<style lang="stylus">
        // 全局样式
        body {
        	overflow: hidden;
        	// --themeColor: #017fff;
        	// --themeHover: #0177f0;
        	color: var(--text-color-black) !important;
            background-color var(--bg-color-primary) !important
            font-family: 'Harmonyos Sans SC', 'Harmonyos Sans', -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
        }
        html.dark {
            .max-theme {
                box-shadow $box-shadow
            }
        }
        * :focus-visible {
            outline none
        }
        // 自定义tippy悬浮提示 dark主题的样式
        .max-theme{
            text-align:left;
            font-size:12px !important;
            transfrom-style:preserve-3d;
            padding: 12px
            max-width:205px !important;
            min-height:24px;
            background-color: var(--border-color-tips);
            border-radius: 6px;
            //(隐藏箭头)
            &[x-placement^='top']::before{
                content:'';
                position:absolute;
                width:0;
                height:0;
            }
            &[x-placement^='top'].tippy-arrow{
                display:none
            }
            &[x-placement^='bottom'].tippy-arrow{
                border:none;
            }
            &[x-placement^='top'] .tippy-arrow{
                border-top-color:var(--border-color-tips);
            }
            &[x-placement^='bottom'] .tippy-arrow{
                border-bottom-color:var(--border-color-tips);
            }
            &[x-placement^=right] .tippy-arrow {
                border-right-color  var(--border-color-tips);
            }
            &[x-placement^=left] .tippy-arrow {
                border-left-color  var(--border-color-tips);
            }
        }
        //替换成实心下拉三角
        // .ivu-select .ivu-icon-ios-arrow-down:before{
        //     content: "\F33D" !important;//替换content
        // }
        .no-pointer {
        	pointer-events: none !important;
        }

        .export-pos-left {
        	.shepherd-arrow {
        		transform: translate(20px, 0) !important;
        	}
        }

        .menu-divide {
            width: 90%;
        	margin: 4px 0;
            margin-left: auto;
            margin-right: auto;
            > hr {
                height: 1px;
                border: 0 none;
                background: var(--bg-color-menu-hr) !important;
            }
        }

        .disabled-menu-item {
        	opacity: 0.3 !important;
            // 需要鼠标hover事件支持二级菜单延时关闭
        	// pointer-events: none;
        	cursor: no-drop !important;
        }

        .expand-menu-item {
        	position: relative;

        	.expanded-menu {
        		background-color: white;
        		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
        		position: absolute;
        		top: -2px;
        	}

        	.menu-text {
        		pointer-events: none;
        	}

        	// &:after {
        	// 	content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAGFBMVEUAAAB1dXV0dHR0dHR1dXV0dHR2dnZ1dXXxfp/EAAAAB3RSTlMA779fMIBw/GLP2QAAABpJREFUCNdjgAAVEFFoACTKy0BEKYyrAlUAAERNA2S3+incAAAAAElFTkSuQmCC');
        	// 	display: block;
        	// }
        }

        .checked-menu-item::before {
        	line-height: 0;
        	content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath stroke='%23424242' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M4 8l2.5 2.5L12 5'/%3E%3C/svg%3E");
        	position: absolute;
        	display: block;
        	left: 3px;
        	top: 7px;
        	width: 16px;
        	height: 16px;
        }

        .menu-item {
            display: flex;
            text-align: left;
            line-height: 28px;
            cursor: default;
            white-space: nowrap;
            height: 28px;
            position: relative;
            padding: 0px 10px;
            text-overflow: ellipsis;
            border-radius: 6px;

            &:hover:not(.disabled-menu-item) {
                background: var(--bg-color-menu-item-4);
        	}
            &.lib-context-menu{
                &:hover{
                    background: var(--bg-color-menu-item-active)
                }
            }
        }

        .menu-limitW {
        	display: block !important;
        	max-width: 300px;
        }

        .activeFunc {
        	background-color: var(--themeActived);
            opacity: 1 !important;

        	.menu-text {
        		color: #fff;
        	}

        	.menu-shortcut {
        		color: #fff;
        	}
        }

        .comImgDialog {
        	width: 330px;
        	padding-bottom: 10px;
        }
        .compressimg-dialog {
            padding-bottom: 0;
            .dialog-slot {
                padding: 16px 16px 24px;
            }
        }

        .vipChoseDialog {
        	width: 400px;
        	text-align: center;
        	padding-bottom: 10px;
        }

        .mindTipsDialog {
            .dialog-title {
                padding: 0 12px !important;
                .title-text {
                    left: 32px;
                }
            }
            .dialog-slot {
                padding: 24px 0 !important;
            }
            .mindtips-content {
                padding: 12px 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                .item-icon {
                    width: 24px;
                    height: 24px;
                }
            }
            .mindtips-footer {
                padding: 12px 32px 0 32px;
                display: flex;
                justify-content: flex-end;
                .btn-secondary {
                    color: white;
                    padding: 6px 16px;
                    background-color: var(--themeColor);
                    border-radius: 6px;
                    cursor: pointer;
                }
                .btn-primary {
                    padding: 6px 16px;
                    margin-left: 16px;
                    background-color: var(--bg-color-dialog-cancel-btn);
                    border-radius: 6px;
                    cursor: pointer;
                }
            }
        }

        .defAction {
        	&:hover {
        		background-color: #e1e1ff;
        	}
        }

        .checkedAction::before {
        	content: '\2713';
        	position: absolute;
        	left: 4px;
        	text-indent: 0;
        }

        #contentDiv {
            sub {
                vertical-align sub
                bottom auto
                line-height normal
                font-size 75%
            }
            sup {
                vertical-align super
                top auto
                line-height normal
                font-size 75%
            }
        }

        // #contentDiv,#textDocRoot{
        // // sup{
        // //         top: auto !important;
        // //         vertical-align:;
        // // }
        // ul{
        // margin: 0;
        // padding: 0;
        // }

        // .disc > li{
        // list-style-type: disc;
        // list-style-position: inside;
        // }

        // .circle > li{
        // list-style-type: circle;
        // list-style-position: inside;
        // }

        // .square > li{
        // list-style-type: square;
        // list-style-position: inside;
        // }

        // ol{
        // margin: 0;
        // list-style: none;
        // counter-reset: list;

        // > li{
        // counter-increment: list;

        // &:before{
        // direction: rtl;
        // content: '.' counter(list, decimal);
        // margin-right: 0.3em;
        // text-align: right;
        // display: inline-block;
        // white-space: nowrap;
        // width: 1.5em;
        // flow:left;
        // }
        // }

        // }

        // .decimal > li:before
        // {content: '.' counter(list, decimal) ;}

        // .decimalSuf > li:before
        // {content: '(' counter(list, decimal);}

        // .decimalPS > li:before
        // {content: '(' counter(list, decimal) ')';}

        // .lowerAlpha > li:before
        // {content: '.' counter(list, lower-alpha);}

        // .lowerAlphaSuf > li:before
        // {content: '(' counter(list, lower-alpha);}

        // .lowerAlphaPS > li:before
        // {content: '(' counter(list, lower-alpha) ')';}

        // .upperAlpha > li:before
        // {content: '.' counter(list, upper-alpha);}

        // .upperAlphaSuf > li:before
        // {content: '(' counter(list, upper-alpha);}

        // .upperAlphaPS > li:before
        // {content: '(' counter(list, upper-alpha) ')';}

        // .lowerRoman > li:before
        // {content: '.' counter(list, lower-roman);}

        // .lowerRomanSuf > li:before
        // {content: '(' counter(list, lower-roman);}

        // .lowerRomanPS > li:before
        // {content: '(' counter(list, lower-roman) ')';}

        // .upperRoman > li:before
        // {content: '.' counter(list, upper-roman);}

        // .upperRomanSuf > li:before
        // {content: '(' counter(list, upper-roman);}

        // .upperRomanPS > li:before
        // {content: '(' counter(list, upper-roman) ')';}

        // }
        .hRuler {
        	pointer-events: none;
        	position: fixed;
        	z-index: 2;
        	top: 105px;
        	right: 40px;
        	border-left: 20px solid var(--border-ruler-block-zero);
        	border-bottom: 1px solid var(--border-ruler-bottom);
        	height: 20px;
        	overflow: hidden;
        	background: transparent;

        	.hcanvas {
        		position: absolute;
        	}
        }

        .vRuler {
        	pointer-events: none;
        	position: fixed;
        	z-index: 2;
        	top: 121px;
        	width: 20px;
        	border-top: 20px solid var(--border-ruler-block-zero);
        	border-right: 1px solid var(--border-ruler-bottom);
        	overflow: hidden;
        	background: transparent;

        	.vcanvas {
        		position: absolute;
        	}
        }

        .disabled {
        	color: #bebebe;
        }
        .disable-gray{
            color var(--text-color-disabled-gray)
        }

        .hovered {
        	&:hover {
        		background-color: #e5e5e5;
        	}
        }

        &::-webkit-scrollbar {
        	height: 8px;
        	width: 6px;
        	background-color: transparent;
        	pointer-events: none;
        }

        &::-webkit-scrollbar-corner {
        	background-color: transparent;
        }

        .scene{
        //   &::-webkit-scrollbar-button:start{
        //     width: 20px;
        //     height: 20px;
        //   }
        //   &::-webkit-scrollbar-thumb:horizontal, &::-webkit-scrollbar-thumb:vertical {
        //     background-color: #d2d3d4;
        //   }
        //   &::-webkit-scrollbar-thumb:horizontal:hover, &::-webkit-scrollbar-thumb:vertical:hover {
        //        background-color: #bebfc0;
        //      }
        //   &::-webkit-scrollbar-thumb:horizontal:active, &::-webkit-scrollbar-thumb:vertical:active {
        //     background-color: #bebfc0;
        //   }
        //   &::-webkit-scrollbar {
        //        height: 14px;
        //        width: 14px;
        //   }
        }

        .scene-no-ruler::-webkit-scrollbar-button:start {
        	display: none;
        }

        //  滑块
        &::-webkit-scrollbar-thumb:horizontal, &::-webkit-scrollbar-thumb:vertical {
        	border-radius: 6px;
            // box-shadow: none;
            background-color: var(--bg-color-scrollbar);
        	pointer-events: none;
        }

        //  滑动槽
        &::-webkit-scrollbar-track:vertical, &::-webkit-scrollbar-track:horizontal {
        	border-radius: 1px;
            box-shadow: none;
            background-color: transparent;
        	pointer-events: none;
        }

        .app {
            user-select none
            font-family: 'Harmonyos Sans SC', -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            &.app-en {
                font-family: 'Harmonyos Sans', -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            }
        }

        .ivu-modal-footer {
        	.ivu-btn-primary {
        		>span {
        			color: white;
        		}
        	}
        }

        .vertical-center-modal {
        	display: flex;
        	align-items: center;
        	justify-content: center;

        	.ivu-modal {
        		top: 0;
        	}
        }

        .rPanel-item {
        	height: 24px;
            margin-bottom: 16px;
        	display: flex;
        	position: relative;
        	align-items: center;
            &.disabled {
                .border-hover:hover {
                    border-color: var(--border-color-right-panel-item-dropbox);
                }
                .item-dropbox {
                    cursor not-allowed
                    opacity 1;
                    color var(--text-color-ivu-input-disabled)
                    background-color var(--bg-color-ivu-input-number-input-disabled)!important
                    .ios-arrow {
                        opacity 0.5
                    }
                }
            }
        	.left {
        		display: inline-block;
        		position: absolute;
        		line-height: 12px;
        		user-select: none;
        		width: calc(100% - 80px);
        	}

        	.border-hover {
        		&:hover {
        			border-color: var(--themeColor);
        			// background-color: initial !important;
        		}
        	}

            .round-arrow {
                position: unset !important;
                top: unset !important;
                right: unset !important;
                transform: unset !important;
                width: 10px !important;
                height: 10px !important;
                margin-left: auto !important;
                margin-right: 3px !important;
            }

        	.item-dropbox {
                display: flex;
                align-items: center;
        		border-radius: 4px;
        		position: absolute;
        		right: 0;
        		width: 80px;
        		height: 24px;
        		top: 0;
        		line-height: 24px;
        		border: 1px solid var(--border-color-right-panel-item-dropbox);
        		background-color: var(--bg-color-right-panel-item-dropbox);
        		text-indent: 5px;
        		user-select: none;

        		// }
        		>span {
        			pointer-events: none;
        			max-width: 50px;
        			white-space: nowrap;
        			overflow: hidden;
        			text-overflow: ellipsis;
        			display: inline-block;
        		}

        		.png-view {
        			background-position: center;
        			background-repeat: no-repeat;
        			background-size: contain;
        		}

        		.item-preview {
        			width: 100%;
        			height: 100%;
        			pointer-events: none;
        			border-style: solid;
        			border-color: transparent;
        			border-width: 3px;
        			background-clip: content-box;
        			position: relative;
        			overflow: hidden;

        			>span {
        				height: 100%;
        				line-height: 18px;
        				display: inline-block;
        				vertical-align: top;
        			}

        			>div {
        				width: 100%;
        				height: 100%;
        				position: absolute;
        			}
        		}

        		>.ios-arrow {
        			width: 8px;
        			height: 8px;
        			position: absolute;
        			pointer-events: none;
        			top: 50%;
        			right: 12px;
        			color: var(--svg-color-primary);
        			transform: translateY(-50%);
        		}

        		> svg {
        			position: absolute;
        			pointer-events: none;
        			top: 50%;
        			transform: translateY(-50%);
        			right: 3px;
        			width: 6px;
        			height: 6px;
        		}

        		.item-downs {
        			z-index: 99;
        			margin-left: -1px;
        			position: absolute;
        			right: 0;
                    top: 24px;
        			max-height: 250px;
        			overflow: auto;
        			width: 76px;
        			background-color: var(--bg-color-right-panel-item-dropbox-item-downs);
        			border: 1px solid var(--border-color-right-panel-item-dropbox-item-downs);
        			box-shadow: $common-box-shadow;
                    border-radius 2px;

        			.item-down {
        				height: 18px;
        				line-height: 18px;
        				white-space: nowrap;

        				&:hover {
        					background-color: var(--bg-color-right-panel-item-dropbox-item-downs-item-hover);
        				}
        			}

        			.chosenItem {
        				background-color: var(--bg-color-right-panel-item-dropbox-item-downs-select-item) !important;
        			}
        		}

        		.dir-downs {
        			box-sizing: content-box;
        			display: flex;
        			flex-wrap: wrap;
        			margin-top: 2px;
        			padding: 5px;
        			border: none !important;
        			border-radius: 3px;

        			.dir-down {
        				box-sizing: content-box;
        				padding: 3px;

        				>div {
        					width: 100%;
        					height: 100%;
        					position: relative;
        					box-sizing: border-box;

        					>div {
        						width: 100%;
        						height: 100%;
        						position: absolute;
        					}
        				}

        				&:hover {
        					background-color: #e5e5e5;
        				}
        			}
        		}
        	}

        	.input-num {
        		position: absolute;
        		border-color: #e0e0e0;
        		right: 0;
        		width: 76px;
        		height: 24px;
        		line-height: 24px;
        		user-select: none;
        	}

        	.ivu-input-number {
        		width: 76px;
        		height: 24px;
        		border-color: #e0e0e0;
        		margin-left: auto;

        		.ivu-input-number-handler {
        			height: 50%;
        		}

        		.ivu-input-number-input-wrap {
        			height: 100%;

        			.ivu-input-number-input {
        				padding: 0 6px;
        				height: 100%;
        				display: block;
        			}
        		}
        	}

        	.ivu-slider {
        		.ivu-slider-bar {
        			height: 6px;
        		}

        		.ivu-slider-wrap {
        			// height: 6px;
        			// background-color: #d0d0d0;
        			// width: 105px;
        			// margin-top: 14px;
        			// position: relative;
        			// margin-left: 90px;
        		}

        		.ivu-slider-button-wrap {
        			// top: -4px;
        			// height: 15px;
        			// line-height: 1;
        		}
        	}
        }

        .ivu-slider {
        	.ivu-slider-bar {
        		height: 6px;
        	}
        	.ivu-slider-wrap {
        		height: 6px;
                background-color: var(--bg-color-ivu-slider-wrap);
        	}

        	.ivu-slider-button-wrap {
        		top: -3px;
        		height: 15px;
        		line-height: 1;
        	}
        }

        .ivu-slider-disabled {
            .ivu-slider-button{
                width: 14px
                height: 14px
            }
            .ivu-slider-wrap {
        		background-color: var(--bg-color-ivu-slider-disabled)!important;
            }
        	.ivu-slider-bar {
        		background-color: var(--bg-color-ivu-slider-bar-disabled)!important;
        	}
            .ivu-slider-button {
                border-color: var(--border-color-ivu-slider-button-disabled) !important;
                background-color: var(--bg-color-ivu-slider-button-disabled) !important;
            }
        }

        // https://devops.300624.cn/console/vteam/j3882c/twBug?vmode=table&id=7f44470f4a924692b735bac3a00371ff
        div:focus-visible {
            outline: none;
        }
</style>
<style lang="stylus">
    html.dark
        .palette .palette-switch
            > div
                &::after, &::before {
                    background transparent!important;
                }
        .ft-has-checked-list-item::before, .checked-menu-item::before, .ft-menu .ft-menucheck.active::before
            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath stroke='%23fff' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round' d='M4 8l2.5 2.5L12 5'/%3E%3C/svg%3E")!important
        .main-context-wrapper
            border: none;
        .ivu-select-arrow
            &:before
                background-image url('./assets/ivu-select-arrow-dark.svg');
        .ivu-input-number .ivu-input-number-handler-wrap
            .ivu-icon-ios-arrow-up
                &:before
                    background-image  url('./assets/caret-up-empty-dark.svg')
            .ivu-icon-ios-arrow-down
                &:before
                    background-image  url('./assets/caret-down-empty-dark.svg')
        #lineheightmodal .line-height-list li.active::before
            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' %3E%3Cpath fill='%23fff' d='M5.94352 10.5293L3.70711 8.29291C3.31658 7.90239 2.68342 7.90239 2.29289 8.29291C1.90237 8.68344 1.90237 9.3166 2.29289 9.70712L5.29289 12.7071C5.70479 13.119 6.38016 13.0931 6.75926 12.6508L12.7593 5.65081C13.1187 5.23148 13.0701 4.60018 12.6508 4.24076C12.2315 3.88134 11.6002 3.9299 11.2407 4.34923L5.94352 10.5293Z'/%3E%3C/svg%3E");
    .line-animate-tip-content
        white-space break-spaces
        .to-vip
            color #ff7100
            cursor pointer
            &:hover
                text-decoration underline
    // iview
    .ivu-select-arrow
        color var(--svg-color-primary) !important;
        width 8px !important;
        height 8px !important;
        font-size 12px !important;
        right 6px !important;
        &:before
            content '' !important;
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            background url('./assets/ivu-select-arrow.svg') no-repeat center / contain
    .ivu-input-number:focus {
        box-shadow: 0 0 0 2px var(--box-shadow-color-ivu-component-focus) !important;
    }
    .ivu-tooltip-light .ivu-tooltip-inner {
        color: var(--text-color-primary) !important;
    }
    .ivu-picker-panel-icon-btn:hover {
        color: var(--color-ivu-picker-panel-icon-btn-hover)!important;
    }
    .ivu-tabs-bar {
        border-bottom-color: var(--border-color-ivu-tab-bar)!important;
    }
    .ivu-dropdown-item-divided {
        border-top-color: var(--border-color-ivu-dropdown-item-divided)!important;
    }
    .ivu-radio-focus, .ivu-checkbox-focus, .ivu-input-number-focused
        box-shadow: 0 0 0 2px var(--box-shadow-color-ivu-component-focus) !important;
    .ivu-tooltip-popper
        &[x-placement^='top'] .ivu-tooltip-arrow
            border-top-color:var(--bg-color-ivu-tooltip)!important;;

        &[x-placement^='bottom'] .ivu-tooltip-arrow
            border-bottom-color:var(--bg-color-ivu-tooltip)!important;;

        &[x-placement^=right] .ivu-tooltip-arrow
            border-right-color  var(--bg-color-ivu-tooltip)!important;;

        &[x-placement^=left] .ivu-tooltip-arrow
            border-left-color  var(--bg-color-ivu-tooltip)!important;;
        .ivu-tooltip-inner
            background-color var(--bg-color-ivu-tooltip)!important;
    .ivu-progress-bg
        background-color var(--bg-color-ivu-progress-bg)!important;
    .ivu-date-picker-header
        border-bottom-color var(--border-color-ivu-time-picker-cells-list)!important
    .ivu-date-picker-cells-cell:hover em
        background var(--border-color-ivu-date-picker-cells-cell-hover)!important;
    .ivu-date-picker-cells-cell-selected em, .ivu-date-picker-cells-cell-selected:hover em
        background var(--themeHover)!important
    .ivu-date-picker-cells-focused em
        box-shadow var(--box-shadow-ivu-date-picker-cells-focused)!important
    .ivu-date-picker-cells-cell-today em:after
        background var(--themeHover)!important;
    .ivu-input:focus
        box-shadow none !important
    .ivu-tabs
        color var(--text-color-ivu-tab) !important
    .ivu-tabs-nav
        .ivu-tabs-tab:hover
            color var(--color-ivu-tabs-tab-hover)!important
        .ivu-tabs-ink-bar
            background var(--bg-color-ivu-tabs-tab-active)!important
        .ivu-tabs-tab-active
            color var(--bg-color-ivu-tabs-tab-active)!important
    .ivu-select-multiple .ivu-select-item-selected:after
        color var(--themeHover)!important
    .ivu-tooltip-light .ivu-tooltip-inner
        // background-color var(--color-black-12)!important
        box-shadow var(--box-shadow-ivu-tool-tip-inner)!important
    .ivu-tooltip-light.ivu-tooltip-popper[x-placement^=right] .ivu-tooltip-arrow:after
        border-right-color  var(--border-color-tips)!important;

    .ivu-switch.ivu-switch-checked
        background-color var(--bg-color-ivu-switch-checked)!important;
        border-color: var(--border-color-ivu-switch-checked)!important;
    .ivu-switch:not(.ivu-switch-checked)
        background-color var(--bg-color-ivu-switch)!important;
        border-color: var(--border-color-ivu-switch)!important;
    .ivu-modal-content
        background-color var(--bg-color-dialog-container)!important;
        box-shadow $modal-shadow;
    .ivu-slider:not(.ivu-slider-disabled)
        .ivu-slider-bar
            background var(--themeColor)

        .ivu-slider-button
            border-color var(--themePressed)
            width: 14px
            height: 14px
            background-color: var(--bg-color-primary)
            &:hover,
            &:focus
                border-color var(--themeColor)
    .ivu-radio-wrapper
        .ivu-radio
            margin-right 8px
            &:hover
                .ivu-radio-inner
                    border-color var(--border-color-ivu-radio-inner-hover)!important;
            .ivu-radio-inner
                border-color var(--border-color-ivu-radio-inner)
                background-color var(--bg-color-ivu-radio-inner)
        .ivu-radio-disabled
            &:hover
                .ivu-checkbox-inner
                    border-color var(--border-color-ivu-checkbox-inner)!important;
            .ivu-radio-inner
                border-color: var(--border-color-ivu-checkbox-inner)!important;
                background-color: var(--bg-color-ivu-checkbox-disabled)!important;
            + span
                opacity 0.4
        .ivu-radio-checked
            &:hover .ivu-radio-inner
                border-color var(--themeColor)
            .ivu-radio-inner
                border-width 4px
                border-color var(--themeColor)
                &:after
                    background-color transparent
                    width 6px
                    height 6px

    .ivu-input-wrapper
        .ivu-input-small
            padding 6px
    .ivu-checkbox
        &:hover
            .ivu-checkbox-inner
                border-color var(--border-color-ivu-checkbox-inner-hover-2)!important;
        &.ivu-checkbox-disabled
            &:hover
                .ivu-checkbox-inner
                    border-color var(--border-color-ivu-checkbox-inner)!important;
    .ivu-checkbox-wrapper
        .ivu-checkbox-inner
           background-color var(--bg-color-primary);
           border-color: var(--border-color-ivu-checkbox-inner);
        .ivu-checkbox-checked,.ivu-checkbox-indeterminate
            .ivu-checkbox-inner
                background-color var(--themeColor)
                border-color var(--themeColor)
    .ivu-checkbox-wrapper
        .ivu-checkbox-disabled
            .ivu-checkbox-inner
                border-color: var(--border-color-ivu-checkbox-inner)!important;
                background-color: var(--bg-color-ivu-checkbox-disabled)!important;
            &.ivu-checkbox-checked
                .ivu-checkbox-inner
                    border-color #E0E0E0
                    background var(--color-black-2)
    .ivu-input-number
        border:1px solid var(--border-color-ivu-input-number)!important;
        background-color var(--bg-color-ivu-input-number) !important;
        &.ivu-input-number-default,&.ivu-input-number-small
            border-radius 4px
        .ivu-input-number-handler-wrap
            margin-right 5px
            width 8px
            border-left 0
            opacity 1
            display flex
            flex-direction column
            justify-content center
            align-items center
            background-color var(--bg-color-primary)
            .ivu-input-number-handler
                border none
                width 8px
                height 8px
                &:hover
                    background var(--hover-color-common-6)
            .ivu-input-number-handler-down-inner, .ivu-input-number-handler-up-inner
                width 8px
                height 8px
                right 0
                top 0
                bottom 0
                left 0
                color var(--svg-color-primary)
                font-size 12px;
                margin auto
            .ivu-icon-ios-arrow-up
                &:before
                    content ''
                    position absolute
                    left 0
                    right 0
                    top 0
                    bottom 0
                    margin auto
                    background url('./assets/caret-up-empty.svg') no-repeat center / contain
            .ivu-icon-ios-arrow-down
                &:before
                    content ''
                    position absolute
                    left 0
                    right 0
                    top 0
                    bottom 0
                    margin auto
                    background url('./assets/caret-down-empty.svg') no-repeat center / contain
        .ivu-input-number-input
            padding 6px
            color: var(--text-color-ivu-input-number-input)
            background-color var(--bg-color-primary)
        &:not(.ivu-input-number-disabled):hover,
        &:not(.ivu-input-number-disabled):focus
            border-color var(--themeColor) !important
        &.ivu-input-number-disabled
            .ivu-input-number-handler-wrap
                display flex
                background-color transparent !important
            .ivu-input-number-input
                opacity 1;
                color var(--text-color-ivu-input-disabled)
                background-color var(--bg-color-ivu-input-number-input-disabled)!important
    .ivu-input-number-focused
        border-color var(--themeColor) !important

    .ivu-input
        border 1px solid var(--border-color-box-6)!important
        border-radius 6px
        background-color var(--bg-color-ivu-input) !important
        &.ivu-input-default,&.ivu-input-small
            border-radius 6px
            color var(--text-color-ivu-dropdown-item);
        &:not(.ivu-input-disabled):hover,
        &:not(.ivu-input-disabled):focus
            border-color var(--themeColor) !important
    .ivu-input-focused
        border-color var(--themeColor) !important
    .ivu-input[disabled], fieldset[disabled] .ivu-input
        background-color var(--bg-color-ivu-input-disabled) !important
        border-color var(--border-color-ivu-input-disabled) !important
    textarea.ivu-input
        font-size 12px !important
    .ivu-dropdown-menu
        .ivu-dropdown-item
            color: var(--text-color-ivu-dropdown-item)
            &:hover
                background-color var(--bg-color-ivu-dropdown-item-hover)
    .ivu-select-dropdown
        box-shadow var(--box-shadow-color-box)!important
        background-color var(--bg-color-ivu-select-dropdown)!important
        .ivu-select-item
            color var(--text-color-primary)
            &:hover
                background-color var(--bg-color-ivu-select-item-hover);
            &.ivu-select-item-selected
                color var(--text-color-active)
    .ivu-select,.ivu-select-small
        &.ivu-select-single
            .ivu-select-selection
                background-color var(--bg-color-tertiary)
                color var(--text-color-primary)
                border 1px solid var(--border-color-box-6)
                border-radius 4px !important
        &:not(.ivu-select-disabled)
            .ivu-select-selection:hover,
            .ivu-select-selection:focus
                border-color var(--themeColor) !important
        &.ivu-select-disabled
            .ivu-select-selection
                color var(--text-color-ivu-input-disabled)!important
                background-color var(--bg-color-ivu-input-number-input-disabled)!important
                .ivu-select-arrow
                    color var(--text-color-ivu-input-disabled)!important
                    opacity 0.5
            .ivu-select-selection:hover,
            .ivu-select-selection:focus
                border-color var(--border-color-ivu-select-disabled-selection);
        .ivu-select-dropdown
            padding 8px
            background-color var(--bg-color-ivu-select-dropdown)
            .ivu-select-dropdown-list
                .ivu-select-item
                    padding 8px 26px 8px 10px
                    border-radius 6px
                    color var(--text-color-primary)
                    line-height 16px;
                    &:hover
                        background var(--bg-color-ivu-select-item-hover)
                .ivu-select-item-selected
                    color var(--text-color-primary)
                    background var(--bg-color-ivu-select-dropdown-select-item)
    .ivu-select-dropdown
        padding 6px !important
        background-color var(--bg-color-ivu-select-dropdown) !important
        border-radius 6px !important
        .ivu-select-dropdown-list
            .ivu-select-item
                padding 8px 26px 8px 10px
                border-radius 6px
                color var(--text-color-primary)
                line-height 16px;
                &:hover
                    background var(--bg-color-ivu-select-item-hover)
            .ivu-select-item-selected
                color var(--text-color-primary)
                background var(--bg-color-ivu-select-dropdown-select-item)
            .ivu-select-item-focus
                background transparent
    .ivu-select-visible
        .ivu-select-selection
            border-color var(--themeColor)!important
    .ivu-select-selection-focused
        border-color var(--themeColor) !important

    .expandLibrary-mask
        position fixed
        top 0
        left 0
        width 100vw
        height 100vh
        z-index 999
    .expandLibrary-box
        position absolute
        padding 10px
        z-index 999
    .menu-container
        outline:none;
        position:fixed;
        z-index:30;
        background-color:var(--bg-color-menu-container);
        box-shadow: var(--box-shadow-color-menu-container);
        border 1px solid var(--border-color-gray2)
        // border-top:none;
        border-radius: 8px;
        padding:0 6px
    .dialog-container
    	position fixed
    	z-index 5
    	background-color white
    	border-radius 6px
    	color $dialog-fontcolor
    	overflow hidden
    	.dialog-title
    			background-color $dialog-title-backcolor
    .dialog-btn
      dialog-btn()
    .dialog-btn-cancel
      dialog-btn-cancel()
    .dialog-btn-ok
      dialog-confirm-btnstyle()
      margin-left: 0
    .dialog-disable
      dialog-disable-btnstyle()
    .dialog-btnbox-normal
    	dialog-btnbox-normal()
    .vip-dialog-btnbox-normal
        div,.dialog-btn-ok
            min-width 94px
    .dialog-btnbox-big
    	dialog-btnbox-big()
    .dialog-btnbox-return
    	dialog-btnbox-return()

    .share-loading
        modal-mask()
        .loading-ring
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            width 50px
            height 50px
            path
                fill var(--themeColor)

    .new-guide
        max-width 500px !important
        width 476px !important
        border-bottom none
        .shepherd-arrow:before
            background-color white !important
        .shepherd-content
            width 476px
            position relative
            border-radius 10px
            .shepherd-header
                height 40px
                background white !important
                border-top-left-radius 10px
                border-top-right-radius 10px
                border-bottom 1px solid #e0e0e0
                padding 0 !important
                text-indent 16px
                >h3
                    display block !important
                    font-size 16px
                    .subTitle
                        font-weight bold
            .shepherd-text
                padding 8px 8px 0 8px !important
                >video
                    display block
            .shepherd-footer
                border-bottom-left-radius 10px
                border-bottom-right-radius 10px
                padding 0 8px
                height 44px
                position relative
                align-items center
                bottom 0
                right 0
                justify-content flex-start
                .progress
                    background white !important
                    pointer-events none
                    position absolute
                    top 51%
                    left 50%
                    transform translate(-50%,-50%)
                    color #b0b0b0
                .shepherd-button-secondary
                    margin-right auto
                    color #3288E6
                    font-size 12px
                    background initial
                    outline none
                    &:not(:disabled):hover
                        background initial !important
                        color #3288E6 !important
                .shepherd-button
                    height 28px
                    line-height 28px
                    padding 0 16px

    .help-tips.orgChartHelpTips
        .shepherd-arrow
            left -12px !important
    .help-tips
        max-width 265px !important
        width 265px !important

        .shepherd-content
            // width 200px
            position relative
            // border-radius 10px
            .shepherd-text
                padding 8px !important
                font-size 14px
                line-height 1.8em
            .shepherd-footer
                border-bottom-left-radius 10px
                border-bottom-right-radius 10px
                padding 0px 8px 8px 0
                .shepherd-button
                    height 28px
                    line-height 28px
                    padding 0 16px
    .tips-dropbox
        padding 6px
        position absolute
        background-color white
        color #000
        box-shadow $common-box-shadow
        border-radius 4px
        font-size 12px
        overflow hidden
        z-index 21
        outline none

    .vertical-center-modal
        display flex
        justify-content center
        align-items center

    .vertical-center-modal .ivu-modal
        top 0

    #nps {
    	position: absolute;
    	right: 0;
    	bottom: 0;
    	margin: auto;
    	z-index: 11;
    }
</style>
<style lang="stylus">
    //tippy
    .tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]
        @media screen and (max-height: 666px)
            transform translateX(-24px)
</style>
<template>
    <div id="app" class="app" :class="{ 'app-en': lang !== 'zh' }">
        <!-- 顶部菜单栏 -->
        <TabPanel ref="tab" />
        <!-- 顶部菜单下拉弹窗 -->
        <DropDown />
        <!-- 右键弹窗 -->
        <MainContext v-if="!isPreviewView && !EDCONFIG.IS_SDK" />
        <!-- 中心工作区 -->
        <div
            ref="hRuler"
            class="hRuler"
            v-show="!isPreviewView"
            :style="{ left: rulerLeft, top: rulerTop, right: sceneRight }"
            style="visibility: hidden"
        >
            <canvas class="hcanvas" id="UIHCanvas" ref="hcanvas"></canvas>
        </div>
        <div
            ref="vRuler"
            class="vRuler"
            v-show="!isPreviewView"
            :style="{ left: rulerLeft, top: rulerTop, bottom: sceneDataSheetBottom }"
            style="visibility: hidden"
        >
            <canvas class="vcanvas" id="UIVCanvas" ref="vcanvas"></canvas>
        </div>
        <MainContent ref="scene" :style="`left: ${sceneLeft};top:${sceneTop};right:${sceneRight};bottom:${sceneDataSheetBottom}`" />
        <!-- 右侧工具栏 -->
        <RightPanel v-if="!isPreviewView" :style="{ top: sceneTop, bottom: sceneBottom }" ref="rightPanel" />
        <!-- 底部工具栏 -->
        <BottomPanel ref="pagebar" />
        <!-- 左侧工具栏 -->
        <LeftPanel :style="{ top: sceneTop, bottom: sceneBottom }" />
        <!-- <Library :style="{ top: sceneTop, bottom: sceneBottom, width: sceneLeft }"></Library> -->
        <!-- 数据属性工具栏 -->
        <DataSheet :style="{ height: dataSheetHeight + 'px', left: rulerLeft, right: sceneRight }" v-if="showDataSheet" ref="dataSheet"></DataSheet>

        <!-- 全屏控件 -->
        <SliderContainer />
        <CryptModal v-if="showCryptModal" />
        <PrintContainer v-if="showPrintContainer" />

        <!-- 弹窗 -->
        <Palette v-if="fillColorWindow" :fixed="true" windowType="fillColor" />
        <Palette v-if="lineColorWindow" :fixed="true" windowType="lineColor" />
        <Palette v-if="fontColorWindow" :fixed="true" windowType="fontColor" />
        <Palette v-if="fontbgColorWindow" :fixed="true" windowType="fontbgColor" />
        <Palette />
        <component v-show="!showSketch" :is="dialogType" v-if="showDialog"></component>
        <!-- <ColorSucker v-if="showColorSucker" /> -->
        <upgrade :isAd="isAd" />
        <BuyFrame v-if="showBuyframe" @closeBuyFrame="closeBuyFrame" />
        <BuyDiscount v-model="showBuyDiscount" />
        <BuyPackage v-model="showBuyPackage" />
        <Dialog
            class="comImgDialog compressimg-dialog"
            v-if="showImageModal"
            :type="'tip'"
            :showFooter="true"
            :mask="true"
            :extra="true"
            @ok="compressImg"
            @close="closeModal"
        >
            <p style="text-align: center; margin-bottom: 16px; font-size: 13px">{{ $t("compressImage") }}</p>
        </Dialog>
        <Dialog class="comImgDialog" v-if="showPasteModal" :type="'tip'" :autoFocus="true" @close="closeModal">
            <p style="text-align: center; margin: 10px 0 15px 0; font-size: 13px">
                {{ $t("noPastePermission") }}
                <span style="font-weight: bold; font-size: 16px">Ctrl + V</span>
                {{ $t("pasteEndTip") }}
            </p>
        </Dialog>
        <Dialog class="vipChoseDialog" v-if="showVipChoseDialog" :mask="true" :type="'tip'" @close="closeModal">
            <div style="margin: 15px 0 15px 0; font-size: 13px; padding: 0 8px">{{ $t("noVipTip") }}</div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" style="width: fit-content; padding: 0 6px" @click="showUpgrade">{{ $t("okVip") }}</div>
                <div class="" @click="showVipNext">{{ $t("noGoAhead") }}</div>
            </div>
        </Dialog>
        <!-- 👇 待整合至 showMessage -->
        <!-- 页面中包含思维导图时，点击 右侧栏-主题 的提示弹窗 -->
        <AIBot v-if="showAIBotDialog" />
        <Dialog
            class="mindTipsDialog"
            v-if="showMindTipsDialog && !EDCONFIG.IS_SDK"
            :icon="'edrawIcon'"
            :type="'tip'"
            :showFooter="false"
            @close="closeMindTips"
        >
            <div class="mindtips-content">
                <iconSymbol class="item-icon" name="big-warn" />
                <p style="margin-left: 8px">{{ $t("mindmapTip") }}</p>
            </div>
            <div class="mindtips-footer">
                <div class="btn-secondary" @click="beautifyMind">{{ $t("beautify") }}</div>
                <div class="btn-primary" @click="ignoreMindTips">{{ $t("noRemind") }}</div>
            </div>
        </Dialog>
        <!-- 👆 待整合至 showMessage -->
        <!-- 智能助手充值提示弹窗 -->
        <component :is="'AIpointModal'" v-if="!aiPointsDialogFlag && showAIPointTipsDialog" @closeAiModal="closeAIPointTips" />
        <component :is="'AIpointFrame'" v-if="aiPointsDialogFlag && showAIPointTipsDialog" @closeAiModal="closeAIPointTips" />
        <!-- 浏览器兼容提示 -->
        <component :is="'CompatibilityTips'" :Remindtype="1" v-if="showRemind" />
        <!-- 页面缩放提示 -->
        <div
            class="expandLibrary-box"
            v-show="showExpandLibrary"
            :style="{ left: `${expandLeft - 10}px`, top: `${expandTop - 10}px` }"
            @mouseleave="leaveExpandBox()"
        >
            <ExpandLibrary ref="expandLibBox" />
        </div>
        <dialogMask />
        <SketchDialog v-if="showSketch"></SketchDialog>
        <ShapeData v-if="showShapeData" />
        <!-- 自定义域弹窗 -->
        <!-- 自定义域弹窗和选择卡片信息弹窗可以同时出现 -->
        <component :is="'CloudFileDialog'" v-if="showCloudFileDialog" />
        <!-- 选择云文档弹窗 可以和超链接弹窗同时出现 -->
        <component :is="'CloudFileNoExistDialog'" v-if="showColudFileNoExistDialog" />
        <component :is="'PublishModal'" v-if="showPublish" />
        <component :is="'PublishSymbolModal'" v-if="showPublishSymbol" />
        <component
            :is="'ImportLibrary'"
            ref="importLib"
            v-if="showImportModal"
            :from="'titleClick'"
            :DBName="dbAndTable[0]"
            :TBName="dbAndTable[1]"
            :TBID="dbAndTable[2]"
            @closeModal="closeImport"
            @updateShowList="updateImport"
        />
        <component :is="'EditLibrary'" v-if="showEditModal" />
        <div
            id="outputDrop"
            class="tips-dropbox"
            v-if="showOutputDialog"
            :style="{
                left: outputDialogPosition.left + 'px',
                top: outputDialogPosition.top + 'px',
            }"
        >
            <DownloadMenu @closeDrop="$bus.$emit('closeOuputMenu')" />
        </div>
        <component :is="'Coupon'" v-if="useCoupon" />
        <component :is="'BindPhone'" v-if="showBindPhone" />
        <!-- msgbox需放至最后，防止覆盖 -->
        <component :is="'MsgBox'" v-if="showMsg" />

        <!-- Loading -->
        <!-- <Loading v-if="showLoading || showShareLoading" :loadType="'rotate'" /> -->
        <Loading v-if="showLoading" :loadType="'rotate'" />

        <!-- 其他 -->
        <iframe id="edPrintIframe" style="position: absolute; display: none; z-index: -1"></iframe>
        <input v-if="tempDisable" style="display: none" id="keyToLocalFile" accept=".eddx" type="file" @change="openFile" />
        <component :is="'FocusExpand'" v-if="isFocusMode" />
        <component :is="'FocusExpandTool'" v-if="isFocusMode" />
        <!-- <Guide v-model="showGuide" v-show="showGuide" /> -->
        <!-- <div style="position: absolute;left:800px;top:800px;width:100px;height:30px;background:#eee;border-radius:5px;z-index:999999;text-align:center;line-height:30px" @click="test(2)">蛤蛤</div> -->
        <!-- Nps -->
        <!-- <iframe
            v-if="showNpsIframe && !showGuide && !isPrivate"
            id="nps"
            frameborder="no"
            border="0"
            marginwidth="0"
            marginheight="0"
            width="400px"
            height="276px"
            :src="`https://wae.wondershare.cc/nps2/?embed=web&lang=${lang == 'jp' ? 'ja' : lang}&email=${email}&source=${JSON.stringify({
                pid: pro_id,
                uid: '' + user_id,
                ut: user_type,
                tid: 'UA-EdrawMax-Web',
                pv: '' + appVersion,
                did: did,
            })}`"
        ></iframe> -->
        <miniprogram />
        <UserTask v-if="!EDCONFIG.IS_SDK" :customOffset="userTaskOffset" />
        <component
            :is="'AIBotEntry'"
            v-if="!isPreviewView && EDCONFIG.AI.ENABLE"
            v-show="showAIBotEntry"
            :screenData="{ right: sceneRight, top: sceneTop }"
        />
        <component :is="'FloatTool'" v-if="isViewLoaded"></component>
        <!-- <component :is="'MoreTemplateDialog'" v-if="showMoreTemplateDialog"></component> -->
        <MoreTemplateDialog v-if="showMoreTemplateDialog" :showLv2Id="templateLv2Id" @close="showMoreTemplateDialog = false" />
        <!--  客服   -->
        <!-- <CustomerService /> -->
        <EDNotice
            v-show="useNotice"
            :show="showNotice"
            :dom="noticeDom"
            :forceDirect="noticeDirect"
            :content="noticeContent"
            :showClose="true"
            @closeTips="closeNotice"
        />
        <NalPromo :from="'app'" v-if="$store.state.publicStore.nalPromoLoaded" />
        <ChartEditor ref="chartEditor" />
        <template v-if="EDCONFIG.AI.ENABLE">
            <AISet :screenData="{ top: sceneTop }" v-show="showAIPanel" />
        </template>
        <Promodal v-if="showPromodal" :type="promodalType" :page="promodalPage" @togglePromodal="togglePromodal" />
        <FuncVipTip
            v-if="showFuncVipTip"
            :vipFuncs="vipFuncs"
            :upgradeTrigger="upgradeTrigger"
            :closeCallback="closeCallback"
            @toggleFuncVipTip="toggleFuncVipTip"
            :mask="true"
        />
        <AdvanceVip v-if="showAdvanceVip" @closeModal="closeAdvanceVip" />
        <DownloadTips v-if="showDownloadPcTips" @closeDownloadTips="closeDownloadTips" />
        <GlobalNotice :from="'canvas'" v-if="!EDCONFIG.IS_SDK" />
        <MobileDownloadTip />
        <FpsViewer />
    </div>
</template>

<script lang="ts">
    declare var _view: any;
    declare var JSZip: any;
    declare var getTextEditor: any;
    declare var AutoSaveTimer: any;
    declare var ForceSaveTimer: any;
    declare var app: any;
    declare var EDDocument: any;
    declare var echarts: any;
    declare var $edAuth: any;
    declare var egSize: any;
    declare var WUES: any;
    import { EDRAWMAX_PRODUCT_VIPLIMIT, EDRAWMAX_USE_SAVE, EDRAWMAX_USE_AUTOVERSION, EDRAWMAX_PRODUCT_ENV, EDRAWMAX_USE_COUPON } from "@/env/";
    import appConfig from "@/public/globalConfig";
    import { Component, Prop, Vue, Watch, Provide } from "vue-property-decorator";
    import CustomerService from "@/app/components/CustomerService.vue";
    import OCRModal from "@/app/components/Modals/AI/OCRModal.vue";
    import Dialog from "./components/Modals/Dialog.vue";
    import SketchDialog from "./components/Common/Sketch/SketchDialog.vue";
    import TabPanel from "./components/TabPanel.vue";
    import DropDown from "./components/DropMenus/MainDrops.vue";
    import MainContent from "./components/MainContent.vue";
    import MainContext from "./components/Common/Context/MainContext.vue";
    import BottomPanel from "./components/BottomPanel.vue";
    import Library from "./components/Common/Library.vue";
    import Palette from "./components/Common/Color/Palette.vue";
    import RightPanel from "./components/RightPanel.vue";
    import LeftPanel from "./components/LeftPanel.vue";
    import DataSheet from "./components/DataSheet.vue";
    import pageReorder from "./components/Modals/PageReorder.vue";
    import delLayerTip from "./components/Modals/DelLayerTip.vue";
    import saveAs from "./components/Modals/SaveAs.vue";
    import OrgChartImport from "./components/Modals/OrgChartImport.vue";
    import OrgChartModal from "./components/Modals/OrgChartModal.vue";
    import BatchReplaceImg from "./components/Modals/orgChart/BatchReplaceImg.vue";
    import InsertWaterMark from "./components/Modals/InsertWaterMark.vue";
    import InsertTheme from "./components/Modals/InsertTheme.vue";
    import InsertContainer from "./components/Modals/InsertContainer.vue";
    import InsertTimeline from "./components/Modals/InsertTimeLine.vue";
    import TimeLineTip from "./components/Modals/TimeLineTip.vue";
    import ReplaceColor from "./components/Modals/ReplaceColor.vue";
    import ImportData from "./components/Modals/ImportData.vue";
    import ModifyBlock from "./components/Modals/ModifyBlock.vue";
    import InsertBlock from "./components/Modals/InsertBlock.vue";
    import ClickEvent from "./components/Modals/ClickEvent.vue";
    import AddLibrary from "./components/Modals/library/AddLibrary.vue";
    import OpenLibrary from "./components/Modals/library/OpenLibrary.vue";
    import AddSymbolFromLocal from "./components/Modals/library/AddSymbolFromLocal.vue";
    import AddSymbolFromWeb from "./components/Modals/library/AddSymbolFromWeb.vue";
    import EditSymbol from "./components/Modals/library/EditSymbol.vue";
    import RenameTable from "./components/Modals/library/RenameTable.vue";
    import GanttColumn from "./components/Modals/Gantt/GanttColumn.vue";
    import GanttColumnAdd from "./components/Modals/Gantt/GanttColumnAdd.vue";
    import ouputPDF from "./components/Modals/ouputPDF.vue";
    import ouputPPTExcelWord from "./components/Modals/ouputPPTExcelWord.vue";
    import ouputHTML from "./components/Modals/ouputHTML.vue";
    import ouputSvg from "./components/Modals/ouputSvg.vue";
    import showName from "./components/Modals/showName.vue";
    import splitTableCell from "./components/Modals/splitTableCell.vue";
    import OrgChartOutput from "./components/Modals/OrgChartOutput.vue";
    import ShareBox from "./components/Modals/ShareBox.vue";
    import Options from "./components/Modals/Options.vue";
    import ExpandLibrary from "./components/Modals/library/ExpandLibrary.vue";
    import ShapeData from "./components/Modals/ShapeData.vue";
    import Loading from "./components/Loading.vue";
    import CreateSmartShape from "./components/Modals/CreateSmartShape.vue";
    import Hotkey from "./components/Modals/Hotkey.vue";
    import GuideModal from "./components/Modals/GuideModal.vue";
    import VersionTip from "./components/Modals/VersionTip.vue";
    import SearchFunc from "./components/Modals/SearchFunc.vue";
    import CryptModal from "./components/Modals/CryptModal.vue";
    import SliderContainer from "./components/SliderContainer.vue";
    import RightMenuOption from "./components/Modals/RightMenuOption.vue";
    import AIDraw from "./components/Modals/plugin/aidraw.vue";
    import DownloadMenu from "./components/DropMenus/expandMenus/DownloadMenus.vue";

    import AIBot from "./components/AIBot.vue";
    // import Guide from "./components/Guide.vue";

    import PrintContainer from "./components/Modals/PrintContainer.vue";
    import dialogMask from "./components/Modals/DialogMask.vue";
    import scheduleCommit from "./utils/scheduleCommit";
    import { addJs } from "@/public/utils/tool";
    import upgrade from "@/public/components/upgrade.vue";
    import BuyFrame from "@/public/components/buyFrame.vue";
    import BuyDiscount from "@/public/components/BuyDiscount.vue";
    import BuyPackage from "@/public/components/BuyPackage.vue";
    import googleSlideApi from "@/app/utils/googleSlideApi.js";
    import cloneDeep from "lodash/cloneDeep";
    import remove from "lodash/remove";
    import last from "lodash/last";
    import { logout, validate } from "@/public/utils/auth";
    import miniprogram from "@/home/parts/miniprogram.vue";
    import UserTask from "@/public/components/usertask/UserTask.vue";
    import EDNotice from "@/app/components/Notice/EDNotice.vue";
    import NalPromo from "@/public/components/NalPromo.vue";
    import GlobalNotice from "@/public/components/GlobalNotice/index.vue";
    import MobileDownloadTip from "@/public/components/MobileDownloadTip.vue";
    import FpsViewer from "@/public/components/FpsViewer.vue";

    import { combineCommitKeys } from "./store/modules/shape";

    import MoreTemplateDialog from "./components/Modals/MoreTemplate.vue";
    import AISet from "@/app/components/Common/RightTabs/singleSet/AISet.vue";
    import ChartEditor from "./components/LeftPanel/chart/ChartEditor.vue";
    import { getQueryString, getSdkSaveData } from "@/public/utils/tool";
    import Cookies from "js-cookie";

    import FuncVipTip from "./components/Modals/FuncVIpTip.vue";

    import "@/app/utils/nps3Online.js";

    const PDFDocument = require("@/app/utils/pdfkit.min.js");

    @Component({
        components: {
            CustomerService,
            OCRModal,
            Dialog,
            SketchDialog,
            /** dialogType start */
            hyperlink: () => import("./components/Modals/Hyperlink.vue"),
            attach: () => import("./components/Modals/AttachModal.vue"),
            LibraryModal: () => import("./components/Modals/library/LibraryModal.vue"),
            imageModel: () => import("./components/Modals/ImageModel.vue"),
            InsertTable: () => import("./components/Modals/InsertTable.vue"),
            InsertEChart: () => import("./components/Modals/InsertEChart.vue"),
            InsertMap: () => import("./components/Modals/InsertMap.vue"),
            Math: () => import("./components/Math/home.vue"),
            InsertQRCode: () => import("./components/Modals/InsertQRCode.vue"),
            note: () => import("./components/Modals/Note.vue"),
            comment: () => import("./components/Modals/Comment.vue"),
            ouputImg: () => import("./components/Modals/ouputImg.vue"),
            EditActionPlan: () => import("./components/Modals/EditActionPlan.vue"),
            ShareBox: () => import("./components/Modals/ShareBox.vue"),
            ActionModal: () => import("./components/Modals/ActionModal.vue"),
            GanttOption: () => import("./components/Modals/Gantt/GanttOption.vue"),
            /** dialogType end */
            AISet,
            EDNotice,
            TabPanel,
            DropDown,
            MainContent,
            MainContext,
            RightPanel,
            LeftPanel,
            BottomPanel,
            Palette,
            Library,
            DataSheet,
            CloudFileDialog: () => import("./components/Modals/Hyperlink/CloudFile.vue"),
            CloudFileNoExistDialog: () => import("./components/Modals/Hyperlink/ColudFileNoExist.vue"),
            pageReorder,
            delLayerTip,
            OrgChartModal,
            OrgChartImport,
            BatchReplaceImg,
            AddLibrary,
            OpenLibrary,
            AddSymbolFromLocal,
            AddSymbolFromWeb,
            RenameTable,
            ouputPDF,
            ouputPPTExcelWord,
            ouputHTML,
            ouputSvg,
            showName,
            splitTableCell,
            OrgChartOutput,
            PrintContainer,
            EditSymbol,
            Loading,
            InsertWaterMark,
            InsertTheme,
            InsertContainer,
            InsertTimeline,
            TimeLineTip,
            ReplaceColor,
            ImportData,
            SearchFunc,
            Options,
            ModifyBlock,
            ExpandLibrary,
            ShapeData,
            InsertBlock,
            MsgBox: () => import("./components/Modals/MsgBox.vue"),
            BindPhone: () => import("./components/Modals/BindPhone.vue"),
            GanttColumn,
            GanttColumnAdd,
            saveAs,
            Hotkey,
            GuideModal,
            CryptModal,
            CreateSmartShape,

            ClickEvent,
            // Guide,
            AIBot,
            VersionTip,
            upgrade,
            BuyFrame,
            BuyDiscount,
            BuyPackage,
            // AiChatModal,
            SliderContainer,
            PublishModal: () => import("./components/Modals/Publish.vue"),
            PublishSymbolModal: () => import("./components/Modals/library/PublishSymbol.vue"),
            RightMenuOption,
            Coupon: () => import("./components/Modals/coupon.vue"),
            AIDraw,
            FocusExpand: () => import("./components/FocusExpand/FocusExpand.vue"),
            FocusExpandTool: () => import("./components/FocusExpand/FocusExpandTool.vue"),
            DownloadMenu,
            ImportLibrary: () => import("@/app/components/Modals/library/ImportLibrary.vue"),
            EditLibrary: () => import("@/app/components/Modals/library/EditLibrary.vue"),
            CompatibilityTips: () => import("@/public/components/compatibilityTips.vue"),
            dialogMask,
            miniprogram,
            UserTask,
            FloatTool: () => import("./components/FloatTool/FloatTool.vue"),
            AIBotEntry: () => import("@/app/components/AIBotEntry.vue"),
            AIpointModal: () => import("@/public/components/AIPointModal/AIpointModal.vue"),
            AIpointFrame: () => import("./components/Modals/plugin/AIpointFrame.vue"),
            NalPromo,
            GlobalNotice,
            MobileDownloadTip,
            FpsViewer,
            ChartEditor,
            MoreTemplateDialog,
            Promodal: () => import("@/public/components/Promodal.vue"),
            FuncVipTip,
            AdvanceVip: () => import("./components/Modals/AdvanceVip.vue"),
            DownloadTips: () => import("./components/Modals/DownloadTips.vue"),
        },
    })
    export default class App extends Vue {
        saveOffline: boolean = false;
        editFileNumFlag = false;
        did: string = "";
        showRemind = false;
        browser: string = "unkown";
        get isViewLoaded() {
            return !this.$store.state.ui.openFileLoading;
        }
        get showNpsIframe() {
            return this.$store.state.nps.showNpsIframe;
        }
        get user_type() {
            return Number((this.$store.state.user.userInfo || false) && Boolean(this.vip));
        }
        get useCoupon() {
            return EDRAWMAX_USE_COUPON;
        }
        get userTaskOffset() {
            let right = 0;
            if (!this.focusModeExpandRight) right = 0;
            else if (this.$store.state.ui.showRightPanel) right = this.$store.state.ui.sceneRight + 10 - 15;
            else right = 51 - 15;

            return { right: right, bottom: 32 };
        }
        // nps的timer
        operationTimer: number = null;

        get showDialogMask() {
            return this.$store.state.dialog.showDialogMask;
        }
        updateNpsStorage(key, value) {
            let localInfo: any = localStorage.getItem("npsData");
            if (localInfo) {
                localInfo = JSON.parse(localInfo);
                localInfo[key] = value;
                localStorage.setItem("npsData", JSON.stringify(localInfo));
            }
        }
        getSeason() {
            let month = new Date().getMonth() + 1;
            if (month <= 3) return 0;
            else if (month <= 6) return 1;
            else if (month <= 9) return 2;
            else if (month <= 12) return 3;
        }
        isNeedNps() {
            /***
             * 触发条件(同时满足)
             * 1.单次使用10分钟及以上
             * 2.距离首次使用72小时及以上
             * 3.使用次数2次及以上
             *
             * 触发频率
             * 1.每季度一次
             * 2.第一位版本号更新，更新版本号同时需重置触发条件2和3
             */
            let localInfo = localStorage.getItem("npsData");
            if (localInfo) {
                localInfo = JSON.parse(localInfo);
                let seasonAlert = localInfo["last_season"] == this.getSeason(), // 当前季度是否弹出过nps
                    use72hour = false,
                    use2count = false;
                let oldVersion = localInfo["last_version"].split(".") || [0, 0, 0];
                let nowVersion = this.appVersion.split(".");
                if (nowVersion[0] > oldVersion[0]) {
                    localInfo["last_version"] = this.appVersion;
                    localInfo["first_use"] = new Date().getTime();
                    localInfo["count"] = 1;
                    localInfo["last_season"] = -1;
                    localStorage.setItem("npsData", JSON.stringify(localInfo));
                    return false;
                }
                this.updateNpsStorage("count", localInfo["count"] + 1);

                if (new Date().getTime() - localInfo["first_use"] >= 24 * 3600 * 1000) {
                    use72hour = true;
                }

                if (localInfo["count"] >= 1) {
                    use2count = true;
                }

                return use72hour && use2count && !seasonAlert;
            } else {
                let npsObj = {
                    last_version: this.appVersion,
                    last_season: -1, // 上次弹出nps的季度，-1为未弹出
                    first_use: new Date().getTime(),
                    count: 1,
                };
                localStorage.setItem("npsData", JSON.stringify(npsObj));
                return false;
            }
        }
        initNpsWork() {
            if (this.isPlugin) return;
            if (window.EDCONFIG.IS_SDK) return;
            if (this.isNeedNps()) {
                this.operationTimer = setTimeout(
                    () => {
                        if (this.showDialogMask) return;
                        this.$store.commit("toShowNpsIframe");
                        this.updateNpsStorage("last_season", this.getSeason());
                    },
                    10 * 60 * 1000
                );
            }
        }
        showNps3() {
            let lang = this.lang;
            switch (this.lang) {
                case "jp":
                    lang = "ja";
                    break;
                case "zh":
                    lang = "zh-cn";
                    break;
            }
            WUES.popup({
                lang,
                theme: "light",
                sp: "bottom_right",
                pos: {
                    bottom: 42,
                    right: 58,
                },
                source: {
                    uid: "" + this.user_id,
                    ut: this.user_type,
                    pid: this.pro_id,
                    pv: "" + this.appVersion,
                    ps: "web",
                    // scene:  "YT_test",
                    scene: "Max_desktop_exit",
                },
            });
        }
        get isAd() {
            return this.$store.state.user.isAd;
        }
        get saveState() {
            return this.$store.state.ui.saveState;
        }
        set saveState(v) {
            this.$store.commit("setStatus", {
                type: "saveState",
                data: v,
            });
        }
        get selectShapesFlag() {
            return this.$store.state.shape.selectShapesFlag;
        }
        set selectShapesFlag(v) {
            this.$store.commit("setShapeStatus", {
                type: "selectShapesFlag",
                data: v,
            });
        }
        get customLang() {
            return this.$changLang(this.lang);
        }
        get pro_id() {
            return this.appPid;
        }
        tempDisable = !appConfig.isBuild;
        workerURL: string = appConfig.workerURL;
        showRatioRemind: boolean = false;
        googleSlide: any = null;
        slideTemp: any;

        @Provide()
        iviewInputBlur = (e) => {
            e.target.blur();
        };
        @Provide()
        showMessage = (data) => {
            let checkAvoidList = () => {
                let store = localStorage;
                let list = JSON.parse(store.getItem("msgAvoidList")) || [];
                if (list.includes(data.avoidTitle)) {
                    return true;
                }
                return false;
            };
            let msg = {
                sponsor: data["sponsor"] || "", // 动作发起者，需要监听ok cancel事件时使用, 监听$bus msgOperation 事件
                uniqueListenr: data["uniqueListenr"] || false, // 动作监听器是否唯一, 除非是v-if控制的模块，否则都需要唯一监听事件，防止off误删
                title: data["title"] || "",
                type: data["type"] || 0, // 弹窗类型
                time: data["time"] || 3, // 弹窗消失时间
                imgType: data["imgType"] || 0, // 弹窗图片 0 提示 1 成功 2 失败
                content: data["content"] || "", // 提示主题内容
                extraCon: data["extraCon"] || "", // 额外提示
                temp: data["temp"], // 暂存部分数据，用于传递通信所需的id等数值
                avoid: data["avoid"] || false, // 开启不再提醒
                avoidTitle: data["avoidTitle"] || "", // 不再提醒索引
                btnType: data["btnType"] || 0, // 0 确定 取消，1 是 否，默认值为 0
                confirmType: data["confirmType"] || "normal", // normal warning
                confirmText: data["confirmText"],
                cancelText: data["cancelText"],
                msgClass: data["msgClass"] || "",
            };
            this.$store.commit("setDialogState", {
                type: "message",
                data: msg,
            });

            if (data.avoid) {
                // 开启不再提醒且处于不再提醒名单时，不显示弹窗
                let flag = checkAvoidList();
                if (flag) {
                    return;
                }
            }
            this.$store.commit("setDialogState", {
                type: "showMsg",
                data: true,
            });
        };
        // 导出时修改同步文件名称，逻辑提取自 TabPanel 组件的 rename 方法
        @Provide()
        fileRename(targetName) {
            let newName = targetName.trim(),
                oldName = window["_view"]._doc._fileName;

            if (window.EDCONFIG.IS_SDK) {
                return new Promise((resolve, reject) => {
                    this.sdkApp
                        .promisePostMessage("PUT_FILE_NAME", newName)
                        .then(() => {
                            resolve();
                        })
                        .catch(() => {
                            reject(oldName);
                        });
                });
            }

            return new Promise((resolve, reject) => {
                if (newName == oldName || newName == "") {
                    return resolve();
                }
                if (newName.match(/[\/\\]/)) {
                    this.$edMessage.warning(this.$t("renameFail"));
                    return reject();
                }
                let ts: any = this;
                let prefix: any = this.$store.state.ui.fileInfo;
                prefix = prefix.split("/");
                prefix.pop();
                prefix = prefix.join("/") + "/";
                prefix = prefix.match(/Personal\/(.*)/) ? prefix.match(/Personal\/(.*)/)[1] : "";
                console.log(prefix);
                let isSameName = false;
                this.$store
                    .dispatch("getFloder", { prefix })
                    .then((res) => {
                        console.log(res);
                        res.data.data.files.forEach((file) => {
                            let name = "";
                            if (this.isPrivate) {
                                name = file.info.name;
                            } else {
                                let list = file.key.split("/");
                                name = list[list.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            }
                            if (name == newName && file.key.match(/.+eddx$/)) {
                                isSameName = true;
                            }
                        });

                        if (!isSameName) {
                            let params = {
                                from: prefix + oldName + ".eddx",
                                id: this.$store.state.user.userInfo.user_id,
                                to: prefix + newName + ".eddx",
                                token: this.$store.state.user.userInfo.token,
                            };
                            if (this.isPrivate) {
                                let path = this.$store.state.ui.fileInfo;
                                path = path.split("/").slice(2).join("/");
                                Object.assign(params, {
                                    file_key: this.$store.getters.fileKey,
                                    from: path,
                                    to: path,
                                    name: newName,
                                });
                            }
                            this.$edApi
                                .moveObj(params)
                                .then((res) => {
                                    this.fileNameSync = newName;
                                    let newUrl = "";
                                    if (this.isPrivate) {
                                        let url = this.$unZipFileName(location.search.substr(1, location.search.length));
                                        url = url.replace(/(name\=).[^\&]*/, `$1${newName}`);
                                        newUrl = window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName(url);
                                    } else {
                                        let newFileInfo = this.$store.state.ui.fileInfo.replace(/(.*\/)*([^.]+).*/gi, "$1") + newName + ".eddx";
                                        this.$store.commit("setStatus", {
                                            type: "fileInfo",
                                            data: newFileInfo,
                                        });
                                        newUrl =
                                            window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName("obj=" + newFileInfo);
                                    }
                                    let stateObj = history.state;
                                    document.title = document.title.replace(/.*-(.*)/, newName + " -$1");
                                    history.replaceState(stateObj, "", newUrl);
                                    if (window.opener) {
                                        window.opener.postMessage(
                                            {
                                                type: "updateFiles",
                                            },
                                            location.origin
                                        );
                                    }
                                    window.localStorage.setItem("reName", "1");
                                    return resolve();
                                })
                                .catch((err) => {
                                    if (err?.data?.to == "The to format is invalid.") {
                                        (<any>this).$edMessage.warning(this.$t("renameFail"));
                                    }
                                    if (err?.data?.msg == "data invalid") {
                                        (<any>this).$edMessage.warning(this.$t("renameFail"));
                                    }
                                    return reject(oldName);
                                });
                        } else {
                            (<any>this).$edMessage.warning(this.$t("sameName"));
                            return reject();
                        }
                    })
                    .catch((err) => {
                        return reject(oldName);
                    });
            });
        }
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        set fileNameSync(v) {
            window["_view"]._doc._fileName = v;
            this.$store.commit("setStatus", {
                type: "fileNameSync",
                data: v,
            });
        }

        // test(){
        //     window['_view'].translateShapeString().then(e=> {
        //         console.log(e)
        //     })
        // }
        get fillColorWindow() {
            return this.$store.state.ui.fillColorWindow;
        }
        get lineColorWindow() {
            return this.$store.state.ui.lineColorWindow;
        }
        get fontColorWindow() {
            return this.$store.state.ui.fontColorWindow;
        }
        get fontbgColorWindow() {
            return this.$store.state.ui.fontbgColorWindow;
        }
        get showPublish() {
            return this.$store.state.ui.showPublish;
        }
        get showPublishSymbol() {
            return this.$store.state.ui.showPublishSymbol;
        }
        get showDialog() {
            return this.$store.state.dialog.showDialog;
        }
        get showImportModal() {
            return this.$store.state.library.showImportModal;
        }
        set showImportModal(v) {
            this.$store.commit("setLibraryState", {
                type: "showImportModal",
                data: v,
            });
        }

        get showEditModal() {
            return this.$store.state.library.showEditModal;
        }

        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get collectTBID() {
            return this.$store.state.library.collectTBID;
        }
        get showCryptModal() {
            return this.$store.state.ui.showCryptModal;
        }
        get ignorePwd() {
            return this.$store.state.ui.ignorePwd;
        }
        get savedPwd() {
            return this.$store.state.ui.savedPwd;
        }
        get shareUUID() {
            return this.$store.state.ui.shareUUID;
        }
        @Watch("showDialog")
        watchDialog(v) {
            if (v) {
                // 设置弹窗时撤销栈长度
                window["_view"].setDialogUndoStackLength();
            } else {
                window["_view"].setDialogUndoStackLength(0);
            }
        }
        closeImport() {
            this.showImportModal = false;
            this.$store.commit("setDialogState", {
                type: "showDialogMask",
                data: false,
            });
        }
        updateImport(data) {
            let { dbName, tableID } = data;
            this.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });
            this.$store.commit("setLibraryDisplayList", {
                // 清空预览缓存
                groupName: dbName,
                tableName: this.dbAndTable[1],
                data: [],
            });
        }
        showUpgrade() {
            this.closeModal();
            this.$checkAuth({ type: "watermark" });
        }
        showVipNext() {
            this.closeModal();
            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };
            if (this.vipNextAction === "IMG") {
                this.showOutImgDialog();
            } else if (this.vipNextAction === "PDF") {
                let view = window["_view"];
                if (view) {
                    import("@/app/utils/pdfDep.js").then((blobStream) => {
                        if (this.isInclowdz) {
                            view.savePdf(PDFDocument, true, blobStream.default, saveToInclowdz);
                        } else {
                            view.savePdf(PDFDocument, true, blobStream.default);
                        }
                    });
                }
            }
        }
        leaveExpandBox() {
            // 离开弹窗时关闭
            let svg = document.getElementById("opesvg");
            svg.onclick = null;
            this.$store.commit("setDialogState", {
                type: "showExpandLibrary",
                data: false,
            });
            window["_view"]._libMenuInfo = null;
        }
        showOutImgDialog() {
            this.closeModal();
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ouputImg",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            let view = window["_view"];
            if (view) {
                let data = view.exportImageInf();
                data &&
                    this.$store.commit("setStatus", {
                        type: "exportImageInfo",
                        data: data,
                    });
            }
        }
        get showVipChoseDialog() {
            return this.$store.state.ui.showVipChoseDialog;
        }
        set showVipChoseDialog(v) {
            this.$store.commit("setStatus", {
                type: "showVipChoseDialog",
                data: v,
            });
        }
        get vipNextAction() {
            return this.$store.state.ui.vipNextAction;
        }
        set vipNextAction(v) {
            this.$store.commit("setStatus", {
                type: "vipNextAction",
                data: v,
            });
        }

        get showOutputDialog() {
            return this.$store.state.dialog.showOutputDialog;
        }
        get outputDialogPosition() {
            return this.$store.state.dialog.outputDialogPosition;
        }
        // 不兼容提示
        closeRemind() {
            this.showRemind = false;
        }

        // 缩放提示
        showRatioRemindFun() {
            const now = Date.now();
            const lastResizeTime = JSON.parse(localStorage.getItem("lastResizeTime"));
            if (!lastResizeTime || now - lastResizeTime > 60000) {
                // 1分钟内重复操作 不提示
                localStorage.setItem("lastResizeTime", JSON.stringify(now));
                this.showRatoToast();
            }
        }
        showRatoToast() {
            this.sensors.track("refreshToastAction", {
                Catalogues: "openFileProcess",
                action_value: "popup",
            });
            this.$edMessage.showInfoWithExtra({
                content: this.$t("scaleRemindText"),
                okText: this.$t("refreshNow"),
                cancelText: this.$t("closeRemind"),
                duration: 10,
                onOk: () => {
                    this.sensors.track("refreshToastAction", {
                        Catalogues: "openFileProcess",
                        action_value: "refreshNow",
                    });
                    setTimeout(() => {
                        if (window.EDCONFIG.IS_SDK) {
                            this.$bus.$emit("sdkRefreshFile");
                            return;
                        }
                        window.location.reload();
                    }, 120);
                },
                onCancel: () => {
                    this.sensors.track("refreshToastAction", {
                        Catalogues: "openFileProcess",
                        action_value: "close",
                    });
                    this.$edMessage.destroy();
                },
                onCountDown: () => {
                    this.sensors.track("refreshToastAction", {
                        Catalogues: "openFileProcess",
                        action_value: "dismiss",
                    });
                    this.$edMessage.destroy();
                },
            });
        }
        closeRatioRemindFun() {
            this.showRatioRemind = false;
        }
        confirmRemind() {
            this.showRatioRemind = false;
        }
        cancelRemind() {
            this.showRatioRemind = false;
            window.localStorage.setItem("remindRatio", "1");
        }
        checkScale() {
            if (this.showRemind == true || (!this.isPC && !["Safari", "Chrome"].includes(this.browser))) {
                return;
            }
            const _this = this;
            let agent = navigator.userAgent.toLowerCase();
            let isMac =
                /macintosh|mac os x/i.test(navigator.userAgent) &&
                ((window.matchMedia &&
                    (window.matchMedia(
                        "only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)"
                    ).matches ||
                        window.matchMedia(
                            "only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)"
                        ).matches)) ||
                    (window.devicePixelRatio && window.devicePixelRatio >= 2));
            let baseRatio = 1;
            if (isMac) baseRatio = 2;
            if (window.devicePixelRatio != baseRatio) {
                // 浏览器由缩放倍数
                if (window.localStorage.getItem("remindRatio") == "1") {
                    return;
                } else {
                    this.showRatioRemindFun();
                }
                this.showRatioRemindFun();
                // this.$bus.$emit("reciprocal");
            } else {
                this.closeRatioRemindFun();
            }
        }
        get imgdatas() {
            return this.$store.state.page.themesImageMap;
        }
        getCustomerKey() {
            let uid = this.$store.state.user.userInfo.user_id;
            let email = this.$store.state.user.userInfo.email || "";
            let devices_id = 0;
            let from_app = 0;

            let req = new XMLHttpRequest();

            req.onload = function (e) {
                let customerKey = req.response.data.result;
                req;
            };
            req.open("GET", `https://viewer.edrawsoft.com/public/api/user/${uid}16819/encrypt`);
            req.responseType = "json";
            req.send();
        }
        getCartEnv() {
            let currency = "USD";
            let language = "English";
            switch (this.lang) {
            }
        }
        // @Watch('imgdatas')
        // OnImgdatasChange(val){
        //     console.log(val);
        //     // debugger;
        // }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get user_id() {
            return this.$store.state.user.userInfo.user_id;
        }
        get email() {
            return this.$store.state.user.userInfo.email || "";
        }
        @Watch("userInfo")
        OnUserInfoChange(val) {
            if (window.EDCONFIG.IS_SDK) {
                if (val.isVip) {
                    this.$store.commit("toPublicStatus", { type: "vip", data: 1 });
                }
                localStorage.removeItem("localShapeCount50Limit");
                return;
            }
            if (val.user_id && val.token && !val.oldInfo && EDRAWMAX_PRODUCT_VIPLIMIT) {
                let ts: any = this;
                ts.$edApi
                    .getSubscription({ id: val.user_id, token: val.token })
                    .then((expObj) => {
                        const vipType = ["normal", "vip", "lifetimeVip", "vip expire"];
                        if (expObj) {
                            this.$store.commit("toPublicStatus", {
                                type: "fuser",
                                data: expObj.fuser ? 1 : 0,
                            });
                            let { now, online_exp: onlineExp } = expObj,
                                curStamp = new Date(now).getTime(),
                                expStamp = new Date(onlineExp).getTime();
                            if (expStamp > curStamp) {
                                ts.$store.commit("toPublicStatus", { type: "vip", data: 1 });
                                ts.sensors.registerPage({
                                    userPayingType: "vip",
                                    is_vip: true,
                                    vip_type: expObj.fuser ? vipType[2] : vipType[1],
                                });
                                if (!app.hasOwnProperty("$v_")) {
                                    Object.defineProperty(app, "$v_", { value: 1 });
                                }
                                if (this.$store.state.ui.isFileLimitTip) {
                                    // 去除仅预览文件数量限制，并清除url参数
                                    this.$store.commit("setStatus", {
                                        type: "isPreviewView",
                                        data: false,
                                    });
                                    this.$store.commit("setStatus", {
                                        type: "isFileLimitTip",
                                        data: false,
                                    });
                                    ts.$cleanUrlParams("preview");
                                    ts.$cleanUrlParams("fileLimitTip");
                                    ts.$nextTick(() => {
                                        window["_view"].onsize();
                                    });
                                }
                            } else {
                                ts.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                                ts.getPurchaseBubble();
                                if (!app.hasOwnProperty("$v_")) {
                                    Object.defineProperty(app, "$v_", { value: 0 });
                                }
                                ts.sensors.registerPage({
                                    userPayingType: "vip expire",
                                    is_vip: false,
                                    vip_type: vipType[3],
                                });
                            }
                        } else {
                            ts.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                            ts.getPurchaseBubble();
                            if (!app.hasOwnProperty("$v_")) {
                                Object.defineProperty(app, "$v_", { value: 0 });
                            }
                            ts.sensors.registerPage({
                                userPayingType: "no vip",
                                is_vip: false,
                                vip_type: vipType[0],
                            });
                        }
                        // 购买后关闭升级窗口
                        if (this.vip) {
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: false,
                            });
                        }
                        this.$store.commit("setStatus", {
                            type: "getVipDone",
                            data: true,
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        console.log(err.response);
                        ts.$store.commit("toPublicStatus", { type: "vip", data: 0 });
                        if (!app.hasOwnProperty("$v_")) {
                            Object.defineProperty(app, "$v_", { value: 0 });
                        }
                    });
            }
        }
        openFile(item) {
            if (!item.target.files.length) {
                return;
            }
            //this.$store.state.ui.showLibrary = true; // 打开library
            // this.$store.commit('setStatus',{
            //     type: 'showLibrary',
            //     data: true
            // });
            let oFReader = new FileReader();
            var zip;
            var oFile = item.target.files[0];
            document.title = oFile.name + " - MaxOnline";
            window["_view"].setDocName(oFile.name.match(/[^\/]*(?=\.eddx)/)[0]);
            oFReader.readAsArrayBuffer(oFile);
            oFReader.onload = function (oFREvent: any) {
                zip = oFREvent.target.result;
                window["_view"].openFromFile(zip);
            };
        }
        get showAIPanel() {
            return this.$store.state.ui.showAIPanel;
        }
        get currentView() {
            return this.$store.state.ui.currentView;
        }
        get showSketch() {
            return this.$store.state.dialog.showSketch;
        }
        get showMsg() {
            return this.$store.state.dialog.showMsg;
        }

        get showShapeData() {
            return this.$store.state.dialog.showShapeData;
        }

        get showCloudFileDialog() {
            return this.$store.state.dialog.showCloudFileDialog;
        }

        get showColudFileNoExistDialog() {
            return this.$store.state.dialog.showColudFileNoExistDialog;
        }

        get showBindPhone() {
            return this.$store.state.bindPhoneDialog.showBingPhoneDialog;
        }

        compressImg() {
            let view = window["_view"];
            if (view) view.compressImage();
            this.closeModal();
        }
        closeModal() {
            this.showRatioRemind = false;
            this.showPasteModal = false;
            this.showVipChoseDialog = false;
            if (this.showImageModal) {
                this.$store.commit("setStatus", {
                    type: "waitCompressImgIds",
                    data: [],
                });
                this.showImageModal = false;
            }
            this.$store.commit("setDialogState", {
                type: "showDialogMask",
                data: false,
            });
        }
        get showMindTipsDialog() {
            return this.$store.state.ui.showMindTipsDialog;
        }
        set showMindTipsDialog(v) {
            this.$store.commit("setStatus", {
                type: "showMindTipsDialog",
                data: v,
            });
        }
        closeMindTips() {
            this.showMindTipsDialog = false;
        }
        beautifyMind() {
            this.closeMindTips();
            let view = window["_view"];
            let item = view._activePage.topMMShapes()[0]; // 页面中的思维导图代表对象
            if (item) {
                view.selectObject(item);
                view.invalidate();
                this.$store.commit("setStatus", {
                    type: "showFloatExpand",
                    data: "mindMore",
                });
            }
        }
        ignoreMindTips() {
            this.closeMindTips();
            localStorage.setItem("ignoreMindTips", "true");
        }
        get showAIPointTipsDialog() {
            return this.$store.state.ui.showAIPointTipsDialog;
        }
        get aiPointsDialogFlag() {
            return this.$store.state.staticConfig.aiPointsDialogFlag;
        }
        set showAIPointTipsDialog(v) {
            this.$store.commit("setStatus", {
                type: "showAIPointTipsDialog",
                data: v,
            });
        }
        closeAIPointTips() {
            this.showAIPointTipsDialog = false;
        }
        get showAIBotDialog() {
            return this.$store.state.ui.showAIBotDialog;
        }
        get showAIBotEntry() {
            return this.$store.state.ui.showAIBotEntry;
        }
        get showImageModal() {
            return this.$store.state.ui.showCompressModal;
        }
        set showImageModal(v) {
            this.$store.state.ui.showCompressModal = v;
        }
        get showPasteModal() {
            return this.$store.state.ui.showPasteModal;
        }
        set showPasteModal(v) {
            this.$store.state.ui.showPasteModal = v;
        }

        get showLibrary() {
            return this.$store.state.ui.showLibrary;
        }
        set showLibrary(v) {
            this.$store.commit("setStatus", {
                type: "showLibrary",
                data: v,
            });
        }
        get showExpandLibrary() {
            return this.$store.state.dialog.showExpandLibrary;
        }

        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }
        get focusExpand() {
            return this.$store.state.ui.focusExpand;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        get focusModeExpandBottom() {
            return this.$store.getters.expandBottom;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }

        get expandLeft() {
            return this.$store.state.dialog.expandLeft;
        }
        get expandTop() {
            return this.$store.state.dialog.expandTop;
        }
        get dialogType() {
            return this.$store.state.dialog.dialogType;
        }
        get showLoading() {
            return this.$store.state.ui.Loading;
        }
        get showShareLoading() {
            return this.$store.state.ui.ShareLoading;
        }
        // 整合进度条加载动画和旋转加载动画后，兼容处理原来的分享加载文本为默认文本
        @Watch("showShareLoading")
        watchShareLoading(val) {
            // if (val) {
            //     this.$store.commit("setStatus", {
            //         type: "loadingTextType",
            //         data: "library",
            //     });
            // }
        }
        get rulerTop() {
            if (this.isFocusMode) {
                if (this.focusExpand.includes(0)) {
                    return this.$store.state.ui.sceneTop + (this.$store.state.ui.optionShow ? 44 : 0) + "px";
                }
                return 0 + "px";
            }
            return this.$store.state.ui.sceneTop + (this.$store.state.ui.optionShow ? 44 : 0) + "px";
        }
        get rulerLeft() {
            if (this.isFocusMode) {
                if (this.focusExpand.includes(3)) {
                    return this.$store.state.ui.sceneLeft + "px";
                }
                return 0 + "px";
            }
            if (this.showLibrary) {
                return this.$store.state.ui.sceneLeft + "px";
            }
            return 0 + "px";
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop + "px";
        }
        get sceneRight() {
            if (!this.focusModeExpandRight) return 0;
            if (this.$store.state.ui.showRightPanel || this.showAIPanel) return this.$store.state.ui.sceneRight + "px";
            else return "50px";
        }
        get sceneDataSheetBottom() {
            if (this.showDataSheet) {
                return this.dataSheetHeight + "px";
            }
            if (!this.focusModeExpandBottom) return 0;
            return 32 + "px";
        }
        get sceneBottom() {
            if (!this.focusModeExpandBottom) return 0;
            return 32 + "px";
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft + "px";
        }
        get hLeftMargin() {
            if (this.isFocusMode) {
                if (this.focusExpand.includes(3)) {
                    return this.$store.state.ui.sceneLeft + "px";
                }
                return 0 + "px";
            }
            if (this.showLibrary) {
                return this.$store.state.ui.sceneLeft + "px";
            }
            return 0 + "px";
        }
        get vLeftMargin() {
            if (this.isFocusMode) {
                if (this.focusExpand.includes(3)) {
                    return this.$store.state.ui.sceneLeft + "px";
                }
                return 0 + "px";
            }
            if (this.showLibrary) {
                return this.$store.state.ui.sceneLeft + "px";
            }
            return 0 + "px";
        }
        get showDataSheet(): boolean {
            return this.$store.state.ui.showDataSheet;
        }
        get dataSheetHeight() {
            return this.$store.state.ui.dataSheetHeight;
        }
        get showPrintContainer() {
            return this.$store.state.ui.showPrintContainer;
        }
        @Watch("showPrintContainer")
        showPrintContainerChange(value) {
            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("SET_MAX_PRINT_SHOW", value);
            }
        }
        get isSpecial() {
            return this.$store.getters.isSpecial;
        }
        get isLocalFile() {
            return this.$store.state.ui.isLocalFile;
        }
        get isGroupView() {
            return this.$store.state.ui.isGroupView;
        }
        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }
        get screenStyle() {
            if (this.isPreviewView) {
                return "";
            } else {
                let obj = {
                    left: this.sceneLeft,
                    top: this.sceneTop,
                    right: this.sceneRight,
                    bottom: this.sceneDataSheetBottom,
                };
                return `left: ${obj.left};top:${obj.top};right:${obj.right};bottom:${obj.bottom}`;
            }
        }
        updatePosition(dom, type, data) {
            dom.style[type] = `${data}px`;
        }

        updatePositionAnimation(list, duration = 400) {
            let start;
            let easeOutExpo = (t, b, c, d) => {
                return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
            };
            let step = (timestamp) => {
                !start && (start = timestamp);
                const stepp = Math.min((timestamp - start) / duration, 1);
                for (let item of list) {
                    let { dom, type, startData, endData } = item;
                    if (dom) {
                        const changeData = easeOutExpo(stepp, startData, endData - startData, 1);
                        // const changeData = startData + stepp * (endData - startData);
                        this.updatePosition(dom, type, changeData);
                    }
                }
                if (stepp != 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }
        getExpandLibraryFlag = false;
        getExpandLibraryDataByID(groupId, ignoreSet = false) {
            this.$store.commit("setDialogState", {
                type: "expandLibraryData",
                data: [],
            });
            if (!groupId) return;
            if (this.getExpandLibraryFlag && !ignoreSet) return;
            this.getExpandLibraryFlag = true;
            let typeArr = []; // 0 groupName, 1 tableName 2 limit count
            let libraryData = [];
            return new Promise((rs, rj) => {
                new Promise((res, rej) => {
                    let opendb = window.indexedDB.open("versionDB");
                    opendb.onsuccess = () => {
                        let db = opendb.result;
                        const tableNames = db.objectStoreNames;
                        if (!tableNames.contains("version")) {
                            db.close();
                            rej();
                            return;
                        }
                        let trans = db.transaction("version", "readonly");
                        let store = trans.objectStore("version");

                        let index = store.index("tableIDIndex");
                        index.get(groupId).onsuccess = (e) => {
                            let data = (e.target as IDBRequest).result;
                            if (data && data.type) {
                                // 有数据且有type
                                typeArr.push([data.group, data.name, data.mcount]); // 本身数据放置第一位
                                res(data.type);
                            } else {
                                rej();
                            }
                            db.close();
                        };
                    };
                })
                    .then((e) => {
                        // 取消请求typeDB配置的表
                        // let type = e as string;
                        // return new Promise((res, rej) => {
                        //     if(type == 'SELF'){
                        //         res()
                        //     }else{
                        //         let opendb = window.indexedDB.open('typeDB');
                        //         opendb.onsuccess = () => {
                        //             let db = opendb.result;
                        //             let trans = db.transaction('type', 'readonly');
                        //             let store = trans.objectStore('type');

                        //             let request = store.get(type);
                        //             request.onsuccess = () => {
                        //                 let obj = request.result['typeArr'];
                        //                 for(let i = 0; i < obj.length; ++i){ // 去除本身数据
                        //                     if(obj[i][1] == typeArr[0][1]){
                        //                         obj.splice(i, 1)
                        //                     }
                        //                 }
                        //                 typeArr = typeArr.concat(obj)
                        //                 res()
                        //                 db.close()
                        //             }
                        //         }
                        //     }
                        // })
                        //  }).then(() => {
                        // let arr = [];
                        // for(let i = 0; i < typeArr.length; i++){
                        //     arr.push(new Promise((res, rej) => {
                        //         let opendb = window.indexedDB.open(typeArr[i][0]);
                        //         opendb.onsuccess = () => {
                        //             let db = opendb.result;
                        //             let trans = db.transaction(typeArr[i][1], 'readonly');
                        //             let store = trans.objectStore(typeArr[i][1]);

                        //             let cursorData = [];
                        //             let request = store.openCursor();
                        //             request.onsuccess=(e)=>{
                        //                 let cursor = (e.target as IDBRequest).result;
                        //                 if(cursor){
                        //                     cursorData.push(cursor.value);
                        //                     cursor.continue();
                        //                 }else{
                        //                     let result = cursorData;
                        //                     if(result.length > 0){
                        //                         if (typeArr[i][2]) {
                        //                             result.splice(typeArr[i][2], result.length)
                        //                         }
                        //                         libraryData = libraryData.concat(result);
                        //                     }
                        //                     res()
                        //                     db.close()
                        //                 }
                        //             };
                        //         }
                        //     }))
                        // }
                        // Promise.all(arr).then(() => {
                        //     this.$store.commit('setDialogState', {
                        //         type: 'expandLibraryData',
                        //         data: libraryData
                        //     })
                        // })
                        let updateList = (arr) => {
                            // 链式添加防止顺序错误
                            let doAction = (v) => {
                                return new Promise((res, rej) => {
                                    let opendb = window.indexedDB.open(v[0]);
                                    opendb.onsuccess = () => {
                                        let db = opendb.result;
                                        let trans = db.transaction(v[1], "readonly");
                                        let store = trans.objectStore(v[1]);

                                        let cursorData = [];
                                        let request = store.openCursor();
                                        request.onsuccess = (e) => {
                                            let cursor = (e.target as IDBRequest).result;
                                            if (cursor) {
                                                cursorData.push(cursor.value);
                                                cursor.continue();
                                            } else {
                                                let result = cursorData;
                                                if (result.length > 0) {
                                                    if (v[2]) {
                                                        result.splice(v[2], result.length);
                                                    }
                                                    libraryData = libraryData.concat(result);
                                                }
                                                res();
                                                db.close();
                                            }
                                        };
                                    };
                                });
                            };
                            let sequence: any = Promise.resolve();
                            typeArr.forEach(function (item) {
                                if (item)
                                    sequence = sequence.then((e) => {
                                        return doAction(item);
                                    });
                            });
                            sequence.then((e) => {
                                rs(libraryData);
                                if (!ignoreSet) {
                                    this.$store.commit("setDialogState", {
                                        type: "expandLibraryData",
                                        data: libraryData,
                                    });
                                    this.getExpandLibraryFlag = false;
                                }
                            });
                        };
                        updateList(typeArr);
                    })
                    .catch((e) => {
                        rj(e);
                    });
            }).catch((e) => {
                console.log(e);
                this.getExpandLibraryFlag = false;
            });
        }
        get expandLibraryData() {
            return this.$store.state.dialog.expandLibraryData;
        }

        outputGoogleSlide(type) {
            let ts: any = this;
            let msg = ts.$t("saveToGoogleSlideSuccess");
            let msg2 = ts.$t("saveToGoogleSlideFail");
            let success = () => {
                ts.$edMessage.success(msg);
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: false,
                });
                this.slideTemp = null;
            };
            let fail = () => {
                this.googleSlide.checkLogin();
                ts.$edMessage.error(msg2);
                this.$store.commit("setStatus", {
                    type: "ShareLoading",
                    data: false,
                });
            };
            let retry = () => {
                if (this.slideTemp) {
                    this.googleSlide.sendSlide(this.slideTemp);
                }
            };
            if (this.googleSlide == null) this.googleSlide = new googleSlideApi(success, fail, retry);
            this.$store.commit("setStatus", {
                type: "ShareLoading",
                data: true,
            });
            let uploadImg = (blobList) => {
                return new Promise((RS, RJ) => {
                    let promiseList = [];
                    this.$edApi.getSlideUploadSign(this.$store.getters.apiParam).then((response) => {
                        let ossData = response;
                        if (!this.internal) {
                            ossData["host"] = ossData.action;
                        }
                        let page_imgList = [];
                        for (let i = 0; i < blobList.length; ++i) {
                            let imgform = new FormData();
                            page_imgList.push({
                                id: i,
                                imgSrc: `${ossData.host}/${ossData.path + ossData.uri}page-${i + 1}.png`,
                            });
                            if (!this.internal) {
                                imgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
                                imgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
                                imgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
                                imgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
                                imgform.append("acl", ossData["acl"]);
                                imgform.append("Policy", ossData["Policy"]);
                                imgform.append("key", ossData.path + ossData.uri + `page-${i + 1}.png`);
                                imgform.append("file", blobList[i]);
                            } else {
                                imgform.append("OSSAccessKeyId", ossData.id);
                                imgform.append("policy", ossData.policy);
                                imgform.append("Signature", ossData.sign);
                                imgform.append("key", ossData.path + ossData.uri + `page-${i + 1}.png`);
                                imgform.append("file", blobList[i]);
                            }
                            promiseList.push(
                                new Promise((rs, rj) => {
                                    let param = { url: ossData.host, data: imgform };
                                    this.$edApi
                                        .uploadSlideFile(param)
                                        .then((res) => {
                                            rs();
                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        });
                                })
                            );
                        }
                        Promise.all(promiseList).then((e) => {
                            RS(page_imgList);
                        });
                    });
                });
            };
            let getPageImg = () => {
                return new Promise((RS, RJ) => {
                    let promiseList = [];
                    let blobList = [];
                    let pages = window["_view"]._doc._pages;

                    for (let i = 0; i < pages.length; ++i) {
                        let tmpPage = window["_view"]._doc.pageByIndex(i);
                        let imgform = new FormData();
                        promiseList.push(
                            new Promise((rs, rj) => {
                                pages[i].toBitmap(
                                    (blob) => {
                                        blobList.push(blob);
                                        rs();
                                    },
                                    new egSize(2000, (2000 / tmpPage.width) * tmpPage.height),
                                    ".png"
                                );
                            })
                        );
                    }
                    Promise.all(promiseList).then((e) => {
                        RS(blobList);
                    });
                });
            };
            let getSlideImg = () => {
                return new Promise((RS, RJ) => {
                    let promiseList = [];
                    let blobList = [];
                    let slideList = window["_view"]._doc._slideSheet._slides;
                    for (let i = 0; i < slideList.length; i++) {
                        let tmpPage = slideList[i]._area;
                        let canvas = document.createElement("canvas");
                        let ctx = canvas.getContext("2d");
                        let conHeight = (2000 / tmpPage.width) * tmpPage.height;
                        let conWidth = 2000;
                        if (conWidth / conHeight > 1) {
                            canvas.width = conWidth;
                            canvas.height = (conHeight * conWidth) / 2000;
                        } else {
                            canvas.height = conHeight;
                            canvas.width = (conWidth * conHeight) / 2000;
                        }
                        slideList[i].draw(ctx, 2000, true);
                        promiseList.push(
                            new Promise((rs, rj) => {
                                canvas.toBlob((blob) => {
                                    blobList.push(blob);
                                    rs();
                                });
                            })
                        );
                    }
                    Promise.all(promiseList).then((e) => {
                        RS(blobList);
                    });
                });
            };
            let readyCreateData = (obj) => {
                let CREATEDATA: any = {
                    title: "",
                    request: [],
                };
                let emu4MW = {
                    magnitude: 9139669,
                    unit: "EMU",
                };
                let emu4MH = {
                    magnitude: 5136789,
                    unit: "EMU",
                };
                let request: any = [
                    {
                        deleteObject: {
                            objectId: "",
                        },
                    },
                ];
                for (let i = 0; i < obj.page_data.length; i++) {
                    let t = obj.page_data[i];
                    let createSlide = {
                        createSlide: {
                            objectId: "page" + t.id,
                            insertionIndex: i,
                        },
                    };
                    request.push(createSlide);
                    let createImg = {
                        createImage: {
                            objectId: "page-" + t.id + "-img",
                            url: t.imgSrc,
                            elementProperties: {
                                pageObjectId: "page" + t.id,
                                size: {
                                    height: emu4MH,
                                    width: emu4MW,
                                },
                                transform: {
                                    scaleX: 1,
                                    scaleY: 1,
                                    translateX: 0,
                                    translateY: 0,
                                    unit: "EMU",
                                },
                            },
                        },
                    };
                    request.push(createImg);
                }
                CREATEDATA["title"] = obj.file_title;
                CREATEDATA["request"] = request;
                return CREATEDATA;
            };
            if (type == 1) {
                getPageImg().then((e) => {
                    uploadImg(e).then((data) => {
                        let obj = {
                            file_title: window["_view"]._doc._fileName,
                            page_data: data,
                        };
                        this.slideTemp = readyCreateData(obj);
                        if (this.googleSlide.checkLogin()) {
                            this.googleSlide.sendSlide(this.slideTemp);
                        }
                    });
                });
            } else {
                getSlideImg().then((e) => {
                    uploadImg(e).then((data) => {
                        let obj = {
                            file_title: window["_view"]._doc._fileName,
                            page_data: data,
                        };
                        this.slideTemp = readyCreateData(obj);
                        if (this.googleSlide.checkLogin()) {
                            this.googleSlide.sendSlide(this.slideTemp);
                        }
                    });
                });
            }
        }
        getThemeColor() {
            if (window.EDCONFIG.IS_SDK) return;
            let storage = localStorage;
            let theme = storage.getItem("themeColor");
            let index = theme || 0;
            let colorList = [this.isDarkTheme() ? "#7755FF" : "#017fff", "#3a4275", "#4f5359"];
            let hoverList = [this.isDarkTheme() ? "#8F6CFF" : "#0177f0", "#252a4c", "#2a2d31"];
            document.body.style.setProperty("--themeColor", colorList[index]);
            document.body.style.setProperty("--themeHover", hoverList[index]);
        }
        isBrowser() {
            // if(window.localStorage.getItem('remindCompatible') == '1'){
            //     return
            // }
            let userAgent = window.navigator.userAgent; //取得浏览器的userAgent字符串
            if (userAgent.indexOf("IE") != -1) {
                //字符串含有IE字段，表明是IE浏览器
                this.browser = "IE";
            } else if (userAgent.indexOf("Firefox") != -1) {
                //字符串含有Firefox字段，表明是火狐浏览器
                this.browser = "Firefox";
            } else if (userAgent.indexOf("OPR") != -1) {
                //Opera
                this.browser = "Opera";
            } else if (
                userAgent.indexOf("Chrome") != -1 &&
                userAgent.indexOf("360SE") == -1 &&
                userAgent.indexOf("Metasr") == -1 &&
                userAgent.indexOf("QQBrower") == -1
            ) {
                //Chrome
                this.browser = "Chrome";
            } else if (userAgent.indexOf("Safari") != -1) {
                //Safari
                this.browser = "Safari";
            } else if (userAgent.indexOf("Trident") != -1) {
                //IE内核
                this.browser = "IE 11";
            }
            if (!this.isPC && !["Safari", "Chrome"].includes(this.browser) && window.location.hash.indexOf("#editShare") > -1) {
                this.showRemind = true;
            }
        }
        get versionParams() {
            if (this.isPrivate) {
                return this.$store.state.ui.fileInfo && this.userInfo && this.userInfo.token && this.$store.state.ui.fileKey;
            } else {
                return this.$store.state.ui.fileInfo && this.userInfo && this.userInfo.token;
            }
        }
        get otherTypeFile() {
            // 群组文件和分享可编辑文件
            return this.$store.state.ui.isTeamFile || this.$store.state.ui.isShareEditFile;
        }
        @Watch("versionParams")
        watchVersionParams(newVal) {
            if (!newVal || this.otherTypeFile) return;
            this.$store.dispatch("getVersionList", { obj: this.$store.state.ui.fileInfo }).then((res) => {});
        }
        get revisionsLists() {
            return this.$store.state.version.revisionsList;
        }

        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }
        get showBuyDiscount() {
            return this.$store.state.publicStore.showBuyDiscount;
        }
        set showBuyDiscount(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyDiscount",
                data: val,
            });
        }
        get showBuyPackage() {
            return this.$store.state.publicStore.showBuyPackage;
        }
        set showBuyPackage(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyPackage",
                data: val,
            });
        }

        checkCloudSpaceLimit() {
            if (this.isFullCouldSpace) {
                this.showCloudSpaceLimit();
                return true;
            }
            return false;
        }

        showCloudSpaceLimit() {
            if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else if (this.vip && this.showUpgradeVal != "cloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            }
        }
        showGuide = false;

        useCloseExpandLibEvent = false;
        closeExpandLibEventTimer = 0;
        watchClosseExpandLib(e) {
            if (!this.useCloseExpandLibEvent) return;
            this.useCloseExpandLibEvent = false;
            this.$store.commit("setDialogState", {
                type: "showExpandLibrary",
                data: false,
            });
        }
        get showBuyframe() {
            return this.$store.state.publicStore.showBuyframe;
        }
        set showBuyframe(val) {
            this.$store.commit("toPublicStatus", {
                type: "showBuyframe",
                data: val,
            });
        }
        closeBuyFrame() {
            this.showBuyframe = false;
            //关闭弹窗时更新vip状态
            this.updateVipStatus();
        }
        updateVipStatus() {
            if (window.EDCONFIG.IS_SDK) return;
            if (this.isPlugin || this.isTeamsApp || this.isInclowdz || this.isPrivate) return;
            const ts = this as any;
            const vipTrigger = this.$store.state.publicStore.upgradeTrigger;
            const libraryName = this.$store.state.publicStore.libraryName;
            const libraryNames = this.$store.state.library.trackedLibraryIds.map((item) => item.tableName);
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "",
            });
            this.$store.commit("toPublicStatus", {
                type: "libraryName",
                data: "",
            });
            // 重新获取vip信息
            this.$store
                .dispatch("updateVipStatus", {
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    if (ts.$store.state.ui.isFileLimitTip) {
                        // 去除仅预览文件数量限制，并清除url参数
                        ts.$store.commit("setStatus", {
                            type: "isPreviewView",
                            data: false,
                        });
                        ts.$store.commit("setStatus", {
                            type: "isFileLimitTip",
                            data: false,
                        });
                        ts.$cleanUrlParams("preview");
                        ts.$cleanUrlParams("fileLimitTip");
                        ts.$nextTick(() => {
                            window["_view"].onsize();
                        });
                    }
                    if (!this.internal && vipTrigger) {
                        const event = {
                            Catalogues: "payPath",
                            upgrade_trigger: vipTrigger,
                        };
                        // if (libraryName) {
                        //     Object.assign(event, {
                        //         library_name: libraryName,
                        //     });
                        // }
                        const trialVipList = [
                            "exportImageWithVipBenefit",
                            "exportPdfWithVipBenefit",
                            "exportWordWithVipBenefit",
                            "exportExcelWithVipBenefit",
                            "exportPptWithVipBenefit",
                            "exportSvgWithVipBenefit",
                            "exportHtmlWithVipBenefit",
                            "exportEddxWithVipBenefit",
                            "downloadFileWithVipBenefit",
                            "publishFileWithVipBenefit",
                            "shareFileWithVipBenefit",
                            "printFileWithVipBenefit",
                            "removeGrid",
                            "removeVipTemplateMark",
                            "removeVipLibraryMark",
                            "formulaEditor",
                        ];
                        if (trialVipList.includes(vipTrigger)) {
                            const trackKey = (key) => {
                                this.sensors.track("upgradePlanSuccess", {
                                    Catalogues: "payPath",
                                    upgrade_trigger: vipTrigger,
                                    trial_vip_benefit: key,
                                });
                            };
                            if (this.vipTemplateMark || this.cummunityVipTemplateMark) {
                                trackKey(this.cummunityVipTemplateMark ? "cummunityVipTemplate" : "vipTemplate");
                            }
                            if (this.vipSymbolMark) {
                                trackKey("library");
                            }
                            if (this.vipShapeNum) {
                                trackKey("symbolsExceedLimit");
                            }
                            if (this.vipPageTheme) {
                                trackKey("theme");
                            }
                            if (this.vipPageColor) {
                                trackKey("themeColor");
                            }
                            if (this.vipPageConnect) {
                                trackKey("connector");
                            }
                            if (this.vipPageAutoBeautify) {
                                trackKey("oneClickBeautify");
                            }
                            if (this.vipPageBackground) {
                                trackKey("setBackgroundPop");
                            }
                            if (this.vipDoctWatermark) {
                                trackKey("customMark");
                            }
                            if (this.vipDocPageNum) {
                                trackKey("pageIcon");
                            }
                            if (this.vipMath || vipTrigger == "formulaEditor") {
                                trackKey("formulaEditor");
                            }
                            if (this.vipPPTFont) {
                                trackKey("text");
                            }
                            for (let i = 0; i < libraryNames.length; i++) {
                                this.sensors.track("upgradePlanSuccess", {
                                    Catalogues: "payPath",
                                    library_name: libraryNames[i],
                                    trial_vip_benefit: "library",
                                    upgrade_trigger: vipTrigger,
                                });
                            }
                        } else {
                            this.sensors.track("upgradePlanSuccess", event);
                        }
                    }
                });
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        checkLog() {
            if (window.EDCONFIG.IS_SDK) return;
            if (this.isPlugin || this.isTeamsApp) return;
            if (this.$store.state.ui.openFileLoading) return;
            if (this.isInclowdz) return;
            if (this.isPrivate) {
                // 私有化无需建议用户登录
                return;
            }
            if (this.noLoginEditor) {
                // 无需强制登录
                return;
            }
            let success = (userInfo: any) => {
                userInfo.oldInfo = true;
                this.$store.commit("setState", { type: "userInfo", data: userInfo });
                this.$store.dispatch("getUserInfo");
                this.updateVipStatus();
            };
            let fail = () => {
                // $edAuth.show();
            };
            $edAuth
                .checkLocalCookie(true, { pid: this.appPid, refreshMode: 1 })
                .then((userInfo: any) => {
                    success(userInfo);
                })
                .catch(() => {
                    $edAuth.auth(success, fail, { pid: this.appPid, refreshMode: 1 });
                });
        }

        sidePanelAnimation(sideType: "left" | "right", start, end) {
            let scene = this.$refs.scene as Vue;
            let sheet = this.$refs.dataSheet as Vue;
            if (scene) {
                let dom = scene && (scene.$el as HTMLElement),
                    hruler = this.$refs.hRuler as HTMLElement,
                    vRuler = this.$refs.vRuler as HTMLElement,
                    dataSheet = sheet && (sheet.$el as HTMLElement);

                let animationArr = [
                    {
                        dom: hruler,
                        type: sideType,
                        startData: start,
                        endData: end,
                    },
                    sideType === "left"
                        ? {
                              dom: vRuler,
                              type: sideType,
                              startData: start,
                              endData: end,
                          }
                        : null,
                    {
                        dom: dom,
                        type: sideType,
                        startData: start,
                        endData: end,
                    },
                    {
                        dom: dataSheet,
                        type: sideType,
                        startData: start,
                        endData: end,
                    },
                ].filter(Boolean);

                this.updatePositionAnimation(animationArr);
            }
        }
        mounted() {
            this.$bus.$on("showAIPanel", (data) => {
                window["_view"]._tool.endEdit();
                if (data && this.currentView) {
                    console.log(this.$refs.rightPanel);
                    (this.$refs.rightPanel as any).closeRightMenu();
                }
                // 暂时不改变画布宽度了
                this.$store.commit("setStatus", {
                    type: "showAIPanel",
                    data,
                });
                this.$store.commit("setStatus", {
                    type: "showAIBotEntry",
                    data: !data,
                });
            });
            this.$bus.$on("sidePanelAnimation", this.sidePanelAnimation);
            this.$bus.$on("showMoreTemplates", () => {
                this.templateLv2Id = 0;
                this.showMoreTemplateDialog = true;
            });
            this.$bus.$on("showMoreTemplatesLv2", (id) => {
                this.templateLv2Id = id;
                this.showMoreTemplateDialog = true;
            });
            this.$bus.$on("showNps3", () => {
                if (this.userInfo && this.userInfo.user_id) {
                    this.showNps3();
                } else {
                    const loginCallback = () => {
                        this.showNps3();
                        this.$bus.$off("logcinSucc", loginCallback);
                    };
                    this.$bus.$on("logcinSucc", loginCallback);
                }
            });
            let svg = document.getElementById("opesvg");
            svg.addEventListener("mousedown", this.watchClosseExpandLib);
            if (this.isPlugin) {
                window.parent.postMessage(
                    {
                        // 页面加载完成
                        eventName: "edrawmaxEvent",
                        action: "loaded",
                    },
                    "*"
                );
            }
            this.sensors.quick("isReady", () => {
                this.did = this.sensors.quick("getAnonymousID");
            });
            window.addEventListener("message", (event) => {
                // nps弹窗点击执行逻辑
                if (/https:\/\/wae\.wondershare\.cc/g.test(String(event.origin))) {
                    if (event.data.action === "WS_APP_GOTO_SUPPORT") {
                        let url: string = "https://www.edrawmax.cn/feedback/web/help/";
                        if (!this.internal) {
                            url = "https://www.edrawmax.com/feedback/web/help/";
                        }
                        window.open(url);
                    } else if (event.data.action === "WS_APP_CLOSE_WINDOW") {
                        //关闭弹窗
                        this.$store.commit("toHideNpsIframe");
                    } else if (event.data.action === "WS_APP_SUBMIT") {
                        // 提交反馈
                    }
                }
            });
            let ts = this as any;

            location.search && this.initNpsWork();
            this.getThemeColor();
            this.isBrowser();
            window.addEventListener("resize", this.checkScale);
            document.oncontextmenu = (e) => {
                if (
                    window["_view"] &&
                    !(
                        (getTextEditor() &&
                            getTextEditor().isEditing() &&
                            (getTextEditor().getDiv()[0].contains(e.target) || getTextEditor().getDiv()[1].contains(e.target))) ||
                        (this.showDialog &&
                            this.$store.state.dialog.dialogType == "note" &&
                            document.getElementById("edNoteEditDiv").contains(<Node>e.target))
                    )
                ) {
                    return false;
                }
            };
            this.$store.commit("changeUILang", appConfig.language);
            // this.$bus.$on("starterGuide", () => {
            //     if (appConfig.language !== "zh" || ts.isPreviewView) return;
            //     this.$nextTick(() => {
            //         this.showGuide = true;
            //     });
            // });
            this.$bus.$on("showCloudSpaceVipTips", () => {
                this.$edModal.show({
                    title: this.$t("remind"),
                    content: this.$t("cloudVipSpaceTips"),
                    confirmText: this.$t("okText"),
                    useDark: this.isPCDarkMode,
                    isPC: this.isPC,
                });
            });
            this.$bus.$on("showEChartEditor", (chart, type, shapeId, chartName = "", position?) => {
                (this.$refs.chartEditor as any).doEditor(chart, type, shapeId, chartName, true, position);
            });
            this.$bus.$on("aiCreateEchart", (option, type, undo = true) => {
                (this.$refs.chartEditor as any).aiCreateEchart({ option }, type, undo);
            });

            if (!this.isPC && !window.EDCONFIG.IS_SDK && $edAuth.on) {
                $edAuth.on("edrawAuthClose", this.edrawAuthClose);
            }
            $edAuth.on && $edAuth.on("edrawAuthSignup", this.trackSignUp);
        }

        // fix BUG: p122_6478，关闭登录弹框时页面跳转到Home页面
        edrawAuthClose() {
            // AINative和SEO场景不跳转，保留在画布页面
            const query = window.location.search.substr(1);
            const urlData = this.$unZipFileName(query);
            const type = getQueryString(urlData, "type");
            if (["pre_edit", "create_echart", "seo_link"].includes(type)) {
                return;
            }

            location.href = location.origin + appConfig.sourcePath;
        }

        trackSignUp(userInfo) {
            if (userInfo.register == 1) {
                this.$store.commit("setState", { type: "userInfo", data: userInfo });
                this.$store.dispatch("getUserInfo").then((e) => {
                    let userInfo = e.data;
                    if (userInfo.seo_source) {
                        this.sensors.registerPage({
                            seo_source: userInfo.seo_source,
                        });
                    }
                    if (userInfo.selfutm_term) {
                        this.sensors.registerPage({
                            selfutm_term: userInfo.selfutm_term,
                        });
                    }
                    this.sensors.track("signUpSuccess", {
                        Catalogues: "Login",
                        seo_source: this.$store.state.user.seo_source,
                    });
                });
            }
        }

        getToken(name) {
            var cArr = document.cookie.split(";");
            var tok;
            var cName = name + "=";
            if (document.cookie) {
                cArr.forEach(function (t) {
                    var m = t.trim();
                    if (m.indexOf(cName) === 0) {
                        tok = m.slice(cName.length);
                    }
                });
            }
            return tok || undefined;
        }
        closeLoading() {
            // 移除loading
            let loadingDom = document.getElementById("loadingMask");
            if (loadingDom) {
                loadingDom.style.opacity = "0";
                setTimeout(() => {
                    loadingDom.parentNode.removeChild(loadingDom);
                }, 400);
            }
        }
        toggleLoading(type) {
            // 加载map loading
            if (type) {
                this.$store.commit("setStatus", {
                    type: "loadingTextType",
                    data: "map",
                });
            }
            this.$store.commit("setStatus", {
                type: "Loading",
                data: type,
            });
        }
        setProcess(num) {
            this.$store.commit("setStatus", {
                type: "LoadingProcess",
                data: num > 1 ? 1 : num < 0 ? 0 : num,
            });
        }
        setPublicStatus(data) {
            this.$store.commit("toPublicStatus", data);
        }
        setDocPwd(pass) {
            this.$store.commit("setStatus", {
                type: "isEncrypt",
                data: !!pass,
            });
            window["_view"].setDocPassword(pass);
        }
        // notice
        useNotice = false;
        showNotice = false;
        noticeDom = null;
        noticeDirect = "";
        noticeContent = "";
        closeNotice() {
            this.$store.state.ui.helpTipsFlag = false;
            this.showNotice = false;
        }

        showMoreTemplateDialog = false;
        templateLv2Id = 0;

        showPromodal = false;
        promodalPage = 1;
        promodalType = 0;
        togglePromodal(data = false) {
            if (data) {
                this.sensors.track("popNewUpgradePlanTip", {
                    upgrade_trigger: this.$store.state.publicStore.upgradeTrigger,
                });
            }
            if (window.EDCONFIG.IS_SDK && data) {
                this.$openBuyPage();
                return;
            }
            this.showPromodal = data;
        }

        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble;
        }

        showFuncVipTip = false;
        vipFuncs = [];
        closeCallback = null;
        upgradeTrigger = "";
        toggleFuncVipTip({ visible = false, vipFuncs = [], closeCallback = null, upgradeTrigger = "" }) {
            if (window.EDCONFIG.IS_SDK) {
                this.$openBuyPage(upgradeTrigger);
                return;
            }
            this.showFuncVipTip = visible;
            this.vipFuncs = vipFuncs;
            this.closeCallback = closeCallback;
            this.upgradeTrigger = upgradeTrigger;
            if (visible) {
                const funcObj = {
                    funcGrid: "removeGrid",
                    funcTemplate: this.cummunityVipTemplateMark ? "cummunityVipTemplate" : "vipTemplate",
                    funcSymbol: "library",
                    funcShapeNum: "symbolsExceedLimit",
                    funcPageTheme: "theme",
                    funcPageColor: "themeColor",
                    funcPageConnect: "connector",
                    funcAutoBeautify: "oneClickBeautify",
                    funcPageBackground: "setBackgroundPop",
                    funcDocWatermark: "customMark",
                    funcDocNum: "pageIcon",
                    funcShapeMath: "formulaEditor",
                    funcShapePPT: "text",
                };
                vipFuncs.forEach((item) => {
                    this.sensors.track("popVipRemindWindow", {
                        Catalogues: "payPath",
                        upgrade_trigger: upgradeTrigger,
                        is_unlimited_ai: !!this.purchaseBubble,
                        trial_vip_benefit: funcObj[item],
                    });
                });
            }
        }

        excelData: Array<any> = [];

        /**
         * 保存文件出错后，处理报错和数据采集
         * @param err 接口返回的错误信息（可能会经过前端处理）
         * @param from 数据采集时saveType字段的值
         * @param needTrack 是否要神策和百度采集信息
         */
        saveFileCatchHandler(err, from = "", needTrack = true) {
            const sensorsObj = {
                Catalogues: "saveFileProcess",
                savesource: "manualSave",
                diagram_type: this.$store.state.user.diagram_type,
                file_source: this.$store.state.user.file_source,
                template_type: this.$store.state.user.template_type,
                result: "failure",
                fail_reason: "others",
                import_file_type: "none",
                diagram_type_from_empty_file: this.$store.state.user.diagram_type,
            };
            if (!this.$store.state.user.fromNull) {
                delete sensorsObj.diagram_type_from_empty_file;
            }

            const bdTrackObj = {
                enable: false,
                category: "",
                action: "save failed",
                opt_label: "",
            };

            let messageType = "warning";
            let messageText = this.$t("saveFail");
            const errStr = err && err.msg ? "fileNumLimit" : err;
            switch (errStr) {
                case "notCloudFile":
                    messageText = this.$t("notCloudFile");
                    break;
                case "fileNumLimit":
                    messageText = this.$t("fileLim");
                    sensorsObj.fail_reason = "exceedsCloudFileNumber";
                    break;
                case "storageLimit":
                    messageText = this.$t("spaceLim");
                    sensorsObj.fail_reason = "cloudSpaceLimit";
                    this.showCloudSpaceLimit();
                    break;
                case "fileReadOnly":
                    messageText = this.$t("saveFileReadOnly");
                    break;
                case "saving":
                    messageText = this.$t("saving");
                    break;
                case "etag not match":
                case "notLocked":
                    messageText = this.$t("editShareConflict");
                    break;
                case "notAllowed":
                    messageText = this.$t("editShareNotAllowed");
                    break;
                case "not found":
                    messageText = this.$t("editShareNotFound");
                    break;
                case "pageErrorFail":
                    messageType = "error";
                    sensorsObj.fail_reason = "systemError1";
                    bdTrackObj.enable = true;
                    bdTrackObj.category = "saveTrack";
                    bdTrackObj.opt_label = `saveType: ${from}; result: savefailed; type: upload failed`;
                    break;
                case "getSignFail":
                    messageType = "error";
                    sensorsObj.fail_reason = "systemError2";
                    bdTrackObj.enable = true;
                    bdTrackObj.category = "saveTrack";
                    bdTrackObj.opt_label = `saveType: ${from}; result: savefailed; type: getSignFail`;
                    break;
                case "uploadFail":
                    messageType = "error";
                    sensorsObj.fail_reason = "systemError3";
                    bdTrackObj.enable = true;
                    bdTrackObj.category = "saveTrack";
                    bdTrackObj.opt_label = `saveType: ${from}; result: savefailed; type: get Wrong signature`;
                    break;
                default:
                    messageType = "error";
                    bdTrackObj.enable = true;
                    bdTrackObj.category = "save";
                    bdTrackObj.opt_label = `saveType: ${from}`;
            }

            this.saveState = -1;

            if (messageType === "warning") {
                this.$edMessage.warning(messageText);
            } else {
                this.$edMessage.error(messageText);
            }

            if (needTrack) {
                this.sensors.track("saveFileNum", sensorsObj);
                if (bdTrackObj.enable) {
                    this.$track(bdTrackObj.category, bdTrackObj.action, bdTrackObj.opt_label);
                }
            }
        }

        get vipSymbolMark() {
            return this.$store.state.vipState.vipSymbolMark;
        }
        get vipTemplateMark() {
            return this.$store.state.vipState.vipTemplateMark;
        }
        get vipShapeNum() {
            return this.$store.state.vipState.vipShapeNum;
        }
        get cummunityVipTemplateMark() {
            return this.$store.state.vipState.cummunityVipTemplateMark;
        }
        get vipPageTheme() {
            return this.$store.state.vipState.vipPageTheme;
        }
        get vipPageColor() {
            return this.$store.state.vipState.vipPageColor;
        }
        get vipPageConnect() {
            return this.$store.state.vipState.vipPageConnect;
        }
        get vipPageAutoBeautify() {
            return this.$store.state.vipState.vipPageAutoBeautify;
        }
        get vipPageBackground() {
            return this.$store.state.vipState.vipPageBackground;
        }
        get vipDoctWatermark() {
            return this.$store.state.vipState.vipDoctWatermark;
        }
        get vipDocPageNum() {
            return this.$store.state.vipState.vipDocPageNum;
        }
        get vipMath() {
            return this.$store.state.vipState.vipMath;
        }
        get vipPPTFont() {
            return this.$store.state.vipState.vipPPTFont;
        }
        get vipStateFuncList() {
            return this.$store.getters.vipStateFuncList;
        }
        get isUsedVipState() {
            return this.$store.getters.isUsedVipState;
        }
        showAdvanceVip = false;
        isShowAdvanceVip = false; // 是否展示过限制弹窗
        @Provide()
        checkVipLimit(type) {
            let list = [];
            list = this.vipStateFuncList.slice();
            let _type = type;
            if (_type !== "removeGrid") {
                _type = type === "share" ? "shareFileWithVipBenefit" : `${_type}WithVipBenefit`;
            }
            let obj = {
                visible: true,
                vipFuncs: list,
                upgradeTrigger: _type,
            };
            if (this.userInfo.user_id && this.userInfo.user_id % 2) {
                Object.assign(obj, {
                    closeCallback: () => {
                        this.showAdvanceVip = true;
                        this.isShowAdvanceVip = true;
                        this.setFileEditLimit(1);
                        this.sensors.track("popNoEditNextTip", {
                            Catalogues: "payPath",
                        });
                    },
                });
            }
            let show = list.length > 0;
            if (show) {
                if (this.internal || this.lang == "zh") {
                    this.$bus.$emit("toggleFuncVipTip", obj);
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: _type,
                    });
                    this.setTrigger(_type);
                    this.promodalType = 0;
                    this.promodalPage = 1;
                    this.togglePromodal(true);
                }
            }
            return show;
        }

        setTrigger(type) {
            let str = "";
            if (/export/.test(type)) {
                str = "export";
            } else if (/print/.test(type)) {
                str = "print";
            } else if (/share/.test(type)) {
                str = "share";
            } else if (/publish/.test(type)) {
                str = "publish";
            } else if (/download/.test(type)) {
                str = "download";
            }
            this.$store.commit("setStatus", {
                type: "triggerType",
                data: str,
            });
        }

        fileStatus = 0;
        setFileEditLimit(member_edit) {
            this.$edApi
                .setFileEdit({
                    obj_id: this.$store.state.ui.fileID,
                    member_edit,
                    token: this.userInfo.token,
                })
                .then((res) => {
                    if (res.data.status == "success") {
                        this.fileStatus = member_edit;
                    }
                });
        }
        checkFileLimit() {
            let status = 0;
            if (this.userInfo.user_id % 2 && this.isUsedVipState && this.isShowAdvanceVip) {
                status = 1;
            }
            if (status != this.fileStatus) {
                this.setFileEditLimit(status);
            }
        }
        closeAdvanceVip() {
            this.showAdvanceVip = false;
        }

        getPurchaseBubble() {
            this.$edApi
                .getPurchaseBubble({
                    config_key: "max_purchase_bubble",
                    v: this.appVersion,
                })
                .then((res) => {
                    if (res.data.status == "success" && !!res.data.data.first) {
                        this.$store.commit("changePurchaseBubble", res.data.data.first);
                    } else {
                        this.$store.commit("changePurchaseBubble", "");
                    }
                });
        }
        get vipViewReady() {
            return this.$store.state.ui?.getVipDone && this.$store.state.ui?.viewLoadDone;
        }
        @Watch("vipViewReady")
        watchVipViewReady(nv, ov) {
            if (nv) {
                if (!this.vip) {
                    let view = window["_view"];
                    if (!view) return;
                    view.showGridBox(true);
                    this.$store.commit("setStatus", {
                        type: "removeGrid",
                        data: true,
                    });
                }
                window["_view"].checkShapeLimitCount();
                window["_view"].invalidate(true);
            }
        }

        showDownloadPcTips = false;
        checkShowDownloadPc() {
            this.checkShowDownloadPc = () => {}; // 每次打开页面仅可运行一次
            this.$edApi
                .checkFirstEdit({
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                })
                .then((isFirst: boolean) => {
                    if (!isFirst) {
                        this.showDownloadPcTips = true;
                        this.sensors.track("downloadTips_popup", {
                            Catalogues: "downloadEdrawmaxTips",
                            popup_source: "editPage",
                        });
                    }
                });
        }
        closeDownloadTips() {
            this.showDownloadPcTips = false;
        }

        created() {
            // 批量发布流程，打开excel获取发布信息，遍历文件夹，上传至个人云，获取obj字段（注：localhost或https下使用）

            // let failMsg = [];
            // window['addEddxProcess'] = (oFile)=>{
            //     return new Promise((resolve, reject) => {
            //         let oFReader = new FileReader();
            //         oFReader.readAsArrayBuffer(oFile);
            //         oFReader.onload = function(oFREvent:any) {
            //             resolve(oFREvent.target.result);
            //         };
            //     })
            // }

            // window['startSave'] = async ()=>{
            //     if(this.excelData.length == 0) {
            //         alert('未导入excel')
            //         return
            //     }
            //     const opts = {type: 'openDirectory'};
            //     const handle = await window['showDirectoryPicker'](opts);
            //     const entries = await handle.values();
            //     for await (const entry of entries) {
            //         if(entry.kind == 'file' && entry.name.endsWith(".eddx")){
            //             let oFile = await entry.getFile();

            //             document.title= oFile.name+' - MaxOnline';
            //             window['_view'].setDocName(oFile.name);
            //             let zip = await window['addEddxProcess'](oFile);
            //             await importTemplate(oFile).then(e => {
            //                 if(e['type'] == 0) { // 错误
            //                     failMsg.push(e['msg']);
            //                 } else {
            //                     window['_view'].openFromFile(zip);
            //                     return publishTemplate(e['path'], oFile.name);
            //                 }
            //             });
            //         }
            //     }
            //     let msg = failMsg.length > 0 ? '发布完成,错误信息如下:' + JSON.stringify(failMsg) : '发布完成，无错误'
            //     alert(msg);
            // }
            // let startImportExcel = (e) => {
            //     let file = e.target.files[0];
            //     let reader = new FileReader();
            //     reader.readAsBinaryString(file);
            //     reader.onload = (e) => {
            //         let importExcelData = [];
            //         let res = window['_view'].chartImportFromExcel((e.target as any).result, importExcelData);
            //         console.log('-------------', res, importExcelData);
            //         this.excelData = importExcelData;
            //         alert('导入excel成功');
            //     }
            // }
            // let importTemplate = (file) => {
            //     return new Promise((rs, rj) => {
            //         if (this.userInfo && file) {
            //             let name = file.name.match(/(.*)\.eddx/i) && file.name.match(/(.*)\.eddx/i)[1];
            //             let list = []
            //             let exit = false;
            //             this.$store.dispatch('getFloder', {prefix: ''}).then(res => {
            //                 let filesList = res.data.data.files || []
            //                 filesList.map(item => {
            //                     let list = item.key.split('/')
            //                     let n = list[list.length - 1]
            //                     n = n.match(/(.*)\.eddx/) && n.match(/(.*)\.eddx/)[1]
            //                     item.name = n
            //                 })
            //                 filesList = filesList.filter(item => {
            //                     if (item.key.match(/.+eddx$/)) {
            //                         return true
            //                     }
            //                     return false
            //                 })
            //                 filesList.forEach(fileItem => {
            //                     if(fileItem.name == name) {
            //                         exit = true;
            //                     };
            //                 })
            //                 if (exit) {
            //                     rs({type: 0, msg: '错误：重名,模板名称：' + name});
            //                 } else {
            //                     this.$store.dispatch('uploadFile', {file, name: name + '.eddx'}).then(ev => {
            //                         let { res, path } = ev;
            //                         rs({type: 1, path});
            //                     })
            //                     .catch(err => {
            //                         rs({type: 0, msg: '错误：上传失败,模板名称：' + name});
            //                     })
            //                 }
            //             })

            //         }
            //     })
            // }
            // let publishTemplate = (objPath, fileName) => {
            //     return new Promise((RS, RJ) => {
            //         setTimeout(() => { // 等待5s，文件完全打开
            //             let publishInfo = {
            //                 title: '',
            //                 description: '',
            //                 price: 0,
            //                 tag: [],
            //                 copy: 1
            //             };
            //             let createSeoImg = async (svgContent, ossData) => {
            //                 const loadImage = (url): Promise<HTMLImageElement> => {
            //                     return new Promise(function(resolve, reject) {
            //                         var image = new Image();
            //                         image.src = url;
            //                         image.crossOrigin = 'Anonymous';
            //                         image.onload = function() {
            //                             resolve(image);
            //                         };
            //                         image.onerror = function(err) {
            //                             reject(err);
            //                         };
            //                     });
            //                 }

            //                 const blobToBase64 = (blob)=> {
            //                     return new Promise((resolve, reject) => {
            //                         const fileReader = new FileReader();
            //                         fileReader.onload = (e) => {
            //                             resolve((e.target as any).result);
            //                         };
            //                         fileReader.readAsDataURL(blob);
            //                         fileReader.onerror = () => {
            //                             reject(new Error('blobToBase64 error'));
            //                         };
            //                     });
            //                 }

            //                 const canvas = document.createElement('canvas'),
            //                 ctx = canvas.getContext("2d");
            //                 // 生成画布以及svg的width height
            //                 const viewBox = svgContent.getAttribute("viewBox").split(" ");
            //                 svgContent.setAttribute("width", String(viewBox[2]));
            //                 svgContent.setAttribute("height", String(viewBox[3]));
            //                 canvas.width = Number(viewBox[2]);
            //                 canvas.height = Number(viewBox[3]);

            //                 const base64 = await blobToBase64(new Blob([svgContent.outerHTML], {
            //                     type: "image/svg+xml;charset=utf-8"
            //                 }))
            //                 // 画base64至画布
            //                 const image = await loadImage(base64)
            //                 ctx.drawImage(image, 0, 0);

            //                 const file = await new Promise<Blob>((res,rej)=>{
            //                     canvas.toBlob((blob)=> {
            //                         res(blob)
            //                     }, 'image/png', 0.8)
            //                 })

            //                 let imgform = new FormData();
            //                 imgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
            //                 imgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
            //                 imgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
            //                 imgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
            //                 imgform.append("acl", ossData["acl"]);
            //                 imgform.append("Policy", ossData["Policy"]);
            //                 imgform.append("key", ossData.path + ossData.uri + `main.png`);
            //                 imgform.append("file", file);

            //                 let param = { url: ossData.host, data: imgform };
            //                 await this.$edApi
            //                     .uploadFile(param)
            //                     .then(res => {})
            //                     .catch(err => {
            //                         console.log(err);
            //                     });
            //                 return ossData.host + '/' + ossData.path + ossData.uri + `main.png`
            //             }
            //             let uploadFunc = response => {
            //                 let promiseList = [];
            //                 let ossData = response;
            //                 if (!this.internal) {
            //                     ossData["host"] = ossData.action;
            //                 }
            //                 let content = window["_view"]._doc.saveToSvgStream(192, true);
            //                 let svgFile = new Blob([content.documentElement.outerHTML], { type: "text/xml" });
            //                 let svgFileName = "main.svg";
            //                 let svgform = new FormData();
            //                 let pages = window["_view"]._doc._pages;
            //                 let ts = this;
            //                 let endFunc = ()=>{
            //                     promiseList.push(createSeoImg(content.documentElement, ossData))
            //                     let imgCanvas = pages[0].toBitmap(
            //                         blob => {
            //                             let imgform = new FormData();
            //                             if (!ts.internal) {
            //                                 imgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
            //                                 imgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
            //                                 imgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
            //                                 imgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
            //                                 imgform.append("acl", ossData["acl"]);
            //                                 imgform.append("Policy", ossData["Policy"]);
            //                                 imgform.append("key", ossData.path + ossData.uri + `thumb.png`);
            //                                 imgform.append("file", blob);
            //                             } else {
            //                                 imgform.append("OSSAccessKeyId", ossData.id);
            //                                 imgform.append("policy", ossData.policy);
            //                                 imgform.append("Signature", ossData.sign);
            //                                 imgform.append("key", ossData.path + ossData.uri + `thumb.png`);
            //                                 imgform.append("file", blob);
            //                             }
            //                             promiseList.push(
            //                                 new Promise((rs, rj) => {
            //                                     let param = { url: ossData.host, data: imgform };
            //                                     ts.$edApi
            //                                         .uploadFile(param)
            //                                         .then(res => {
            //                                             rs();
            //                                         })
            //                                         .catch(err => {
            //                                             console.log(err);
            //                                         });
            //                                 })
            //                             );
            //                         },
            //                         new egSize(300),
            //                         ".png",
            //                         2147483648
            //                     );

            //                     if (!ts.internal) {
            //                         svgform.append("X-Amz-Algorithm", ossData["X-Amz-Algorithm"]);
            //                         svgform.append("X-Amz-Credential", ossData["X-Amz-Credential"]);
            //                         svgform.append("X-Amz-Date", ossData["X-Amz-Date"]);
            //                         svgform.append("X-Amz-Signature", ossData["X-Amz-Signature"]);
            //                         svgform.append("acl", ossData["acl"]);
            //                         svgform.append("Policy", ossData["Policy"]);
            //                         svgform.append("key", ossData.path + ossData.uri + svgFileName);
            //                         svgform.append("file", svgFile);
            //                     } else {
            //                         svgform.append("OSSAccessKeyId", ossData.id);
            //                         svgform.append("policy", ossData.policy);
            //                         svgform.append("Signature", ossData.sign);
            //                         svgform.append("key", ossData.path + ossData.uri + svgFileName);
            //                         svgform.append("file", svgFile);
            //                     }
            //                     promiseList.push(
            //                         new Promise((rs, rj) => {
            //                             let param = { url: ossData.host, data: svgform };
            //                             ts.$edApi
            //                                 .uploadFile(param)
            //                                 .then(res => {
            //                                     rs();
            //                                 })
            //                                 .catch(err => {
            //                                     console.log(err);
            //                                 });
            //                         })
            //                     );
            //                     Promise.all(promiseList).then(e => {
            //                         let seoImg = e[0]
            //                         console.log("upload success");
            //                         let obj = {
            //                             id: ts.userInfo.user_id,
            //                             token: ts.userInfo.token,
            //                             data: Object.assign(publishInfo, {
            //                                 author: ts.userInfo.nick_name,
            //                                 url: ossData.path + ossData.uri,
            //                                 obj: objPath,
            //                                 exp: 2147483647,
            //                                 id: ts.userInfo.user_id
            //                             })
            //                         };
            //                         ts.$edApi
            //                             .publishFile(obj)
            //                             .then(e => {
            //                                 console.log("publish success");
            //                                 reviewTemplate(e.data.data.id, fileName, seoImg, imgCanvas).then(e => {
            //                                     RS();
            //                                 })
            //                             })
            //                             .catch(err => {
            //                                 console.log("publish fail");
            //                             });
            //                     })
            //                 };
            //                 window["_view"].addPageTextCache(pages[0], endFunc);
            //             };

            //             if (!ts.internal){ // 海外需添加atag及lang
            //                 publishInfo = Object.assign(publishInfo, {
            //                     lang: 'en',
            //                 });
            //             }
            //             this.$edApi.getPublishLink({
            //                 id: this.userInfo.user_id,
            //                 token: this.userInfo.token
            //             }).then(e => {
            //                 uploadFunc(e.data);
            //             });
            //         }, 5000);
            //     })
            // }
            // let reviewTemplate = (workId, fileName, seoImg, imgCanvas) => {

            //     return new Promise((rs, rj) => {
            //         let ts = this;
            //         let id = ts.userInfo.user_id,
            //         token = ts.userInfo.token,
            //         reason = '',
            //         param: any = {
            //             id,
            //             token,
            //             workId,
            //             pass: 1,
            //             lang: !ts.internal ? 'en' : 'zh',
            //             score: 5,
            //             member_free: 0,
            //         };
            //         for(let i = 1; i < this.excelData.length; i++) {
            //             if(this.excelData[i][1] && (this.excelData[i][1] + '.eddx') == fileName) {
            //                 param.title = this.excelData[i][2];
            //                 param.description = this.excelData[i][3];
            //                 param.atag = this.excelData[i][4].split(',').map(v => ~~v);
            //                 param.tag = this.excelData[i][5].split(',')
            //                 param.seo_title = this.excelData[i][6]
            //                 param.seo_content = this.excelData[i][7]
            //                 param.seo_alt = this.excelData[i][8]
            //                 param.seo_photo = seoImg
            //                 param.cover_width = imgCanvas.width
            //                 param.cover_height = imgCanvas.height
            //                 break
            //             }
            //         }
            //         this.$edApi.reviewAndPublishFile(param, 'review').then(res => {
            //             if (res) {
            //                 console.log('审核通过成功')
            //             } else {
            //                 failMsg.push('审核通过失败，workid:' + workId);
            //             }
            //             rs();
            //         });
            //     })
            // }

            // let input = document.createElement('input');
            // let div1 = document.createElement('div');
            // let div2 = document.createElement('div');

            // input.id = 'zzzzz1'
            // input.accept = '.xlsx,.csv';
            // input.type = 'file';
            // input.onchange = (e) => {startImportExcel(e)}

            // div1.innerText = '开始'
            // div1.onclick = () => {window['startSave']()};
            // let btnStyle = 'position:absolute;top:500px;width:100px;height:24px;line-height:24px;text-align:center;color:#fff;background:#017fff;border-radius:5px;z-index:999;user-select:none;'
            // div1.style.cssText = 'left:500px;' + btnStyle

            // div2.innerText = '引入excel'
            // div2.onclick = () => {document.getElementById('zzzzz1').click()};
            // div2.style.cssText = 'left:380px;' + btnStyle

            // document.body.appendChild(input)
            // document.body.appendChild(div1)
            // document.body.appendChild(div2)

            // this.getClipPathString();

            // let EDCurrentStr = Cookie.getItem('EDCurrent')
            // let EDCurrent = JSON.parse(EDCurrentStr)
            // this.$store.commit('setState', {type: 'userInfo', data: EDCurrent})
            // if (EDCurrent) {
            //         this.$store.dispatch('getUserInfo')
            // }

            if (this.isWorkwx) {
                this.$store.commit("setStatus", {
                    type: "constScreenLeft",
                    data: 230,
                });
                this.$store.commit("setStatus", {
                    type: "sceneLeft",
                    data: 230,
                });
            }

            document.onvisibilitychange = () => {
                if (this.noLoginEditor) return;
                let view = window["_view"];
                let state = document.visibilityState;
                if (state == "visible") {
                    this.checkLog();
                    this.$bus.$emit("appVisible");
                    view?.invalidate(true); // 修复chrome清理内存导致白屏
                }
                if (state == "hidden" && this.saveState != 1) {
                    // view.closeTextEdit();
                    view && this.$root["ui"].autoSaves("logout");
                }
            };

            let ts: any = this;
            window.onoffline = () => {
                ts.$edMessage.error({
                    content: ts.$t("offlineTip"),
                    duration: 0,
                });
            };
            window.ononline = () => {
                ts.$edMessage.destroy();
                if (this.saveOffline) {
                    this.$root["ui"].autoSaves();
                }
            };
            ts.$bus.$on("outputGoogleSlide", (type) => {
                ts.outputGoogleSlide(type);
            });
            ts.$bus.$on("login", () => {
                if (window.EDCONFIG.IS_SDK) {
                    // todo: 不处理
                    return;
                }
                let ts: any = this;
                let logAction = (userInfo) => {
                    userInfo.oldInfo = true;
                    this.$store.commit("setState", { type: "userInfo", data: userInfo });
                    this.$store.dispatch("getUserInfo");
                    ts.$bus.$emit("loginSucc");
                };
                if (this.isPrivate) {
                    validate()
                        .then((userInfo) => {
                            logAction(userInfo);
                        })
                        .catch(() => {
                            location.href = `${location.origin}${appConfig.sourcePath}auth/auth.html`;
                        });
                    return;
                }
                let success = (userInfo: any) => {
                    logAction(userInfo);
                };
                let fail = () => {
                    // $edAuth.show();
                };
                $edAuth
                    .checkLocalCookie(true, { pid: this.appPid, refreshMode: 1 })
                    .then((userInfo: any) => {
                        logAction(userInfo);
                    })
                    .catch(() => {
                        $edAuth.auth(success, fail, { pid: this.appPid, refreshMode: 1 });
                    });
            });
            ts.$bus.$on("logout", () => {
                if (window.EDCONFIG.IS_SDK) {
                    // todo: 消息通信给主站
                    return;
                }
                if (this.isPrivate) {
                    logout();
                    return;
                }
                if (this.isTeamsApp) {
                    history.replaceState(null, null, `${location.origin}${appConfig.sourcePath}`);
                }
                $edAuth.logout().then(() => {
                    if (this.isTeamsApp) {
                        location.reload();
                        return;
                    }
                    location.href = location.origin;
                });
            });
            ts.$bus.$on("notCloudFileLogout", () => {
                if (window.EDCONFIG.IS_SDK) {
                    // todo:
                    return;
                }
                if (this.isPrivate) {
                    logout();
                    return;
                }
                let logAction = (userInfo) => {
                    userInfo.oldInfo = true;
                    this.$store.commit("setState", { type: "userInfo", data: userInfo });
                    this.$store.dispatch("getUserInfo");
                };
                $edAuth.logout().then(() => {
                    $edAuth.auth(
                        logAction,
                        () => {
                            // $edAuth.show();
                        },
                        { pid: this.appPid, refreshMode: 1 }
                    );
                });
            });
            ts.$bus.$on("closeUnCompatibilityRemind", () => {
                ts.closeRemind();
            });
            ts.$bus.$on("closeRatioRemind", () => {
                ts.closeRatioRemindFun();
            });
            ts.$bus.$on("vipBtest", () => {
                ts.showAdvanceVip = true;
                ts.isShowAdvanceVip = true;
                ts.setFileEditLimit(1);
                ts.sensors.track("popNoEditNextTip", {
                    Catalogues: "payPath",
                });
            });
            let uiInterface = {
                /**
                 * 添加帮助提示
                 * json数据格式
                 * {
                 *  ele:绑定的元素
                 *  pos:出现在元素的位置  top|right|bottom|left
                 *  text:提示文字,html格式
                 *  next:存在则进入下一个帮助提示
                 *  params:为帮助提示重新设置信息
                 * }
                 *
                 */
                showHelpTips(json) {
                    let obj = JSON.parse(json);
                    let showTip = () => {
                        if (ts.$store.state.ui.helpTipsTour) return;
                        ts.$store.state.ui.helpTipsTour = ts.$shepherd({
                            useModalOverlay: true,
                            defaultStepOptions: {
                                classes: "help-tips" + (obj.otherClass ? " " + obj.otherClass : ""),
                                highlightClass: "no-pointer",
                                popperOptions: {
                                    modifiers: [
                                        {
                                            name: "offset",
                                            options: {
                                                offset: [0, 12],
                                            },
                                        },
                                    ],
                                },
                            },
                        });
                        ts.$store.state.ui.helpTipsTour.on("complete", () => {
                            ts.$store.state.ui.helpTipsTour = null;
                            if (obj.next) {
                                uiInterface.showHelpTips(JSON.stringify(obj.next));
                            }
                            // 关闭帮助提示后更新接口数据
                            if (obj.params) {
                                ts.$store.dispatch("setUserHelp", obj.params).then((e) => {
                                    // ts.$store.dispatch('getUserHelp')
                                    ts.$store.state.ui.helpContent[obj.params.type] = 1;
                                    ts.$store.state.ui.helpTipsFlag = false;
                                });
                            }
                            // if(ts.$store.state.user.starter !== null){
                            //     if(ts.userInfo){
                            //         let params = {
                            //             id: ts.userInfo.user_id,
                            //             token: ts.userInfo.token,
                            //             obj: { starter: ts.$store.state.user.starter | 2 }
                            //         };
                            //         ts.$edApi.updateUserPrefer(params);
                            //     }
                            // }
                        });

                        ts.$store.state.ui.helpTipsTour.addStep({
                            attachTo: { element: obj.ele, on: obj.pos },
                            text: obj.text,
                            buttons: [
                                {
                                    classes: "helpTipsBtn",
                                    text: "ok",
                                    action() {
                                        ts.$store.state.ui.helpTipsTour.complete();
                                    },
                                },
                            ],
                        });
                        ts.$store.state.ui.helpTipsTour.start();
                        // console.log(document.querySelectorAll('.helpTipsBtn')[0]);
                        // debugger
                        // document.querySelectorAll('.helpTipsBtn')[0].focus();
                    };
                },
                showNotices(json) {
                    ts.useNotice = true;
                    let obj = JSON.parse(json);
                    ts.noticeDirect = obj.pos;
                    ts.noticeContent = obj.text;
                    ts.noticeDom = document.querySelector(obj.ele);
                    ts.showNotice = true;
                    if (obj.params) {
                        ts.$store.dispatch("setUserHelp", obj.params).then((e) => {
                            ts.$store.state.ui.helpContent[obj.params.type] = 1;
                            ts.$store.state.ui.helpTipsFlag = false;
                        });
                    }
                },
                hideHelpTips() {
                    ts.$store.state.ui.helpTipsTour && ts.$store.state.ui.helpTipsTour.complete();
                },
                getWords(word) {
                    return ts.$t(word);
                },
                getHelpTips() {
                    return ts.$store.state.ui.helpTipsTour;
                },
                setHelpTipsFlag(val: any) {
                    ts.$store.commit("setStatus", {
                        type: "helpTipsFlag",
                        data: val,
                    });
                },
                showMsgBox(data) {
                    ts.showMessage({
                        type: 2,
                        content: ts.$t(data),
                    });
                },
                async toSaving(isManual, force: boolean = false, showMessage: boolean = true, from: string = "unknow") {
                    if (window.EDCONFIG.IS_SDK) {
                        if (from === "gridBox") return;
                        if (ts.saveState <= 0 && (force || AutoSaveTimer)) {
                            ts.saveState = 2;
                        }

                        const fileData = await getSdkSaveData();
                        ts.sdkApp
                            .promisePostMessage("PUT_FILE", { file: fileData.file, img: fileData.img, svgImg: fileData.svgImg })
                            .then(() => {
                                showMessage && ts.$edMessage.success(ts.$t("saveSuccess"));
                                ts.saveState = 0;
                            })
                            .catch(() => {
                                ts.saveState = -1;
                            })
                            .finally(() => {
                                if (AutoSaveTimer) {
                                    clearTimeout(AutoSaveTimer);
                                    AutoSaveTimer = null;
                                }
                            });
                        return;
                    }
                    if (!EDRAWMAX_USE_SAVE) return;
                    if (ts.noLoginEditor) return;
                    if (ts.isPreviewView) {
                        // 群组阅读状态不进行保存
                        return Promise.resolve();
                    }
                    // if(!ts.$checkAuth({type:'download'})) return;
                    ts.checkFileLimit();
                    window["_view"]._tool.endEdit();
                    if (ts.checkCloudSpaceLimit()) return;
                    // window['_view'].saveFileToLocal();
                    ts.checkShowDownloadPc();
                    if (ts.saveState <= 0 && (force || AutoSaveTimer)) {
                        ts.saveState = 2;

                        if (!navigator.onLine) {
                            ts.saveState = 0;
                            ts.$edMessage.error(ts.$t("noNetworkSave"));
                            return;
                        }
                        let urlSearch = ts.$store.state.ui.fileInfo;
                        ts.$pcTrack("saveFileProcess_save", `saveType: ${from};`);
                        ts.$track("save", "save action", `saveType: ${from}`);
                        if (!ts.editFileNumFlag) {
                            ts.editFileNumFlag = true;
                            ts.sensors.track("editFileNum", {
                                Catalogues: "editFileProcess",
                                file_source: ts.$store.state.user.file_source,
                                template_type: ts.$store.state.user.template_type,
                            });
                        }
                        return new Promise((result, rej) => {
                            ts.$store
                                .dispatch("autoSaveFile", {
                                    pushHis: isManual,
                                    versionDes: ts.$t("versionDes"),
                                    urlSearch,
                                })
                                .then((res) => {
                                    ts.$track("save", "save successfully", `type: ${from}`);
                                    ts.$pcTrack("saveFileProcess_saveResult", `saveType: ${from}; result: save successfully`);
                                    let sensorsObj = {
                                        Catalogues: "saveFileProcess",
                                        savesource: "manualSave",
                                        diagram_type: ts.$store.state.user.diagram_type,
                                        file_source: ts.$store.state.user.file_source,
                                        template_type: ts.$store.state.user.template_type,
                                        result: "success",
                                        fail_reason: "success",
                                        import_file_type: "none",
                                        diagram_type_from_empty_file: ts.$store.state.user.diagram_type,
                                    };
                                    window["_view"].invalidate(true);
                                    if (!ts.$store.state.user.fromNull) {
                                        delete sensorsObj.diagram_type_from_empty_file;
                                    }
                                    ts.sensors.track("saveFileNum", sensorsObj);
                                    showMessage && ts.$edMessage.success(ts.$t("saveSuccess"));
                                    ts.saveState = 0;
                                    result();
                                    if (AutoSaveTimer) {
                                        clearTimeout(AutoSaveTimer);
                                        AutoSaveTimer = null;
                                    }
                                    if (ForceSaveTimer) {
                                        clearTimeout(ForceSaveTimer);
                                        ForceSaveTimer = setTimeout(() => {
                                            window["_view"].autoSave();
                                        }, 120000);
                                    }
                                    if (ts.shareUUID) {
                                        // 编辑完分享文件后更新原始分享页面的svg等。
                                        ts.$bus.$emit("updateEditShare");
                                    }
                                })
                                .catch((err) => {
                                    ts.saveFileCatchHandler(err, from);
                                    rej(err);
                                });
                        }).catch(() => {});
                    } else {
                        return new Promise((result, rej) => {
                            result();
                            if (!AutoSaveTimer) {
                                showMessage && ts.$edMessage.success(ts.$t("saved"));
                            } else {
                                showMessage && ts.$edMessage.warning(ts.$t("saving"));
                            }
                        });
                    }
                },
                forceUploadFile() {
                    // 当前触发场景：记录社区模板id，文件首次编辑，非会员设置网格状态，试用vip模板设置水印
                    if (ts.noLoginEditor || ts.isPreviewView || ts.checkCloudSpaceLimit() || !navigator.onLine) return Promise.reject();
                    let urlSearch = ts.$store.state.ui.fileInfo;
                    return new Promise((rs, rej) => {
                        ts.$store
                            .dispatch("autoSaveFile", {
                                pushHis: false,
                                versionDes: ts.$t("versionDes"),
                                urlSearch,
                            })
                            .then((res) => {
                                window["_view"].invalidate(true);
                                if (AutoSaveTimer) {
                                    clearTimeout(AutoSaveTimer);
                                    AutoSaveTimer = null;
                                }
                                rs();
                            })
                            .catch((err) => {
                                ts.saveFileCatchHandler(err, "", false);
                                rej(err);
                            });
                    }).catch(() => {});
                },
                HyperlinkOpenFile(key, workId, notEditable, urlHash = "") {
                    let toRedirectNew = (key, fileName, urlHash = "") => {
                        let fileObj = "obj=" + key;
                        let newTab: any = window.open(
                            window.location.origin + appConfig.sourcePath + "app.html?" + ts.$zipFileName(fileObj + fileName) + `#${urlHash}`,
                            key
                        );
                        let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                        if (!openTabs.includes(key)) {
                            openTabs.push(key);
                        }
                        ts.$store.commit("addWin", newTab);
                        localStorage.setItem("openTabs", JSON.stringify(openTabs));
                    };

                    let checkFileExist = async (key) => {
                        let tempfilePath = key.match(/[^\/]+/gi);
                        let filePath = "";
                        tempfilePath.forEach((item, index, array) => {
                            if (index > 1 && index < array.length - 1) {
                                filePath += item + "/";
                            }
                        });
                        let res = await ts.$store.dispatch("getFloder", { prefix: filePath });
                        let fileList = res.data.data.files || [];
                        let result = fileList.some((item) => {
                            return item.key == key;
                        });
                        return result;
                    };

                    if (!workId) {
                        key = ts.userInfo.user_name + key;
                        let fileName = "&name=" + key.match(/[^\/]*(?=\.eddx)/i)[0];
                        let fileKey = key;
                        checkFileExist(fileKey).then((isFileExit: boolean) => {
                            if (!isFileExit) {
                                ts.$store.commit("setDialogState", {
                                    type: "showColudFileNoExistDialog",
                                    data: true,
                                });
                            } else {
                                // 如果超过可编辑文件数，弹窗弹窗
                                if (notEditable) {
                                    // 进入仅预览模式
                                    fileName += "&preview=1";
                                }
                                let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                                if (openTabs.includes(fileKey)) {
                                    try {
                                        let tab = window.open("", fileKey);
                                        if (tab.location.href === "about:blank") {
                                            ts.$store.commit("addWin", tab);
                                            tab.location.href =
                                                window.location.origin +
                                                appConfig.sourcePath +
                                                "app.html?" +
                                                ts.$zipFileName("obj=" + fileKey + fileName + +`#${urlHash}`);
                                        }
                                    } catch (e) {
                                        toRedirectNew(fileKey, fileName, urlHash);
                                    }
                                } else {
                                    toRedirectNew(fileKey, fileName, urlHash);
                                }
                            }
                        });
                    } else {
                        // 我的收藏文件
                        let langStr = ts.lang || appConfig.language;
                        let url = `${window.location.origin}${appConfig.sourcePath}${langStr}/store?workId=${workId}&noClone=true`;
                        window.open(url);
                    }
                },
                setActivedPage(type, data) {
                    if (type === "Theme") {
                        ts.$store.commit("setTheme", data);
                    } else if (type === "ThemeImage") {
                        ts.$store.commit("setThemesImage", data);
                    } else if (type === "ThemeConnectorImage") {
                        ts.$store.commit("setThemeConnectorsImage", data);
                    } else if (type === "QuickStyleImage") {
                        ts.$store.commit("setQuickStyleImage", data);
                    } else if (type === "TableQuickStyleImage") {
                        ts.$store.commit("setTableQuickStyleImage", data);
                    }
                },
                openNavigationTools(type) {
                    ts.$bus.$emit("openNavigationTool", type);
                },
                closeNavigationTools() {
                    if (!ts.isSpecial) ts.$bus.$emit("closeNavigationTool");
                },
                setRightView(type: string) {
                    if (type === "aiset") {
                        if (ts.currentView) {
                            (ts.$refs.rightPanel as any).closeRightMenu();
                        }
                        ts.$bus.$emit("showAIPanel", !ts.showAIPanel);
                        return;
                    }
                    ts.$bus.$emit("changeRightView", type, false, "other");
                },
                setRightViewAcitveKey(type: string | null) {
                    ts.$bus.$emit("changeRightViewActiveKey", type);
                },
                itemChosen(key: string) {
                    ts.$bus.$emit("changeRightViewActiveKey", key);
                },
                setRightSlideView() {
                    ts.$bus.$emit("changeRightView", "slideset", false, "other");
                },
                setPageStats(data) {
                    ts.$store.commit("setPageStat", data);
                    if (data.type === "pages") {
                        ts.$bus.$emit("refreshPagePre");
                    }
                },
                setActivedFmt(type, data) {
                    if (type === "Fill") {
                        ts.$store.commit("activedFill", data);
                    } else if (type === "Line") {
                        ts.$store.commit("activedLine", data);
                    } else if (type === "Shadow") {
                        ts.$store.commit("activedShadow", data);
                    } else if (type === "Font") {
                        ts.$store.commit("activedFont", data);
                    } else if (type === "Shape") {
                        // 这里点击图形有 100 多次 commit 合并一些 commit
                        if (combineCommitKeys.includes(data.type)) {
                            if (!ts.combineObj) {
                                ts.combineObj = {};
                            }
                            Object.assign(ts.combineObj, { [data.type]: data.data });
                            if (Object.keys(ts.combineObj).length === combineCommitKeys.length) {
                                ts.$store.commit("setShapeCombineStatus", ts.combineObj);
                                delete ts.combineObj;
                            }
                        } else {
                            ts.$store.commit("setShapeStatus", data);
                        }
                    } else if (type === "ShapeData") {
                        ts.$store.commit("activedShapeData", data);
                    } else if (type === "PlanSet") {
                        ts.$store.commit("setPlanSetData", data);
                    } else if (type === "actions") {
                        ts.$store.commit("setShapeActions", data);
                    } else if (type === "setEchartSerieColors") {
                        let options = JSON.parse(data.options);
                        const seriesList = options.series;
                        const defaultColor = options.color;
                        let seriesColorList = [];
                        let colorIndex = 0;
                        if (data.chartType == "pie") {
                            let data = seriesList[0].data;
                            for (let i = 0; i < data.length; i++) {
                                let item = data[i];
                                if (item.itemStyle && item.itemStyle.color) {
                                    seriesColorList.push(item.itemStyle.color);
                                } else {
                                    seriesColorList.push(defaultColor[colorIndex]);
                                }
                            }
                        } else if (data.chartType == "funnel") {
                            for (let j = 0; j < seriesList.length; j++) {
                                let data = seriesList[j].data;
                                for (let i = 0; i < data.length; i++) {
                                    let item = data[i];
                                    if (item.itemStyle.color) {
                                        seriesColorList.push(item.itemStyle.color);
                                    } else {
                                        seriesColorList.push(defaultColor[colorIndex]);
                                    }
                                    colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                                }
                            }
                        } else if (data.chartType === "parallel") {
                            for (let i = 0; i < seriesList.length; i++) {
                                let item = seriesList[i];
                                if (item.lineStyle && item.lineStyle.color) {
                                    seriesColorList.push(item.lineStyle.color);
                                } else {
                                    seriesColorList.push(defaultColor[colorIndex]);
                                    colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                                }
                            }
                        } else {
                            for (let i = 0; i < seriesList.length; i++) {
                                let item = seriesList[i];
                                if (item.itemStyle && item.itemStyle.color) {
                                    seriesColorList.push(item.itemStyle.color);
                                } else {
                                    seriesColorList.push(defaultColor[colorIndex]);
                                    colorIndex = colorIndex + 1 > defaultColor.length - 1 ? 0 : colorIndex + 1;
                                }
                            }
                        }
                        ts.$store.commit("setEchartSeriesColors", [...seriesColorList]);
                    } else if (type === "lineAnimateData") {
                        ts.$store.commit("activedLineAnimateData", data);
                    }
                },
                setMathData(data) {
                    ts.$store.commit("setShapeStatus", data);
                },
                setShapeIdImmidiatly(data) {
                    ts.$store.commit("setShapeStatus", {
                        type: "id",
                        data: data,
                    });
                },
                getShapeType() {
                    return ts.$store.state.shape.type;
                },
                disActivedFmtTypes() {
                    ts.$store.commit("disActivedFmtType");
                },
                changeStyleBrushStatus(v) {
                    ts.$store.commit("setShapeStatus", {
                        type: "isStyleBrushActive",
                        data: v,
                    });
                },
                setStatuss(type, data) {
                    if (type === "showNumber" && data === 0) {
                        ts.$bus.$emit("editedNum");
                    }
                    if (type === "fileNameSync") {
                        if (appConfig.language === "zh") {
                            document.title = data + " - 亿图图示";
                        } else {
                            document.title = data + " - EdrawMax";
                        }
                    }
                    ts.$store.commit("setStatus", {
                        type: type,
                        data: data,
                    });
                },
                spliceSlide(type, index, num, slide) {
                    ts.$store.commit("changeSlide", {
                        type,
                        index,
                        num,
                        slide,
                    });
                },
                replaceSlide(data) {
                    ts.$store.commit("setSlideList", data);
                },
                swapSlide(pIndex, index) {
                    ts.$store.commit("swap2Slide", {
                        pIndex,
                        index,
                    });
                },
                showDialogs(type) {
                    if (type == "InsertMap") {
                        if (!ts.internal) {
                            // 海外屏蔽地图
                            return;
                        }
                        let worker = new Worker(ts.workerURL);
                        let loadingEnd = () => {
                            // 加载完成后打开弹窗
                            // 地图注册
                            EDDocument.getEChartsData().then((e) => {
                                let MapData = EDDocument._eChartData;
                                for (let i in MapData) {
                                    for (let key in MapData[i]) {
                                        echarts.registerMap(key, MapData[i][key]);
                                    }
                                }
                                ts.toggleLoading(false);
                                ts.$store.commit("setDialogState", {
                                    type: "showDialog",
                                    data: true,
                                });
                                ts.$store.commit("setDialogState", {
                                    type: "dialogType",
                                    data: type,
                                });
                            });
                        };
                        ts.$edApi.getMaxConfig().then((res) => {
                            let axiosData = res.data;
                            let host = res.msg;
                            let newArr = [];
                            let updateArr = [];

                            let opendb = window.indexedDB.open("versionDB");
                            opendb.onsuccess = (e) => {
                                let db = opendb.result;
                                let trans = db.transaction("configVersion", "readwrite");
                                let objstore = trans.objectStore("configVersion");
                                let index = objstore.index("configIDIndex");

                                let promiseArr = [];
                                for (let i = 0; i < axiosData.length; ++i) {
                                    if ("EChartsData.tar" == axiosData[i].name) {
                                        new Promise((res, rej) => {
                                            index.get(axiosData[i].id).onsuccess = (e) => {
                                                let data = (e.target as IDBRequest).result;
                                                if (data) {
                                                    // 有数据且版本不一致 需要更新
                                                    if (data.version !== axiosData[i].version) updateArr.push(axiosData[i]);
                                                } else {
                                                    newArr.push(axiosData[i]);
                                                }
                                                res();
                                            };
                                        }).then((e) => {
                                            if (newArr.length > 0 || updateArr.length > 0) {
                                                ts.toggleLoading(true);
                                                let downloadArr = newArr.concat(updateArr).map((v, k) => {
                                                    return {
                                                        name: v.name,
                                                        type: v.type,
                                                        v: 1,
                                                        url: `${host}/${v.url}`,
                                                        dataVersionInfo: {
                                                            configName: v.name,
                                                            configID: v.id,
                                                            version: v.version,
                                                        },
                                                    };
                                                });
                                                let obj = {};
                                                for (let i = 0; i < downloadArr.length; ++i) {
                                                    obj[downloadArr[i]["name"].match(/[a-zA-Z].[^\.]*/)] = downloadArr[i];
                                                }
                                                worker.postMessage({
                                                    type: "checkDB",
                                                    data: obj,
                                                });
                                                worker.onmessage = (e) => {
                                                    let message = e.data;
                                                    if (message.type === "loaded") {
                                                        worker.terminate();
                                                        db.close();
                                                        loadingEnd();
                                                    }
                                                    if (message.type === "process") {
                                                        ts.setProcess(message.process);
                                                    }
                                                };
                                            } else {
                                                worker.terminate();
                                                db.close();
                                                loadingEnd();
                                            }
                                        });
                                        break;
                                    }
                                }
                            };
                        });
                    } else {
                        ts.$store.commit("setDialogState", {
                            type: "showDialog",
                            data: true,
                        });
                        ts.$store.commit("setDialogState", {
                            type: "dialogType",
                            data: type,
                        });
                    }
                },
                setDialogStatus(type, data) {
                    ts.$store.commit("setDialogState", {
                        type: type,
                        data: data,
                    });
                },
                showMathDialog() {
                    ts.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                    ts.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "Math",
                    });
                },
                setEChartData(data) {
                    ts.$store.commit("setEChartState", data);
                    if (data.type == "showDataFlag") {
                        ts.$root["ui"].expandExcelData("echart", data["data"], "_act$");
                    }
                },
                expandExcelData(type, data) {
                    ts.$bus.$emit("changeRightType", {
                        type: type,
                        data: data,
                    });
                },
                chartSet(data) {
                    if (data) {
                        data.isInit = true;
                        ts.$store.commit("initEChart", data, "_act$");
                    }
                },
                chartSelect(data) {
                    ts.$store.dispatch("clickSeries", data + 1);
                },
                checkMapInit(callback) {
                    // 检查map数据是否装载
                    let status = ts.$store.state.ui.chartLoadedStatus;
                    if (!status) {
                        ts.$store.commit("setStatus", {
                            type: "chartLoadedStatus",
                            data: 1,
                        });
                        ts.$store.dispatch("loadConfig", ["EChartsData.tar"]).then((e) => {
                            ts.$store.commit("setStatus", {
                                type: "chartLoadedStatus",
                                data: 2,
                            });
                            callback();
                        });
                    } else if (status == 2) {
                        callback();
                    }
                },
                updateChartDatas(data) {
                    ts.$store.commit("updateChartData", data);
                },
                orgchartSet(data) {
                    ts.$store.commit("initOrgchart", data);
                },
                dragOrgchartSet(data) {
                    ts.$store.commit("initDragOrgchart", data);
                },
                setapplyOptions(data) {
                    ts.$store.commit("setapplyOption", data);
                },
                ganttSet(data) {
                    ts.$store.commit("initGantt", data);
                },
                tableSet(data) {
                    ts.$store.commit("initTableSet", data);
                },
                setTableStates(data) {
                    ts.$store.commit("setTableState", data);
                },
                getOrgChartRange() {
                    return ts.$store.state.orgchart.applyOption;
                },
                getOrgCardApplyOption() {
                    return ts.$store.state.orgchart.cardApplyOption;
                },
                getOrgCardStyleApplyOption() {
                    return ts.$store.state.orgchart.cardStyleApplyOption;
                },
                layoutSet(data) {
                    ts.$store.commit("initLayout", data);
                },
                getData(type, module: string = "") {
                    if (type === "editNumber") {
                        return ts.$store.state.ui.editNumber.value;
                    } else if (type === "vip") {
                        if (ts.isPrivate || ts.isPlugin) {
                            return true;
                        }
                        return !!ts.vip;
                    } else if (type === "vueDragFlag") {
                        return ts.$store.state.library.vueDragFlag;
                    } else if (module) {
                        return ts.$store.state[module][type];
                    } else if (type === "version") {
                        return ts.appVersion;
                    } else if (type === "activedThemeId") {
                        return ts.$store.state.page.activedThemeId;
                    }
                    return ts.$store.state.ui[type] != void 0
                        ? ts.$store.state.ui[type]
                        : ts.$store.getters[type] != void 0
                          ? ts.$store.getters[type]
                          : undefined;
                },
                getGanttData(type) {
                    return ts.$store.state.gantt[type];
                },
                getDialogStatus(type) {
                    if (type !== void 0) {
                        return ts.$store.state.dialog.showDialog && ts.$store.state.dialog["dialogType"] === type;
                    } else {
                        return ts.$store.state.dialog.showDialog;
                    }
                },
                getDialogData(type) {
                    return ts.$store.state.dialog[type];
                },
                getShapeData(type) {
                    return ts.$store.state.shape[type] || ts.$store.getters[type] || undefined;
                },
                getChartData(type) {
                    return ts.$store.state.echart[type] || ts.$store.getters[type] || undefined;
                },
                pictureSet(data) {
                    ts.$store.commit("setPictureState", data);
                },
                dataSheetSet(data) {
                    ts.$store.commit("initDataSheet", data);
                },
                uploadTheme(content) {
                    //上传自定义主题
                    if (!content) return;
                    if (!ts.$store.state.user.userInfo) return;
                    let file = new Blob([content]);
                    ts.$store
                        .dispatch("uploadCustomTheme", { file })
                        .then((res) => {
                            console.log(res);
                        })
                        .catch((err) => {
                            ts.showMessage({
                                type: 2,
                                content: ts.$t("msgContent"),
                            });
                        });
                },
                getSheetData(type) {
                    return ts.$store.state.datasheet[type] || ts.$store.getters[type] || undefined;
                },
                showSwimLaneSeparatorError(type) {
                    let str = ts.$t("separatorOnCanvas");
                    if (type == 1) str = ts.$t("correctSeparator");

                    ts.showMessage({
                        type: 2,
                        content: str,
                    });
                },
                showTableDragCopyError() {
                    ts.showMessage({
                        type: 2,
                        content: ts.$t("tableError"),
                    });
                },
                toggleExpandLibrary(v: boolean, direction?) {
                    // 切换可用库的显示
                    if (ts.expandLibraryData.length == 0) return; // 没有数据 返回
                    ts.$store.commit("setDialogState", {
                        type: "showExpandLibrary",
                        data: v,
                    });
                    if (v) {
                        ts.closeExpandLibEventTimer = setTimeout(() => {
                            ts.useCloseExpandLibEvent = true;
                        }, 150);
                        ts.$store.commit("setDialogState", {
                            type: "expandChoiceIndex",
                            data: 0,
                        });
                    } else {
                        clearTimeout(ts.closeExpandLibEventTimer);
                        ts.useCloseExpandLibEvent = false;
                    }
                },
                setExpandLibraryData(id, flag) {
                    // flag true时限制高度
                    let height = 248; // 五行
                    if (id) ts.getExpandLibraryDataByID(id);
                    if (flag) height = 200;
                    ts.$store.commit("setDialogState", {
                        type: "expandMaxHeight",
                        data: height,
                    });
                },
                linkLineExpandLibrary(position, direct) {
                    // 通过连接线展开可用库
                    if (ts.expandLibraryData.length == 0) return;
                    let left = 0,
                        top = 0,
                        boxW = 0,
                        boxH = 0,
                        libL = ts.sceneLeft ? ts.sceneLeft.replace("px", "") - 0 : 0,
                        libT = ts.sceneTop ? ts.sceneTop.replace("px", "") - 0 : 0,
                        winW = window.innerWidth,
                        winH = window.innerHeight;

                    ts.$nextTick(() => {
                        let dom = ts.$refs.expandLibBox.$el as HTMLElement;
                        let domData = dom.getBoundingClientRect();
                        boxW = domData["width"];
                        boxH = domData["height"];

                        left = position["x"] + libL;
                        if (position["y"] + libT + boxH > winH && direct === 1) top = position["y"] + libT - boxH;
                        else if (position["y"] + libT + boxH > winH && ~[2, 3].indexOf(direct)) top = position["y"] + libT - boxH / 2;
                        else top = position["y"] + libT;

                        if (direct == 0) {
                            top -= 30;
                        }
                        if (direct == 2) {
                            left -= 30;
                        }

                        ts.$store.commit("setDialogState", {
                            type: "expandLeft",
                            data: left,
                        });
                        ts.$store.commit("setDialogState", {
                            type: "expandTop",
                            data: top,
                        });
                    });
                },
                updateExpandLibrary() {
                    // 右键更新可用库菜单
                    if (_view._activeShape) {
                        let libId = _view._activeShape._libId;
                        if (ts.selectShapesFlag === "shapeStyle") {
                            if (_view._activeShape.getObjectList) {
                                libId = _view._activeShape.getObjectList()[0]._libId;
                            }
                            ts.selectShapesFlag = "";
                        }
                        ts.getExpandLibraryDataByID(libId);
                        ts.$store.commit("setDialogState", {
                            type: "expandMaxHeight",
                            data: 320,
                        });
                    }
                },
                getExpandLibraryData(id) {
                    if (id) {
                        let p = ts.getExpandLibraryDataByID(id, true);
                        return p;
                    }
                },
                setFloatMenuList(type, data) {
                    if (type == "init") {
                        ts.$store.commit("initFloatMenuList", data);
                    } else if (type == "add") {
                        ts.$store.commit("addFloatMenuList", data);
                    } else if (type == "update") {
                        ts.$store.commit("updateFloatMenuList", data);
                    } else if (type == "delete") {
                        ts.$store.commit("deleteFloatMenuList", data);
                    } else if (type == "allPosition") {
                        ts.$store.commit("updateFloatMenuListAllPostion", data);
                    } else if (type == "onePosition") {
                        ts.$store.commit("updateFloatMenuListOnePostion", data);
                    } else if (type == "clear") {
                        ts.$store.commit("clearFloatMenu");
                    } else if (type == "expand") {
                        ts.$bus.$emit("expandFloatMenu", data);
                    } else if (type == "index") {
                        if (ts.$store.state.shape.id == data.id) {
                            // 修改图形是当前选中图形
                            ts.$store.commit("setActiveFloatMenu", data.id);
                        }
                    } else if (type == "optionIndex") {
                        // ts.$store.commit('setActiveFloatOption', data.id)
                    } else if (type == "navigationOption") {
                        ts.$store.commit("setnavigationOption", data);
                    }
                },
                setLanguage(lang) {
                    ts.$store.commit("changeUILang", lang);
                },
                getLanguage() {
                    return ts.lang;
                },
                setProcess(num) {
                    // 设置进度条进度
                    ts.$store.commit("setStatus", {
                        type: "LoadingProcess",
                        data: num > 1 ? 1 : num < 0 ? 0 : num,
                    });
                },
                showLoadingDialog(show, type) {
                    // loading dialog
                    if (show) {
                        ts.$store.commit("setStatus", {
                            type: "loadingTextType",
                            data: type,
                        });
                    }
                    ts.$store.commit("setStatus", {
                        type: "Loading",
                        data: show,
                    });
                },
                showEditActionPlanCard() {
                    ts.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "EditActionPlan",
                    });
                    ts.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                },
                autoSaves(from = "auto save") {
                    if (window.EDCONFIG.AUTO_SAVE_ENABLE === false) return;
                    if (!EDRAWMAX_USE_SAVE) return;
                    if (ts.noLoginEditor) return;
                    if (ts.isPreviewView || ts.dialogType === "ShareBox") {
                        // 群组阅读状态不进行保存
                        return;
                    }
                    ts.saveState = 1;
                    if (!navigator.onLine) {
                        ts.saveState = 0;
                        ts.$edMessage.error(ts.$t("noNetworkSave"));
                        ts.saveOffline = true;
                        return;
                    }
                    if (!window.EDCONFIG.IS_SDK && ts.checkCloudSpaceLimit()) return;
                    ts.$pcTrack("saveFileProcess_save", `saveType: ${from}`);
                    ts.$track("save", "save action", `saveType: ${from}`);
                    let urlSearch = ts.$store.state.ui.fileInfo;
                    ts.$store
                        .dispatch("autoSaveFile", { urlSearch })
                        .then((e) => {
                            ts.$track("save", "save successfully", `type: ${from}`);
                            ts.$pcTrack("saveFileProcess_saveResult", `saveType: ${from}; result: save successfully`);
                            let sensorsObj = {
                                Catalogues: "saveFileProcess",
                                savesource: "autoSave",
                                diagram_type: ts.$store.state.user.diagram_type,
                                file_source: ts.$store.state.user.file_source,
                                template_type: ts.$store.state.user.template_type,
                                result: "success",
                                fail_reason: "success",
                                import_file_type: "none",
                                diagram_type_from_empty_file: ts.$store.state.user.diagram_type,
                            };
                            if (!ts.$store.state.user.fromNull) {
                                delete sensorsObj.diagram_type_from_empty_file;
                            }
                            ts.sensors.track("saveFileNum", sensorsObj);
                            if (AutoSaveTimer) {
                                clearTimeout(AutoSaveTimer);
                                AutoSaveTimer = null;
                            }
                            if (ForceSaveTimer) {
                                clearTimeout(ForceSaveTimer);
                                ForceSaveTimer = setTimeout(() => {
                                    window["_view"].autoSave();
                                }, 120000);
                            }
                            ts.saveState = 0;
                            if (ts.shareUUID) {
                                // 编辑完分享文件后更新原始分享页面的svg等。
                                ts.$bus.$emit("updateEditShare");
                            }
                        })
                        .catch((err) => {
                            // 获取签名错误（未获取到签名,getSignFail）,上传错误(uploadFail), 前端其他错误(page error)
                            ts.saveFileCatchHandler(err, from);
                        });
                },
                setMindMasterData(data) {
                    ts.$store.commit("setMindMasterState", {
                        type: data.type,
                        data: data.data,
                    });
                },
                setLibraryData(data) {
                    ts.$store.commit("setLibraryState", {
                        type: data.type,
                        data: data.data,
                    });
                },
                setPublicStatus(data) {
                    ts.$store.commit("toPublicStatus", data);
                },
                limitShapeCallback(data) {
                    ts.$bus.$emit("limitShapeCallback", data);
                },
                setOrgchartStates(data) {
                    ts.$store.commit("setOrgchartState", {
                        type: data.type,
                        data: data.data,
                    });
                },
                updateSearchDialog() {
                    ts.$bus.$emit("updateSearchStr");
                },
                //向用户确认文档解密密码
                confirmFilePassword(passwordData, res) {
                    // do show confirmModal
                    ts.$store.commit("setStatus", {
                        type: "cryptType",
                        data: "decry",
                    });
                    if (ts.ignorePwd && ts.savedPwd) {
                        // 免输密码解密
                        let result = JSZip.verifyData(passwordData, ts.savedPwd);
                        if (result) {
                            ts.setDocPwd(ts.savedPwd);
                            res(result);
                        } else {
                            ts.$edMessage.error(ts.$t("encryptionPasswordError"));
                        }
                    } else {
                        ts.$store.commit("setStatus", {
                            type: "showCryptModal",
                            data: true,
                        });
                        ts.$bus.$on("confirmFileDecryption", (password) => {
                            let result = JSZip.verifyData(passwordData, password);
                            if (result) {
                                ts.setDocPwd(password);
                                ts.$store.commit("setStatus", {
                                    type: "showCryptModal",
                                    data: false,
                                });
                                // 保存密码
                                ts.$store.commit("setStatus", {
                                    type: "savedPwd",
                                    data: password,
                                });
                                res(result);
                            } else {
                                ts.$edMessage.error(ts.$t("encryptionPasswordError"));
                            }
                        });
                    }
                },
                closeContext() {
                    ts.$store.commit("closeContext");
                },
                autoSaveVersion() {
                    if (window.EDCONFIG.AUTO_SAVE_ENABLE === false) return;
                    if (!EDRAWMAX_USE_AUTOVERSION) return;
                    if (ts.noLoginEditor) return;
                    const getversionName = (initId) => {
                        let prefix = ts.internal ? "自动保存" : "Automatic Save";
                        const versions = ts.revisionsLists.filter((item) => item.auto == 1);
                        let id = initId || versions.length + 1;
                        let name: string = `${prefix}-${id}`;
                        while (versions.find((item) => item.name === name)) {
                            id++;
                            name = `${prefix}-${id}`;
                        }
                        return name;
                    };

                    ts.$bus.$emit("beforeAutoSaveVersion");

                    const revisionsLists = cloneDeep(ts.revisionsLists);
                    const data = ts.revisionsLists.filter((item) => item.auto === 1);
                    let initId;
                    if (data.length === 10) {
                        ts.$store.commit("setVersionState", {
                            type: "revisionsList",
                            data: remove(ts.revisionsLists, (v) => v.id !== last(data).id),
                        });
                        initId = 1;
                    }

                    ts.$store
                        .dispatch("saveVersion", {
                            file_key: ts.$store.state.ui.fileKey,
                            urlSearch: ts.$store.state.ui.fileInfo,
                            versionDes: ts.$t("versionDes"),
                            auto: 1,
                            name: getversionName(initId),
                        })
                        .catch(() => {
                            ts.$store.commit("setVersionState", {
                                type: "revisionsList",
                                data: revisionsLists,
                            });
                        });
                },
                sensorTrack(eventsName, data) {
                    ts.sensors.track(eventsName, JSON.parse(data));
                },
                getEnv(name: string) {
                    switch (name) {
                        case "env":
                            return EDRAWMAX_PRODUCT_ENV;
                    }
                },
                floatToolBridge(data: object) {
                    // ts修改vue store数据
                    if (data["type"] == "forceClose") {
                        ts.$bus.$emit("ft_closeChildExpand");
                        return;
                    }
                    let libL = ts.sceneLeft ? ts.sceneLeft.replace("px", "") - 0 : 0,
                        libT = ts.sceneTop ? ts.sceneTop.replace("px", "") - 0 : 0;
                    if (Object.keys(data).includes("floatToolPosition")) {
                        data["floatToolPosition"].left += libL;
                        data["floatToolPosition"].top += libT;
                    }
                    ts.$store.commit("setFloatToolState", data);
                },
                updateMiniMapPreview() {
                    ts.$bus.$emit("updateMiniMapPreview");
                },
                showEChartDialog(option, type, shapeId) {
                    ts.$bus.$emit("showEChartEditor", { option }, type, shapeId);
                },
                showEchartRightExcel() {
                    ts.$store.commit("setStatus", {
                        type: "isEChartData",
                        data: true,
                    });
                    ts.$bus.$emit("itemChosen", "echart");
                },
                alertPromodal() {
                    if (!ts.internal && ts.lang == "en") {
                        ts.$store.commit("toPublicStatus", {
                            type: "upgradeTrigger",
                            data: "symbolsPop",
                        });
                        ts.promodalType = 3;
                        ts.promodalPage = 1;
                        ts.togglePromodal(true);
                    } else {
                        ts.$store.commit("toPublicStatus", {
                            type: "showUpgrade",
                            data: "limitShape",
                        });
                        ts.$store.commit("toPublicStatus", {
                            type: "upgradeTrigger",
                            data: "symbolsPop",
                        });
                        // ts.$openBuyPage("symbolsPop");
                    }
                },
                alertShapeNumFloat() {
                    ts.$refs.pagebar.showShapeNum();
                },
                setUsedVipState(type, data) {
                    ts.$store.commit("setVipState", {
                        type,
                        data,
                    });
                },
                showVipStatePoper(key) {
                    ts.$bus.$emit("showVipPopover", key);
                },
                setThirdPartData(type, data, index) {
                    if (type == "echart") {
                        ts.$store.commit("setFloatEChartState", data);
                        ts.trackHoverEvent(data);
                    }
                    if (type === "slideEchart") {
                        ts.$store.commit("setSlideEChartState", { data, index });
                    }
                },
                setNewEchartData(key, value) {
                    ts.$store.commit("setNewEChartState", {
                        key,
                        value,
                    });
                },
                resizeCanvas() {
                    ts.$bus.$emit("canvasOnsize");
                },
                sdkUserEdited() {
                    if (!ts.editFileNumFlag) {
                        ts.editFileNumFlag = true;
                        ts.sdkApp.promisePostMessage("SDK_USER_EDIT");
                    }
                },
            };
            let ignoreFunc = {
                toSaving: "1",
                getData: "1",
                setFloatMenuList: "1",
                showHelpTips: "1",
                showNotices: "1",
                getHelpTips: "1",
                setHelpTipsFlag: "1",
                getWords: "1",
                getSheetData: "1",
                getChartData: "1",
                checkMapInit: "1",
                getShapeData: "1",
                getDialogStatus: "1",
                getOrgChartRange: "1",
                getOrgCardApplyOption: "1",
                getOrgCardStyleApplyOption: "1",
                getShapeType: "1",
                showMathDialog: "1",
                expandExcelData: "1",
                getLanguage: "1",
                setProcess: "1",
                spliceSlide: "1",
                replaceSlide: "1",
                openNavigationTools: "1",
                swapSlide: "1",
                chartSet: "1",
                linkLineExpandLibrary: "1",
                setExpandLibraryData: "1",
                toggleExpandLibrary: "1",
                showLoadingDialog: "1",
                disActivedFmtTypes: "1",
                showSwimLaneSeparatorError: "1",
                showTableDragCopyError: "1",
                setLibraryData: "1",
                setPublicStatus: "1",
                confirmFilePassword: "1",
                setRightSlideView: "1",
                getGanttData: "1",
                tableSet: "1",
                getDialogData: "1",
                closeContext: "1",
                ganttSet: "1",
                autoSaveVersion: "1",
                updateSearchDialog: "1",
                getExpandLibraryData: "1",
                getEnv: "1",
                floatToolBridge: "1",
                layoutSet: "1",
                setShapeIdImmidiatly: "1",
                setMathData: "1",
                forceUploadFile: "1",
                setThirdPartData: "1",
                setNewEchartData: "1",
            };
            let eventDone = () => {
                ts.$bus.$emit("scheduleEventDone");
            };
            //ts代码执行与ui更新过程分离
            for (let k in uiInterface) {
                let func = uiInterface[k];
                if (Object.keys(ignoreFunc).includes(k)) continue;
                uiInterface[k] = function (...args) {
                    let act = Array.isArray(args) && args[args.length - 1] == "_act$";
                    if (act) {
                        args.pop();
                        func(...args);
                    } else {
                        scheduleCommit(k, args, eventDone);
                    }
                };
            }
            this.$root["ui"] = uiInterface;
            ts.$bus.$on("showHelpTips", uiInterface.showHelpTips);
            ts.$bus.$on("getWords", uiInterface.getWords);

            //预读取font文件，在window.onload之后添加。避免多次全局reflow
            window.addEventListener("load", () => {
                setTimeout(() => {
                    addJs("js/3rd/xlsx.full.min.js");
                }, 1000);
            });

            this.$bus.$on("togglePromodal", (data, type = 0, page = 1) => {
                this.promodalType = type;
                this.promodalPage = page;
                this.togglePromodal(data);
            });
            this.$bus.$on("toggleFuncVipTip", (data) => {
                this.toggleFuncVipTip(data);
            });
            this.$bus.$on("loginSucc", () => {
                this.updateVipStatus();
            });
            this.$bus.$on("sdkResetEditNumFlag", () => {
                this.editFileNumFlag = false;
            });
        }

        oldData = new Set();
        trackHoverEvent(data) {
            let list = data
                .filter((item) => item != null)
                .map((item) => {
                    return item.itemId;
                });
            let popList = Array.from(this.oldData);
            const trackEvent = (str) => {
                this.sensors.track("echartIActive", {
                    Catalogues: "chart",
                    action_value: str,
                });
            };
            list.forEach((element) => {
                if (!popList.includes(element)) {
                    this.oldData.add(element);
                    trackEvent("popup");
                }
            });
            popList.forEach((element) => {
                if (!list.includes(element)) {
                    this.oldData.delete(element);
                    trackEvent("close");
                }
            });
        }

        beforeDestroy() {
            window.addEventListener("resize", this.checkScale);
            if ($edAuth.off) {
                $edAuth.off("edrawAuthClose", this.edrawAuthClose);
                $edAuth.off("edrawAuthSignup", this.trackSignUp);
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "compressImage": "图片太大。您想要压缩图片吗？",
    "noPastePermission": "请使用快捷键",
    "pasteEndTip": "进行粘贴。",
    "msgContent": "上传失败，请重试",
    "deleteShapeProtect": "请解除锁定删除后再删除形状",
    "saveSuccess": "保存成功",
    "saveFail": "保存失败",
    "versionDes": "描述",
    "noNetworkSave": "保存失败，请检查网络",
    "notCloudFile": "非当前账号文件，请切换至对应账号重试",
    "fileLim": "保存失败，云文档数量超出限制",
    "spaceLim": "保存失败，云空间不足",
    "saveFileReadOnly": "对不起，本次操作失败！您的免费文件数已超出，请升级会员后重新尝试。",
    "saving": "文档正在保存中，请稍后重试",
    "saved": "文档已保存",
    "noVipTip": "非专业版用户导出文件包含水印，是否升级到专业版？",
    "okVip": "升级到专业版",
    "noGoAhead": "继续导出",
    "divixError": "页面缩放比例不正确",
    "divixWarn": "可能会影响某些功能的正常使用",
    "divixHelp": "请尝试调整浏览器缩放比例为100% (快捷键Ctrl + 0)",
    "divixHelp2": "请尝试调整系统显示比例为系统推荐显示比例 (控制面板\\显示 设置)",
    "divixHelp3": "调整后，请保存文件并刷新此页面。（您的文件不会有任何损坏）",
    "confirm": "我知道了",
    "noRemind": "不再提醒",
    "beautify": "去美化思维导图",
    "saveToGoogleSlideSuccess": "保存至Google Slide成功",
    "saveToGoogleSlideFail": "保存失败",
    "editShareConflict": "与文件所有者编辑有冲突，请从分享页面重新进入编辑",
    "editShareNotFound": "该文件已被删除，保存失败",
    "editShareNotAllowed": "暂无编辑权限，仅支持查看",
    "offlineTip": "无网络连接，请检查您的网络",
    "encryptionPasswordError": "密码错误！",
    "flowchartButton": "1.鼠标悬停至浮动按钮即可选择符号连接<br/>2.点击浮动按钮即可快速连接同符号",
    "mindShape": "1.按\\\"Enter\\\"键添加同级主题<br/>2.按\\\"Tab\\\"或\\\"Insert\\\"键添加子级主题",
    "mindTip": "改变边框、颜色、以及布局样式",
    "mindmapTip": "此操作对思维导图不生效。如需美化思维导图，请至【浮动工具栏-美化】中进行相关操作",
    "aiPoint": "AI点数不足，无法执行指令，请先充值后唤醒小助手。",
    "recharge": "去充值",
    "cancel": "取消",
    "swimContainer": "选中后点击右键可添加，删除泳道",
    "smartTip": "调整智能形状样式和布局",
    "orgFloat": "点击浮动按钮添加新成员按\\\"Enter\\\"添加同事<br/>按\\\"Tab/Ins\\\"添加下属",
    "noReplace": "不能修改连接线，组合形状或其他特殊形状",
    "page": "页 ",
    "separatorOnCanvas": "分隔符必须放在要插入的跨功能流程图顶部",
    "correctSeparator": "请使用正确的分隔符",
    "tableError": "若要执行此操作，所有合并单元格需大小相同。",
    "renameFail": "重命名失败，名字不能包含特殊字符(& % $ 😊等)",
    "sameName": "已存在同名文件，请重新命名",
    "remind": "提示",
    "cloudVipSpaceTips": "无法使用此功能，因为可用的云空间不足，请清理后继续使用。",
    "okText": "确定",
    "refreshNow": "立即刷新",
    "scaleRemindText": "缩放时若画布内图形展示异常，请尝试刷新页面",
    "closeRemind":"关闭提示"

  },
  "en": {
    "compressImage": "The image is too large. Do you want to compress it?",
    "noPastePermission": "Please use shortcut key.",
    "pasteEndTip": "To paste.",
    "msgContent": "Upload failed, please try again.",
    "deleteShapeProtect": "Shape protection prevents complete execution of this command.",
    "saveSuccess": "Save Successfully.",
    "saveFail": "Save failed.",
    "versionDes": "Description",
    "noNetworkSave": "Save failed, please check network.",
    "notCloudFile": "Not the current account file, please switch to the corresponding account and try again",
    "fileLim": "Save failed, the number of files exceeds the limit",
    "spaceLim": "Save failed, insufficient cloud space",
    "saveFileReadOnly": "Sorry, failed error! Your free  document count has been exceeded, you can upgrade plan and try again.",
    "saving": "Document is saving, please try again later",
    "saved": "The file has been saved.",
    "noVipTip": "Watermark cannot be removed if you export file with the current version. Do you want to upgrade to the premium version?",
    "okVip": "Upgrade to premium version",
    "noGoAhead": "Continue",
    "divixError": "Page zoom error",
    "divixWarn": "May affect some functionalities",
    "divixHelp": "Please try to adjust the zoom level of browser to 100% (shortcut ctrl + 0)",
    "divixHelp2": "Please adjust the display scale to recommended scale ( windows settings \\ system \\ display )",
    "divixHelp3": "After adjustment, please save the file and reload this page. (Your file will not be damaged)",
    "confirm": "Got it",
    "noRemind": "Don't remind again",
    "beautify": "Beautify now",
    "saveToGoogleSlideSuccess": "Save Success",
    "saveToGoogleSlideFail": "Fail",
    "editShareConflict": "Conflict with file owner edit, reenter from the share page to edit",
    "editShareNotFound": "The document has been deleted, couldn't be saved.",
    "editShareNotAllowed": "Editing is disabled. View only.",
    "offlineTip": "No Internet, please check your network",
    "encryptionPasswordError": "Incorrect Password!",
    "flowchartButton": "1.Hover your mouse cursor here to add flowchart shapes.<br/>2.Cick the floating button to add the same shape.",
    "mindShape": "1.Press \\\"Enter\\\" key to add a topic. <br/>2.Press \\\"Tab\\\" or \\\"Insert\\\" key to add a subtopic.",
    "mindTip": "Change mind map style.",
    "mindmapTip": "This operation doesn't work on mind maps. If you want to retouch a mind map, please select [Floating Toolbar - Beautify].",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Cancel",
    "swimContainer": "You can add or delete the swimlanes with the right click menu.",
    "smartTip": "Change smartshape style here.",
    "orgFloat": "Click the floating button to add a new member.<br/>Press \\\"Enter\\\" key to add a colleague. <br/>Press \\\"Tab\\\" or \\\"Insert\\\" key to add a subordinate.",
    "noReplace": "Could not change connectors, grouped shapes or other special shapes.",
    "page": "Page ",
    "separatorOnCanvas": "A separator must be inserted on top of a cross-functional flowchart",
    "correctSeparator": "Please use the correct separator",
    "tableError": "To do this, all the merged cells need to be the same size.",
    "renameFail": "Rename failed, check if the name contains special character, such as & % $ 😊, etc.",
    "sameName": "A file with the same name already exists. Please rename it.",
    "remind": "Reminder",
    "cloudVipSpaceTips": "This function cannot be used because there is not enough cloud storage available. You can manage your storage in Cloud Documents.",
    "okText": "Confirm",
    "refreshNow": "Refresh",
    "scaleRemindText": "If the graphics in Canvas appear distorted when zooming, try refreshing the page.",
    "closeRemind":"Close"
  },
  "fr": {
    "compressImage": "L'image est trop grande.Voulez-vous compresser l'image?",
    "noPastePermission": "Veuillez utiliser le raccourci.",
    "pasteEndTip": "Coller.",
    "msgContent": "Échec du téléchargement, veuillez réessayer.",
    "deleteShapeProtect": "Veuillez déverrouiller la suppression avant de supprimer la forme.",
    "saveSuccess": "Enregistré avec succès",
    "saveFail": "Échec de l'enregistrement",
    "versionDes": "Description",
    "noNetworkSave": "Échec de l'enregistrement, veuillez vérifier le réseau",
    "notCloudFile": "Il ne s'agit pas du fichier de compte actuel, veuillez passer au compte correspondant et réessayer",
    "fileLim": "Échec de l'enregistrement, le nombre de documents de nuage dépasse la limite",
    "spaceLim": "Échec de l'enregistrement, espace cloud insuffisant",
    "saveFileReadOnly": "Désolé, échec ! Vous avez atteint le nombre maximum de créations gratuites de documents. Vous pouvez effectuer une mise à niveau et réessayer.",
    "saving": "Le document est en cours d'enregistrement, veuillez réessayer plus tard",
    "saved": "Document enregistré",
    "noVipTip": "Les utilisateurs non-Pro à fichier d'exportation contient un filigrane, voulez-vous passer à la version professionnelle?",
    "okVip": "Mettez à niveau à la version Pro",
    "noGoAhead": "Continuer",
    "divixError": "Erreur de zoom de page.",
    "divixWarn": "Peut affecter certaines fonctionnalités",
    "divixHelp": "Veuillez essayer de régler le niveau de zoom du navigateur à 100% (raccourci ctrl + 0)",
    "divixHelp2": "Veuillez essayer d'ajuster le ratio d'affichage du système au ratio d'affichage recommandé (Panneau de configuration \\ Affichage Paramètres)",
    "divixHelp3": "Après les ajustements, enregistrez le fichier et actualisez cette page. (Aucun dommage à vos fichiers)",
    "confirm": "confirmer",
    "noRemind": "Pas de rappel",
    "beautify": "Embellir maintenant",
    "saveToGoogleSlideSuccess": "Enregistrer à google slide avec succès",
    "saveToGoogleSlideFail": "Échec de l'enregistrement",
    "editShareConflict": "Il y a un conflit avec la modification du propriétaire du fichier, veuillez saisir à nouveau la modification à partir de la page de partage",
    "editShareNotFound": "Le document a été supprimé, il n'a pas pu être enregistré.",
    "editShareNotAllowed": "TLa modification est désactivée. Affichage uniquement.",
    "offlineTip": "Pas de connexion Internet, veuillez vérifier votre réseau",
    "encryptionPasswordError": "Mot de passe incorrect!",
    "flowchartButton": "1.Placez le curseur de votre souris ici pour ajouter des formes d'organigramme.<br/>2.Cliquez sur le bouton flottant pour ajouter la même forme.",
    "mindShape": "1.Appuyez sur la touche \\\"Entrée\\\" pour ajouter un sujet.<br/>2.Appuyez sur la touche \\\"Insérer\\\" pour ajouter un sous-thème.",
    "mindTip": "Changer le style de la carte mentale",
    "mindmapTip": "Cette opération ne fonctionne pas sur les cartes heuristiques. Si vous souhaitez modifier une carte heuristique, sélectionnez [Barre d'outils flottante - Embellir].",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Annuler",
    "swimContainer": "Vous pouvez ajouter ou supprimer les couloirs avec le menu contextuel.",
    "smartTip": "Changez le style de smartshape ici.",
    "orgFloat": "Cliquez sur le bouton flottant pour ajouter un nouveau membre.<br/>Appuyez sur la touche \\\"Entrée\\\" pour ajouter un collègue. <br/>Appuyez sur la touche \\\"Insérer\\\" pour ajouter un subordonné.",
    "noReplace": "Impossible de modifier les lignes de connexion, les formes combinées ou d'autres formes spéciales",
    "page": "Page ",
    "separatorOnCanvas": "Le séparateur doit être placé en haut de l'organigramme interfonctionnel à insérer",
    "correctSeparator": "Veuillez utiliser le bon séparateur",
    "tableError": "Pour ce faire, toutes les cellules fusionnées doivent avoir la même taille.",
    "renameFail": "Changement de nom a échoué, vérifier si le nom contient un caractère spécial, tel que &% $ 😊, etc.\"",
    "sameName": "Un fichier du même nom existe déjà, veuillez le renommer",
    "remind": "Rappeler",
    "okText": "Confirmer",
    "refreshNow": "Actualiser",
    "scaleRemindText": "Si les graphiques du canevas apparaissent déformés lors du zoom, actualisez la page.",
    "closeRemind":"Fermer"
  },
  "de": {
    "compressImage": "Das Bild ist zu groß. Möchten Sie es komprimieren?",
    "noPastePermission": "Bitte verwenden Sie die Tastenkombination.",
    "pasteEndTip": "Einfügen",
    "msgContent": "Upload fehlgeschlagen, bitte versuchen Sie es erneut.",
    "deleteShapeProtect": "Der Formschutz verhindert die vollständige Ausführung dieses Befehls.",
    "saveSuccess": "Erfolgreich gespeichert",
    "saveFail": "Speicherung gescheitert",
    "versionDes": "Beschreibung",
    "noNetworkSave": "Speichern fehlgeschlagen, bitte überprüfen Sie den Netzwerk .",
    "notCloudFile": "Nicht die aktuelle Kontodatei, wechseln Sie bitte zum entsprechenden Konto und versuchen Sie es erneut",
    "fileLim": "Speichern fehlgeschlagen, die Anzahl der Dateien überschreitet das Limit",
    "spaceLim": "Speichern fehlgeschlagen, unzureichender Cloud-Speicherplatz",
    "saveFileReadOnly": "Der Vorgang ist leider fehlgeschlagen! Sie haben das Limit für die kostenlose Erstellung von Dokumenten erreicht. Upgraden Sie Ihren Plan und versuchen Sie es erneut.",
    "saving": "Das Dokument wird gespeichert. Bitte versuchen Sie es später erneut",
    "saved": "Datei gespeichert",
    "noVipTip": "Wasserzeichen können nicht entfernt werden, wenn Sie Dateien mit der aktuellen Version exportieren. Möchten Sie auf die Premium-Version upgraden?",
    "okVip": "Upgrade auf Premium-Version",
    "noGoAhead": "Fortfahren",
    "divixError": "Seitenzoomfehler",
    "divixWarn": "Kann einige Funktionen beeinträchtigen",
    "divixHelp": "Bitte versuchen Sie, die Zoomstufe des Browsers auf 100% einzustellen (Tastenkürzel Strg + 0).",
    "divixHelp2": "Bitte stellen Sie die Anzeigeskala auf die empfohlene Skala ein (Windows-Einstellungen \\\\ System \\\\ Anzeige)",
    "divixHelp3": "Speichern Sie nach der Anpassung die Datei und laden Sie diese Seite neu. (Ihre Datei wird nicht beschädigt)",
    "confirm": "Bestätigen",
    "noRemind": "Nicht erinnern",
    "beautify": "Jetzt verschönern",
    "saveToGoogleSlideSuccess": "In Google Slide erfolgreich gespeichert ",
    "saveToGoogleSlideFail": "Gescheitert",
    "editShareConflict": "Konflikt mit der Bearbeitung durch den Dateieigentümer, erneut eingeben von der Freigabeseite zum Bearbeiten",
    "editShareNotFound": "Das Dokument wurde gelöscht, es konnte nicht gespeichert werden.",
    "editShareNotAllowed": "Die Bearbeitung ist deaktiviert. Die Ansicht erfolgt nur schreibgeschützt.",
    "offlineTip": "Kein Internet, bitte überprüfen Sie Ihr Netzwerk",
    "encryptionPasswordError": "Falsches Passwort!",
    "flowchartButton": "1.Bewegen Sie den Mauszeiger hierher, um Flussdiagrammformen hinzuzufügen.<br/>2.Klicken Sie auf die schwebende Schaltfläche, um dieselbe Form hinzuzufügen.",
    "mindShape": "1.Drücken Sie die Eingabetaste, um ein Thema hinzuzufügen.<br/>2.Drücken Sie die Taste \\\"Einfügen\\\", um ein Unterthema hinzuzufügen.",
    "mindTip": "Ändern Sie den Mind-Map-Stil.",
    "mindmapTip": "Dieser Vorgang kann nicht auf Mindmaps angewendet werden. Wenn Sie eine Mindmap bearbeiten möchten, wählen Sie bitte [Schwebende Symbolleiste – Verschönern] aus.",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Abbrechen",
    "swimContainer": "Sie können die Schwimmbahnen mit dem Rechtsklick-Menü hinzufügen oder löschen.",
    "smartTip": "Ändern Sie hier den Smartshape-Stil.",
    "orgFloat": "Klicken Sie auf die schwebende Schaltfläche, um ein neues Mitglied hinzuzufügen.<br/>Drücken Sie die „Einfügen“-Taste, um einen Kollegen hinzuzufügen.",
    "noReplace": "Verbindungslinien, kombinierte Formen oder andere spezielle Formen können nicht geändert werden",
    "page": "Seite ",
    "separatorOnCanvas": "Der Separator muss oben im funktionsübergreifenden Flussdiagramm platziert werden, um eingefügt zu werden",
    "correctSeparator": "Bitte benutzen sie das richtige trennzeichen",
    "tableError": "Dazu müssen alle zu zusammenführenden Zelle die gleiche Größe haben.",
    "renameFail": "Umbenennen fehlgeschlagen, prüfen Sie, ob der Name Sonderzeichen wie &% $ 😊 usw. enthält",
    "sameName": "Eine gleichnamige Datei existiert bereits. Bitte benennen Sie sie um.",
    "remind": "Hinweis",
    "okText": "Sichern",
    "refreshNow": "Aktualisieren",
    "scaleRemindText": "Wenn die Grafiken in Canvas beim Zoomen verzerrt erscheinen, aktualisieren Sie die Seite.",
    "closeRemind":"Schließen"
  },
  "jp": {
    "compressImage": "画像が大きすぎます。圧縮しますか？",
    "noPastePermission": "ショートカットを使用して、",
    "pasteEndTip": "貼り付けてください。",
    "msgContent": "アップロードに失敗しました。再度お試しください",
    "deleteShapeProtect": "図形を削除する前に、削除のロックを解除してください",
    "saveSuccess": "正常に保存されました",
    "saveFail": "保存に失敗しました",
    "versionDes": "説明",
    "noNetworkSave": "保存に失敗しました。ネットワークを確認してもう一度お試しください",
    "notCloudFile": "現在のアカウントファイルではありません。対応するアカウントに切り替えて、もう一度お試しください",
    "fileLim": "クラウドドキュメントの数が制限を超えているため、保存に失敗しました",
    "spaceLim": "クラウドスペースが不足しているため、保存に失敗しました",
    "saveFileReadOnly": "エラーが発生しました。無料で作成できるドキュメント数を超えました。引き続き作成するには、プランをアップグレードしてください。",
    "saving": "ドキュメントを保存しています。しばらくしてから再度お試しください",
    "saved": "ドキュメントが保存されました",
    "noVipTip": "プロ版ではない場合、エクスポートされたファイルには透かしが入ります。プロ版にアップグレードしますか？",
    "okVip": "プロ版にアップグレード",
    "noGoAhead": "エクスポートを続ける",
    "divixError": "ページの表示倍率が正しくありません",
    "divixWarn": "一部の機能の使用に影響を与える可能性があります",
    "divixHelp": "ブラウザの表示倍率を100％に調整してみてください（ショートカットCtrl + 0）",
    "divixHelp2": "システムの表示比率を推奨の表示比率に調整してみてください（コントロールパネル\\ディスプレイ設定）",
    "divixHelp3": "調整後、ファイルを保存し、このページを更新してください。 （ファイルへの損傷なし）",
    "confirm": "はい",
    "noRemind": "再度表示しない",
    "beautify": "今すぐ美化",
    "saveToGoogleSlideSuccess": "Googleスライドに正常に保存しました",
    "saveToGoogleSlideFail": "保存に失敗しました",
    "editShareConflict": "ファイルオーナーの編集と競合しています。共有ページから編集をやり直してください。",
    "editShareNotFound": "ドキュメントは削除されました。保存できませんでした。",
    "editShareNotAllowed": "編集はできません。表示のみが可能です。",
    "offlineTip": "インターネットに接続できません。ネットワークへの接続を確認してください",
    "flowchartButton": "1.ここにマウスカーソルを合わせると、フローチャートの図形が追加されます。<br/>2.フローティングボタンをクリックして、同じ形状を追加します。",
    "mindShape": "1.「Enter」キーを押してトピックを追加します。<br/>2.「挿入」キーを押してサブトピックを追加します。",
    "mindTip": "マインドマップのスタイルを変更する",
    "mindmapTip": "この操作は、マインドマップでは機能しません。マインドマップのレタッチをする場合は、［フローティングツールバー - 美化］を選択してください。",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "キャンセル",
    "swimContainer": "右クリックメニューでスイムレーンを追加または削除できます。",
    "smartTip": "ここでスマートシェイプのスタイルを変更します。",
    "orgFloat": "フローティングボタンをクリックして、新しいメンバーを追加します<br/>「Enter」キーを押して同僚を追加します。<br/>「Tab / Insert」キーを押して、部下を追加します。",
    "noReplace": "接続線、結合形状、またはその他の特殊な形状は変更できません",
    "page": "ページ ",
    "separatorOnCanvas": "セパレータは、挿入するクロスファンクトフロー図の上部に置く必要があります",
    "correctSeparator": "正しいセパレータを使用してください",
    "tableError": "To do this, all the merged cells need to be the same size.",
    "renameFail": "名前が要件を満たしていないため、名前の変更に失敗しました。",
    "sameName": "同じ名前のファイルが既に存在します。名前を変更してください",
    "remind": "通知",
    "okText": "OK",
    "refreshNow": "更新",
    "scaleRemindText": "ズームした時にキャンバスのグラフィックが歪んで表示される場合は、ページを更新してみてください。",
    "closeRemind":"閉じる"
  },
  "es": {
    "compressImage": "La imagen es demasiado grande. ¿Quieres comprimirla?",
    "noPastePermission": "Por favor, use la tecla de acceso directo,",
    "pasteEndTip": "Para pegar.",
    "msgContent": "La carga falló, por favor inténtelo de nuevo,",
    "deleteShapeProtect": "La protección de la forma impide la ejecución completa de este comando.",
    "saveSuccess": "Guardar con éxito.",
    "saveFail": "Guardar fallido.",
    "versionDes": "Descripción",
    "notCloudFile": "No es el archivo de la cuenta actual, cambie a la cuenta correspondiente y vuelva a intentarlo",
    "fileLim": "Guardar fallido, el número de archivos excede el límite",
    "spaceLim": "Guardado fallido, espacio insuficiente en la nube",
    "saveFileReadOnly": "Lo sentimos, ha habido un error. Se ha superado el límite de documentos gratuitos. Puedes actualizar el plan y volver a intentarlo.",
    "saving": "El documento se está guardando, por favor inténtelo de nuevo más tarde.",
    "saved": "El archivo ha sido guardado",
    "noVipTip": " La marca de agua no puede ser eliminada si se exporta el archivo con la versión actual. ¿Quieres actualizar a la versión premium?",
    "okVip": " Actualizar a la versión premium",
    "noGoAhead": " Continuar",
    "divixError": "Error de zoom de página",
    "divixWarn": "Puede afectar algunas funcionalidades",
    "divixHelp": "Por favor, intenta ajustar el nivel de zoom del navegador al 100% (atajo ctrl + 0)",
    "divixHelp2": "Por favor, ajuste la escala de la pantalla a la escala recomendada (configuración de la ventana de visualización del sistema)",
    "divixHelp3": "Después del ajuste, por favor guarde el archivo y recargue esta página. (Su archivo no se dañará)",
    "confirm": "Confirmar",
    "noRemind": "No recordar",
    "beautify": "Embellecer ahora",
    "saveToGoogleSlideSuccess": "Guardar éxitoso",
    "saveToGoogleSlideFail": "Fallo",
    "editShareNotFound": "El documento se ha eliminado, no se ha podido guardar.",
    "editShareNotAllowed": "La edición está desactivada. Solo lectura.",
    "offlineTip": "Sin conexión a internet, por favor, comprueba su red",
    "encryptionPasswordError": "Contraseña incorrecta!",
    "flowchartButton": "1.Mueva el cursor del mouse aquí para agregar formas de diagrama de flujo.<br/>2.Haga clic en el botón flotante para agregar la misma forma.",
    "mindShape": "1.Presione la tecla \\\"Enter\\\" para agregar un tema.<br/>2.Presione la tecla \\\"Insertar\\\" para agregar un subtema.",
    "mindTip": "Cambiar el estilo del mapa mental.",
    "mindmapTip": "Esta operación no funciona en mapas mentales. Si desea retocar un mapa mental, seleccione [Floating Toolbar - Beautify].",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Cancelar",
    "swimContainer": "Puede agregar o eliminar los carriles con el menú contextual.",
    "smartTip": "Cambie el estilo de smartshape aquí.",
    "orgFloat": "Haga clic en el botón flotante para agregar una nueva miembro.<br/>Presiona la tecla \\\"Enter\\\" para agregar un colega.<br/>Presiona la tecla \\\"Insertar\\\" para agregar un subordinado.",
    "noReplace": "No se pueden modificar líneas de conexión, formas combinadas u otras formas especiales",
    "page": "página ",
    "separatorOnCanvas": "El separador debe colocarse en la parte superior del diagrama de flujo multifuncional que se insertará",
    "correctSeparator": "Por favor, utilice el delimitador correcto",
    "tableError": "Para ello, todas las celdas combinadas deben tener el mismo tamaño.",
    "renameFail": "Renombrar el nombre falló, comprueba si el nombre contiene un carácter especial, como & % $ 😊, etc.",
    "sameName": "Ya existe un archivo con el mismo nombre. Por favor, cambie el nombre",
    "remind": "Recordatorio",
    "okText": "OK",
    "refreshNow": "Actualizar",
    "scaleRemindText": "Actualiza la página si los gráficos del lienzo aparecen distorsionados al hacer zoom.",
    "closeRemind":"Cerrar"
  },
  "it": {
    "compressImage": "L'immagine è troppo grande. Desideri comprimerla?",
    "noPastePermission": "Si prega di usare la scorciatoia di tastiera",
    "pasteEndTip": "per copiare.",
    "msgContent": "Caricamento fallito. Si prega di riprovare.",
    "deleteShapeProtect": "La protezione delle forme impedisce l'esecuzione di questo comando.",
    "saveSuccess": "Salvataggio avvenuto con successo.",
    "saveFail": "Salvataggio fallito.",
    "versionDes": "Descrizione",
    "noNetworkSave": "Il salvataggio è fallito. Si prega di controllare la connessione di rete.",
    "notCloudFile": "Non è il file dell'account corrente, passa all'account corrispondente e riprova",
    "fileLim": "Il salvataggio è fallito. Il numero di file ha raggiunto il limite massimo.",
    "spaceLim": "Il salvataggio è fallito. Spazio sul cloud non sufficiente.",
    "saveFileReadOnly": "Spiacenti, si è verificato un errore. Il numero di documenti gratuiti è stato superato, puoi aggiornare il piano e riprovare.",
    "saving": "Salvataggio del documento in corso. Si prega di riprovare.",
    "saved": "Il file è stato salvato.",
    "noVipTip": "Non è possibile rimuovere la filigrana esportando il file con la versione corrente del programma. Desideri eseguire l'upgrade alla versione premium?",
    "okVip": "Esegui l'upgrade alla versione premium.",
    "noGoAhead": "Continua",
    "divixError": "Errore ingrandimento pagina",
    "divixWarn": "Potrebbe influire su alcune funzionalità.",
    "divixHelp": "Si prega di impostare il livello di zoom su 100% (scorciatoia di tastiera: Ctrl + 0).",
    "divixHelp2": "Si prega di impostare la risoluzione dello schermo consigliata (Impostazioni di Windows \\ Sistema \\ Schermo).",
    "divixHelp3": "In seguito alla modifica, si prega di salvare il file e ricaricare questa pagina (il file non sarà compromesso o danneggiato).",
    "confirm": "Conferma",
    "noRemind": "Non ricordarmelo più",
    "beautify": "Abbellisci ora",
    "saveToGoogleSlideSuccess": "Salvataggio avvenuto con successo.",
    "saveToGoogleSlideFail": "Salvataggio fallito.",
    "editShareConflict": "C'è un conflitto con la modifica del proprietario del file, inserisci nuovamente la modifica dalla pagina di condivisione",
    "editShareNotFound": "Il documento è stato eliminato, non può essere salvato.",
    "editShareNotAllowed": "Impossibile apportare modifiche. Solo visualizzazione.",
    "offlineTip": "Nessuna connessione. Si prega di controllare la rete Internet.",
    "encryptionPasswordError": "Password errata!",
    "flowchartButton": "1.Passa qui il cursore del mouse per aggiungere forme del diagramma di flusso.<br/>2.Fai clic sul pulsante mobile per aggiungere la stessa forma.",
    "mindShape": "1.Premi il tasto \\\"Invio\\\" per aggiungere un argomento.<br/>2.Premi il tasto \\\"Inserisci\\\" per aggiungere un sottoargomento.",
    "mindTip": "Cambia lo stile della mappa mentale.",
    "mindmapTip": "Questa operazione non funziona sui diagrammi dei processi mentali. Se desideri ritoccare un diagramma dei processi mentali, seleziona [Barra degli strumenti mobile - Abbellisci].",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Annulla",
    "swimContainer": "È possibile aggiungere o eliminare le swimlanes con il menu di scelta rapida.",
    "smartTip": "Cambia lo stile smartshape qui.",
    "orgFloat": "Fai clic sul pulsante mobile per aggiungere un nuovo membro.<br/>Premere il pulsante \\\"Entrare\\\" per aggiungere un collega.<br/>Premere il pulsante \\\"Tab / Inserisci\\\" per aggiungere un subordinato.",
    "noReplace": "Non è possibile modificare linee di collegamento, forme combinate o altre forme speciali",
    "page": "pagina ",
    "separatorOnCanvas": "Il separatore deve essere posizionato nella parte superiore del diagramma di flusso interfunzionale da inserire",
    "correctSeparator": "Si prega di utilizzare il separatore corretto",
    "tableError": "Per fare ciò, tutte le celle unite devono avere le stesse dimensioni.",
    "renameFail": "Rinominazione fallita. Assicurarsi che il nome non contenga caratteri speciali, quali & % $ 😊, ecc.",
    "sameName": "Esiste già un file con questo nome. Si prega di sceglierne un altro.",
    "remind": "Promemoria",
    "okText": "OK",
    "refreshNow": "Aggiorna",
    "scaleRemindText": "Prova ad aggiornare la pagina se la grafica nell'area di lavoro appare distorta durante lo zoom.",
    "closeRemind":"Chiudi"
  },
  "pt": {
    "compressImage": "A imagem é muito grande. Deseja comprimir a imagem?",
    "noPastePermission": "Por favor, usar a tecla de atalho.",
    "pasteEndTip": "Para colar.",
    "msgContent": "Carregamento falhado, por favor, tentar novamente.",
    "deleteShapeProtect": "A proteção da forma previne a execução completa deste comando.",
    "saveSuccess": "Gravado com Sucesso.",
    "saveFail": "Falha ao gravar.",
    "versionDes": "Descrição",
    "noNetworkSave": "Falha ao gravar, por favor, verificar rede.",
    "notCloudFile": "Não é o arquivo da conta atual, mude para a conta correspondente e tente novamente",
    "fileLim": "Falha ao gravar, o número de ficheiros excede o limite",
    "spaceLim": "Falha ao gravar, espaço insuficiente na cloud",
    "saveFileReadOnly": "Erro de falha! Você atingiu o limite de criação gratuita de documentos. Você pode atualizar o plano e tentar novamente.",
    "saving": "O documento está a ser gravado, por favor, tentar novamente mais tarde",
    "saved": "O ficheiro foi gravado.",
    "noVipTip": "As marcas de água não podem ser removidas ao exportar o ficheiro com a versão atual. Deseja fazer upgrade para a versão premium?",
    "okVip": "Fazer upgrade para a versão premium",
    "noGoAhead": "Continuar",
    "divixError": "Erro no zoom da página",
    "divixWarn": "Pode afetar algumas funcionalidades",
    "divixHelp": "Por favor, tentar ajustar o nível de zoom do browser para 100% (atalho ctrl + 0)",
    "divixHelp2": "Por favor, ajustar a escala de exibição para a escala recomendada ( configurações windows \\ sistema \\ exibição )",
    "divixHelp3": "Depois de ajustar, por favor, gravar o ficheiro e recarregar esta página. (O seu ficheiro não será danificado)",
    "confirm": "Confirmar",
    "noRemind": "Não Lembrar",
    "beautify": "Embelezar agora",
    "saveToGoogleSlideSuccess": "Sucesso ao Gravar",
    "saveToGoogleSlideFail": "Falha",
    "editShareNotFound": "O documento foi excluído e não foi possível salvá-lo.",
    "editShareNotAllowed": "A edição está desativada. Somente exibição.",
    "offlineTip": "Sem Internet, por favor, verificar rede",
    "encryptionPasswordError": "Senha incorreta!",
    "flowchartButton": "1.Passe o cursor do mouse aqui para adicionar formas de fluxograma.<br/>2.Clique no botão flutuante para adicionar a mesma forma.",
    "mindShape": "1.Pressione a tecla \\\"Enter\\\" para adicionar um tópico.<br/>2.Pressione a tecla \\\"Inserir\\\" para adicionar um subtópico.",
    "mindTip": "Mude o estilo do mapa mental aqui.",
    "mindmapTip": "Esta operação não funciona em mapas mentais. Se deseja retocar um mapa mental, selecione [Barra de ferramentas flutuante > Embelezar]",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "Cancelar",
    "swimContainer": "Você pode adicionar ou deletar as swimlanes com o menu do botão direito.",
    "smartTip": "Mude o estilo do smartshape aqui.",
    "orgFloat": "Clique no botão flutuante para adicionar um novo membro.<br/>Pressione a tecla \\\"Enter\\\" para adicionar um colega. <br/>Pressione a tecla \\\"Tab/Insert\\\" para adicionar um subordinado.",
    "noReplace": "Não é possível modificar linhas de conexão, formas combinadas ou outras formas especiais",
    "page": "página ",
    "separatorOnCanvas": "O separador deve ser colocado no topo do fluxograma multifuncional a ser inserido",
    "correctSeparator": "Por favor, use o separador correto",
    "tableError": "Para fazer isso, todas as células mescladas precisam ter o mesmo tamanho.",
    "renameFail": "Falha ao renomear, verificar se o nome contém caracteres especiais, como & % $ 😊, etc.",
    "sameName": "Já existe um ficheiro com o mesmo nome. Por favor renomear o ficheiro.",
    "remind": "Alerta",
    "okText": "OK",
    "refreshNow": "Actualizar",
    "scaleRemindText": "Se os gráficos no Canvas aparecerem distorcidos ao ampliar e encolher, tente atualizar a página.",
    "closeRemind":"Fechar"
  },
  "tw": {
    "compressImage": "圖片太大。您想要壓縮圖片嗎？",
    "noPastePermission": "請使用快速鍵",
    "pasteEndTip": "進行粘上。",
    "msgContent": "上傳失敗，請重試",
    "deleteShapeProtect": "請解除鎖定刪除後在刪除形狀",
    "saveSuccess": "儲存成功",
    "saveFail": "儲存失敗",
    "versionDes": "描述",
    "noNetworkSave": "儲存失敗，請檢查網絡",
    "notCloudFile": "非當前賬號檔案，請切換至對應賬號重試",
    "fileLim": "儲存失敗，雲端硬碟檔案數量超出限制",
    "spaceLim": "儲存失敗，雲端硬碟空間不足",
    "saveFileReadOnly": "Sorry, failed error! Your free  document count has been exceeded, you can upgrade plan and try again.",
    "saving": "檔案正在儲存中，請稍後重試",
    "saved": "檔案已儲存",
    "noVipTip": "非專業版用戶導出檔案含水印，是否升級到專業版？",
    "okVip": "升級到專業版",
    "noGoAhead": "繼續導出",
    "divixError": "頁面縮放比例不正確",
    "divixWarn": "可能會影響某些功能的正常使用",
    "divixHelp": "請嘗試調整瀏覽器縮放比例為100% (快捷鍵Ctrl + 0)",
    "divixHelp2": "請嘗試調整系統顯示比例為系統推薦顯示比例 (控制面板\\顯示 設置)",
    "divixHelp3": "調整後，請儲存檔案並刷新此頁面。（您的檔案不會有任何損壞）",
    "confirm": "我知道了",
    "noRemind": "不再提醒",
    "beautify": "立即美化",
    "saveToGoogleSlideSuccess": "儲存至Google Slide成功",
    "saveToGoogleSlideFail": "儲存失敗",
    "editShareConflict": "与檔案所有者編輯有衝突，請從分享頁面重新進入編輯",
    "editShareNotFound": "The document has been deleted.",
    "editShareNotAllowed": "The editing permission for this file has been revoked. You can only view it.",
    "offlineTip": "舞網絡連接，請檢查您的網絡",
    "flowchartButton": "1.鼠標懸停至浮動按鈕即可選擇符號連接<br/>2.點擊浮動按鈕即可快速連接同符號",
    "mindShape": "1.按Enter鍵添加同級主題<br/>2.按Tab或Insert鍵添加子主題",
    "mindTip": "改變邊框、顏色、以及佈局樣式",
    "mindmapTip": "此操作無法在心智圖上運作。如果您想要修改心智圖，請選取 [浮動工具列 - 美化]。",
    "aiPoint": "AI點數不足，無法執行指令，請先充值後喚醒小助手。",
    "recharge": "去充值",
    "cancel": "取消",
    "swimContainer": "選中後點擊右鍵可添加，刪除泳道",
    "smartTip": "调整智能形状样式和布局",
    "orgFloat": "点击浮动按钮快速添加符号<br/>按「Enter」鍵添加同事。<br/>按「Tab」或「Insert」鍵添加下屬。",
    "noReplace": "不能修改連接線，組合形狀或其他特殊形狀",
    "page": "頁 ",
    "separatorOnCanvas": "分隔符必须放在要插入的交叉功能流程圖顶部",
    "correctSeparator": "請使用正確的分隔符",
    "tableError": "所有合併的單元格必須具有相同的大小。",
    "renameFail": "重命名失敗，名字不能包含特殊字符(& % $ 😊等)",
    "sameName": "已存在同名檔案，請重新命名",
    "remind": "提示",
    "okText": "確定",
    "refreshNow": "重新整理",
    "scaleRemindText": "",
    "closeRemind":""
  },
  "kr": {
    "compressImage": "이미지가 너무 큽니다. 압축하시겠습니까?",
    "noPastePermission": "단축키를 사용하세요",
    "pasteEndTip": "붙여넣기",
    "msgContent": "업로드에 실패했습니다. 다시 시도하세요",
    "deleteShapeProtect": "삭제 잠금을 해제한 후 이미지을 삭제해 주세요",
    "saveSuccess": "저장 성공",
    "saveFail": "저장 실패",
    "versionDes": "설명",
    "noNetworkSave": "저장하지 못했습니다. 네트워크를 확인하세요",
    "notCloudFile": "현재 계정 파일이 아닙니다. 해당 계정으로 전환하고 다시 시도하세요",
    "fileLim": "파일 수가 제한을 초과하여 저장하지 못했습니다",
    "spaceLim": "저장 실패, 클라우드 공간 부족",
    "saveFileReadOnly": "Sorry, failed error! Your free  document count has been exceeded, you can upgrade plan and try again.",
    "saving": "파일를 저장하는 중입니다. 나중에 다시 시도하세요",
    "saved": "파일이 저장되었습니다.",
    "noVipTip": "파일을 현재 버전으로 내보내는 경우 워터마크를 제거할 수 없습니다. 프리미엄 버전으로 업그레이드하시겠습니까?",
    "okVip": "프리미엄 버전으로 업그레이드",
    "noGoAhead": "계속 내보내기",
    "divixError": "페이지 확대/축소 오류",
    "divixWarn": "일부 기능에 영향을 줄 수 있음",
    "divixHelp": "브라우저의 확대/축소 수준을 100%로 조정해 보세요 (단축키 Ctrl + 0)",
    "divixHelp2": "디스플레이 배율을 권장 배율로 조정하세요 (윈도우 설정 \\\\ 시스템 \\\\ 보이기)",
    "divixHelp3": "조정 후 파일을 저장하고 이 페이지를 다시 로드하세요. (파일은 손상되지 않습니다)",
    "confirm": "알겠습니다.",
    "noRemind": "더 이상 알람하지 않기",
    "beautify": "지금 꾸미기",
    "saveToGoogleSlideSuccess": "Google Slide에 저장되었습니다.",
    "saveToGoogleSlideFail": "저장 실패",
    "editShareConflict": "파일 소유자 편집과 충돌합니다. 편집할 공유 페이지에서 다시 입력하세요",
    "editShareNotFound": "The document has been deleted.",
    "editShareNotAllowed": "The editing permission for this file has been revoked. You can only view it.",
    "offlineTip": "인터넷이 없습니다. 네트워크를 확인하세요",
    "flowchartButton": "1.흐름도 모양을 추가하려면 마우스 커서를 여기에 놓으세요.<br/> 2.부동 버튼을 클릭하여 동일한 모양을 추가합니다.",
    "mindShape": "1.항목을 추가하려면 \"Enter\" 키를 누릅니다. <br/> 2.\"삽입\" 키를 눌러 하위 항목을 추가합니다.",
    "mindTip": "마인드맵 스타일 변경",
    "mindmapTip": "마인드 맵에서는 이 작업이 작동하지 않습니다. 마인드 맵을 리터치하려면 [플로팅 툴바 - 꾸미기]를 선택하십시오.",
    "aiPoint": "Insufficient AI points, unable to execute instructions, please recharge first and then wake up the assistant",
    "recharge": "To Recharge",
    "cancel": "취소",
    "swimContainer": "오른쪽 클릭 메뉴를 사용하여 수영란을 추가하거나 삭제할 수 있습니다.",
    "smartTip": "여기서 스마트 모양 스타일 변경",
    "orgFloat": "새 구성원을 추가하려면 부동 단추를 누르세요.",
    "noReplace": "커넥터, 그룹화된 도형 또는 기타 특수 도형을 변경할 수 없습니다",
    "page": "페이지",
    "separatorOnCanvas": "교차 기능 흐름도 상단에 분리기를 삽입해야 합니다.",
    "correctSeparator": "올바른 분리기를 사용하세요.",
    "tableError": "이렇게 하려면 병합된 모든 셀의 크기가 같아야 합니다.",
    "renameFail": "이름을 바꾸지 못했습니다. 이름에 &% $ 😊 등과 같은 특수 문자가 포함되어 있는지 확인하십시오.",
    "sameName": "같은 이름의 파일이 이미 있습니다. 이름을 바꾸십시오.",
    "remind": "알림",
    "okText": "확인",
    "refreshNow": "새로 고침",
    "scaleRemindText": "",
    "closeRemind":""
  }
}
</i18n>
